(() => {
  var e = {
          6509: (e, t) => {
              "use strict";
              Object.defineProperty(t, "__esModule", { value: !0 }),
                  (t.default = [
                      {
                          alpha2: "US",
                          alpha3: "USA",
                          country_code: "1",
                          country_name: "United States",
                          mobile_begin_with: [
                              "201",
                              "202",
                              "203",
                              "205",
                              "206",
                              "207",
                              "208",
                              "209",
                              "210",
                              "212",
                              "213",
                              "214",
                              "215",
                              "216",
                              "217",
                              "218",
                              "219",
                              "220",
                              "223",
                              "224",
                              "225",
                              "227",
                              "228",
                              "229",
                              "231",
                              "234",
                              "239",
                              "240",
                              "248",
                              "251",
                              "252",
                              "253",
                              "254",
                              "256",
                              "260",
                              "262",
                              "267",
                              "269",
                              "270",
                              "272",
                              "274",
                              "276",
                              "278",
                              "281",
                              "283",
                              "301",
                              "302",
                              "303",
                              "304",
                              "305",
                              "307",
                              "308",
                              "309",
                              "310",
                              "312",
                              "313",
                              "314",
                              "315",
                              "316",
                              "317",
                              "318",
                              "319",
                              "320",
                              "321",
                              "323",
                              "325",
                              "327",
                              "330",
                              "331",
                              "332",
                              "334",
                              "336",
                              "337",
                              "339",
                              "341",
                              "346",
                              "347",
                              "351",
                              "352",
                              "360",
                              "361",
                              "364",
                              "369",
                              "380",
                              "385",
                              "386",
                              "401",
                              "402",
                              "404",
                              "405",
                              "406",
                              "407",
                              "408",
                              "409",
                              "410",
                              "412",
                              "413",
                              "414",
                              "415",
                              "417",
                              "419",
                              "423",
                              "424",
                              "425",
                              "430",
                              "432",
                              "434",
                              "435",
                              "440",
                              "441",
                              "442",
                              "443",
                              "445",
                              "447",
                              "458",
                              "463",
                              "464",
                              "469",
                              "470",
                              "475",
                              "478",
                              "479",
                              "480",
                              "484",
                              "501",
                              "502",
                              "503",
                              "504",
                              "505",
                              "507",
                              "508",
                              "509",
                              "510",
                              "512",
                              "513",
                              "515",
                              "516",
                              "517",
                              "518",
                              "520",
                              "530",
                              "531",
                              "534",
                              "539",
                              "540",
                              "541",
                              "551",
                              "557",
                              "559",
                              "561",
                              "562",
                              "563",
                              "564",
                              "567",
                              "570",
                              "571",
                              "572",
                              "573",
                              "574",
                              "575",
                              "580",
                              "582",
                              "585",
                              "586",
                              "601",
                              "602",
                              "603",
                              "605",
                              "606",
                              "607",
                              "608",
                              "609",
                              "610",
                              "612",
                              "614",
                              "615",
                              "616",
                              "617",
                              "618",
                              "619",
                              "620",
                              "623",
                              "626",
                              "627",
                              "628",
                              "629",
                              "630",
                              "631",
                              "636",
                              "640",
                              "641",
                              "646",
                              "650",
                              "651",
                              "656",
                              "657",
                              "659",
                              "660",
                              "661",
                              "662",
                              "667",
                              "669",
                              "678",
                              "679",
                              "680",
                              "681",
                              "682",
                              "689",
                              "701",
                              "702",
                              "703",
                              "704",
                              "706",
                              "707",
                              "708",
                              "712",
                              "713",
                              "714",
                              "715",
                              "716",
                              "717",
                              "718",
                              "719",
                              "720",
                              "724",
                              "725",
                              "726",
                              "727",
                              "730",
                              "731",
                              "732",
                              "734",
                              "737",
                              "740",
                              "743",
                              "747",
                              "752",
                              "754",
                              "757",
                              "760",
                              "762",
                              "763",
                              "764",
                              "765",
                              "769",
                              "770",
                              "771",
                              "772",
                              "773",
                              "774",
                              "775",
                              "779",
                              "781",
                              "785",
                              "786",
                              "787",
                              "801",
                              "802",
                              "803",
                              "804",
                              "805",
                              "806",
                              "808",
                              "810",
                              "812",
                              "813",
                              "814",
                              "815",
                              "816",
                              "817",
                              "818",
                              "820",
                              "828",
                              "830",
                              "831",
                              "832",
                              "835",
                              "838",
                              "840",
                              "843",
                              "845",
                              "847",
                              "848",
                              "850",
                              "854",
                              "856",
                              "857",
                              "858",
                              "859",
                              "860",
                              "862",
                              "863",
                              "864",
                              "865",
                              "870",
                              "872",
                              "878",
                              "901",
                              "903",
                              "904",
                              "906",
                              "907",
                              "908",
                              "909",
                              "910",
                              "912",
                              "913",
                              "914",
                              "915",
                              "916",
                              "917",
                              "918",
                              "919",
                              "920",
                              "925",
                              "927",
                              "928",
                              "929",
                              "930",
                              "931",
                              "934",
                              "935",
                              "936",
                              "937",
                              "938",
                              "939",
                              "940",
                              "941",
                              "945",
                              "947",
                              "949",
                              "951",
                              "952",
                              "954",
                              "956",
                              "957",
                              "959",
                              "970",
                              "971",
                              "972",
                              "973",
                              "975",
                              "978",
                              "979",
                              "980",
                              "984",
                              "985",
                              "986",
                              "989",
                              "888",
                              "800",
                              "833",
                              "844",
                              "855",
                              "866",
                              "877",
                              "279",
                              "340",
                              "983",
                              "448",
                              "943",
                              "363",
                              "326",
                              "839",
                              "826",
                              "948",
                          ],
                          phone_number_lengths: [10],
                      },
                      { alpha2: "AW", alpha3: "ABW", country_code: "297", country_name: "Aruba", mobile_begin_with: ["5", "6", "7", "9"], phone_number_lengths: [7] },
                      { alpha2: "AF", alpha3: "AFG", country_code: "93", country_name: "Afghanistan", mobile_begin_with: ["7"], phone_number_lengths: [9] },
                      { alpha2: "AO", alpha3: "AGO", country_code: "244", country_name: "Angola", mobile_begin_with: ["9"], phone_number_lengths: [9] },
                      { alpha2: "AI", alpha3: "AIA", country_code: "1", country_name: "Anguilla", mobile_begin_with: ["2645", "2647"], phone_number_lengths: [10] },
                      { alpha2: "AX", alpha3: "ALA", country_code: "358", country_name: "Åland Islands", mobile_begin_with: ["18"], phone_number_lengths: [6, 7, 8] },
                      { alpha2: "AL", alpha3: "ALB", country_code: "355", country_name: "Albania", mobile_begin_with: ["6"], phone_number_lengths: [9] },
                      { alpha2: "AD", alpha3: "AND", country_code: "376", country_name: "Andorra", mobile_begin_with: ["3", "4", "6"], phone_number_lengths: [6] },
                      { alpha2: "AE", alpha3: "ARE", country_code: "971", country_name: "United Arab Emirates", mobile_begin_with: ["5"], phone_number_lengths: [9] },
                      { alpha2: "AR", alpha3: "ARG", country_code: "54", country_name: "Argentina", mobile_begin_with: ["1", "2", "3"], phone_number_lengths: [8, 9, 10, 11, 12] },
                      { alpha2: "AM", alpha3: "ARM", country_code: "374", country_name: "Armenia", mobile_begin_with: ["3", "4", "5", "7", "9"], phone_number_lengths: [8] },
                      { alpha2: "AS", alpha3: "ASM", country_code: "1", country_name: "American Samoa", mobile_begin_with: ["684733", "684258"], phone_number_lengths: [10] },
                      { alpha2: "AG", alpha3: "ATG", country_code: "1", country_name: "Antigua and Barbuda", mobile_begin_with: ["2687"], phone_number_lengths: [10] },
                      { alpha2: "AU", alpha3: "AUS", country_code: "61", country_name: "Australia", mobile_begin_with: ["4"], phone_number_lengths: [9] },
                      { alpha2: "AT", alpha3: "AUT", country_code: "43", country_name: "Austria", mobile_begin_with: ["6"], phone_number_lengths: [10, 11, 12, 13, 14] },
                      { alpha2: "AZ", alpha3: "AZE", country_code: "994", country_name: "Azerbaijan", mobile_begin_with: ["4", "5", "6", "7"], phone_number_lengths: [9] },
                      { alpha2: "BI", alpha3: "BDI", country_code: "257", country_name: "Burundi", mobile_begin_with: ["7", "29"], phone_number_lengths: [8] },
                      { alpha2: "BE", alpha3: "BEL", country_code: "32", country_name: "Belgium", mobile_begin_with: ["4", "3"], phone_number_lengths: [9, 8] },
                      { alpha2: "BJ", alpha3: "BEN", country_code: "229", country_name: "Benin", mobile_begin_with: ["4", "6", "9"], phone_number_lengths: [8] },
                      { alpha2: "BF", alpha3: "BFA", country_code: "226", country_name: "Burkina Faso", mobile_begin_with: ["6", "7"], phone_number_lengths: [8] },
                      { alpha2: "BD", alpha3: "BGD", country_code: "880", country_name: "Bangladesh", mobile_begin_with: ["1"], phone_number_lengths: [8, 9, 10] },
                      { alpha2: "BG", alpha3: "BGR", country_code: "359", country_name: "Bulgaria", mobile_begin_with: ["87", "88", "89", "98", "99", "43"], phone_number_lengths: [8, 9] },
                      { alpha2: "BH", alpha3: "BHR", country_code: "973", country_name: "Bahrain", mobile_begin_with: ["3"], phone_number_lengths: [8] },
                      { alpha2: "BS", alpha3: "BHS", country_code: "1", country_name: "Bahamas", mobile_begin_with: ["242"], phone_number_lengths: [10] },
                      { alpha2: "BA", alpha3: "BIH", country_code: "387", country_name: "Bosnia and Herzegovina", mobile_begin_with: ["6"], phone_number_lengths: [8] },
                      { alpha2: "BY", alpha3: "BLR", country_code: "375", country_name: "Belarus", mobile_begin_with: ["25", "29", "33", "44"], phone_number_lengths: [9] },
                      { alpha2: "BZ", alpha3: "BLZ", country_code: "501", country_name: "Belize", mobile_begin_with: ["6"], phone_number_lengths: [7] },
                      { alpha2: "BM", alpha3: "BMU", country_code: "1", country_name: "Bermuda", mobile_begin_with: ["4413", "4415", "4417"], phone_number_lengths: [10] },
                      { alpha2: "BO", alpha3: "BOL", country_code: "591", country_name: "Bolivia", mobile_begin_with: ["6", "7"], phone_number_lengths: [8] },
                      {
                          alpha2: "BR",
                          alpha3: "BRA",
                          country_code: "55",
                          country_name: "Brazil",
                          mobile_begin_with: [
                              "119",
                              "129",
                              "139",
                              "149",
                              "159",
                              "169",
                              "179",
                              "189",
                              "199",
                              "219",
                              "229",
                              "249",
                              "279",
                              "289",
                              "319",
                              "329",
                              "339",
                              "349",
                              "359",
                              "379",
                              "389",
                              "419",
                              "429",
                              "439",
                              "449",
                              "459",
                              "469",
                              "479",
                              "489",
                              "499",
                              "519",
                              "539",
                              "549",
                              "559",
                              "619",
                              "629",
                              "639",
                              "649",
                              "659",
                              "669",
                              "679",
                              "689",
                              "699",
                              "719",
                              "739",
                              "749",
                              "759",
                              "779",
                              "799",
                              "819",
                              "829",
                              "839",
                              "849",
                              "859",
                              "869",
                              "879",
                              "889",
                              "899",
                              "919",
                              "929",
                              "939",
                              "949",
                              "959",
                              "969",
                              "979",
                              "989",
                              "999",
                          ],
                          phone_number_lengths: [10, 11],
                      },
                      { alpha2: "BB", alpha3: "BRB", country_code: "1", country_name: "Barbados", mobile_begin_with: ["246"], phone_number_lengths: [10] },
                      { alpha2: "BN", alpha3: "BRN", country_code: "673", country_name: "Brunei Darussalam", mobile_begin_with: ["7", "8"], phone_number_lengths: [7] },
                      { alpha2: "BT", alpha3: "BTN", country_code: "975", country_name: "Bhutan", mobile_begin_with: ["17"], phone_number_lengths: [8] },
                      { alpha2: "BW", alpha3: "BWA", country_code: "267", country_name: "Botswana", mobile_begin_with: ["71", "72", "73", "74", "75", "76"], phone_number_lengths: [8] },
                      { alpha2: "CF", alpha3: "CAF", country_code: "236", country_name: "Central African Republic", mobile_begin_with: ["7"], phone_number_lengths: [8] },
                      {
                          alpha2: "CA",
                          alpha3: "CAN",
                          country_code: "1",
                          country_name: "Canada",
                          mobile_begin_with: [
                              "204",
                              "226",
                              "236",
                              "249",
                              "250",
                              "263",
                              "289",
                              "306",
                              "343",
                              "354",
                              "365",
                              "367",
                              "368",
                              "403",
                              "416",
                              "418",
                              "431",
                              "437",
                              "438",
                              "450",
                              "468",
                              "474",
                              "506",
                              "514",
                              "519",
                              "548",
                              "579",
                              "581",
                              "584",
                              "587",
                              "600",
                              "604",
                              "613",
                              "639",
                              "647",
                              "672",
                              "683",
                              "705",
                              "709",
                              "742",
                              "753",
                              "778",
                              "780",
                              "782",
                              "807",
                              "819",
                              "825",
                              "867",
                              "873",
                              "902",
                              "905",
                              "428",
                              "382",
                          ],
                          phone_number_lengths: [10],
                      },
                      { alpha2: "CH", alpha3: "CHE", country_code: "41", country_name: "Switzerland", mobile_begin_with: ["74", "75", "76", "77", "78", "79"], phone_number_lengths: [9] },
                      { alpha2: "CL", alpha3: "CHL", country_code: "56", country_name: "Chile", mobile_begin_with: ["9"], phone_number_lengths: [9] },
                      { alpha2: "CN", alpha3: "CHN", country_code: "86", country_name: "China", mobile_begin_with: ["13", "14", "15", "17", "18", "19", "16"], phone_number_lengths: [11] },
                      { alpha2: "CI", alpha3: "CIV", country_code: "225", country_name: "Côte D'Ivoire", mobile_begin_with: ["0", "4", "5", "6", "7", "8"], phone_number_lengths: [10] },
                      { alpha2: "CM", alpha3: "CMR", country_code: "237", country_name: "Cameroon", mobile_begin_with: ["6"], phone_number_lengths: [9] },
                      { alpha2: "CD", alpha3: "COD", country_code: "243", country_name: "Congo, The Democratic Republic Of The", mobile_begin_with: ["8", "9"], phone_number_lengths: [9] },
                      { alpha2: "CG", alpha3: "COG", country_code: "242", country_name: "Congo", mobile_begin_with: ["0"], phone_number_lengths: [9] },
                      { alpha2: "CK", alpha3: "COK", country_code: "682", country_name: "Cook Islands", mobile_begin_with: ["5", "7"], phone_number_lengths: [5] },
                      { alpha2: "CO", alpha3: "COL", country_code: "57", country_name: "Colombia", mobile_begin_with: ["3"], phone_number_lengths: [10] },
                      { alpha2: "CW", alpha3: "CUW", country_code: "5999", country_name: "Curaçao", mobile_begin_with: ["5", "6"], phone_number_lengths: [7] },
                      { alpha2: "KM", alpha3: "COM", country_code: "269", country_name: "Comoros", mobile_begin_with: ["3", "76"], phone_number_lengths: [7] },
                      { alpha2: "CV", alpha3: "CPV", country_code: "238", country_name: "Cape Verde", mobile_begin_with: ["5", "9"], phone_number_lengths: [7] },
                      { alpha2: "CR", alpha3: "CRI", country_code: "506", country_name: "Costa Rica", mobile_begin_with: ["5", "6", "7", "8"], phone_number_lengths: [8] },
                      { alpha2: "CU", alpha3: "CUB", country_code: "53", country_name: "Cuba", mobile_begin_with: ["5"], phone_number_lengths: [8] },
                      { alpha2: "KY", alpha3: "CYM", country_code: "1", country_name: "Cayman Islands", mobile_begin_with: ["345"], phone_number_lengths: [10] },
                      { alpha2: "CY", alpha3: "CYP", country_code: "357", country_name: "Cyprus", mobile_begin_with: ["9"], phone_number_lengths: [8] },
                      { alpha2: "CZ", alpha3: "CZE", country_code: "420", country_name: "Czech Republic", mobile_begin_with: ["6", "7"], phone_number_lengths: [9] },
                      { alpha2: "DE", alpha3: "DEU", country_code: "49", country_name: "Germany", mobile_begin_with: ["15", "16", "17"], phone_number_lengths: [10, 11] },
                      { alpha2: "DJ", alpha3: "DJI", country_code: "253", country_name: "Djibouti", mobile_begin_with: ["77"], phone_number_lengths: [8] },
                      { alpha2: "DM", alpha3: "DMA", country_code: "1", country_name: "Dominica", mobile_begin_with: ["767"], phone_number_lengths: [10] },
                      {
                          alpha2: "DK",
                          alpha3: "DNK",
                          country_code: "45",
                          country_name: "Denmark",
                          mobile_begin_with: ["2", "30", "31", "40", "41", "42", "50", "51", "52", "53", "60", "61", "71", "81", "91", "92", "93"],
                          phone_number_lengths: [8],
                      },
                      { alpha2: "DO", alpha3: "DOM", country_code: "1", country_name: "Dominican Republic", mobile_begin_with: ["809", "829", "849"], phone_number_lengths: [10] },
                      { alpha2: "DZ", alpha3: "DZA", country_code: "213", country_name: "Algeria", mobile_begin_with: ["5", "6", "7"], phone_number_lengths: [9] },
                      { alpha2: "EC", alpha3: "ECU", country_code: "593", country_name: "Ecuador", mobile_begin_with: ["9"], phone_number_lengths: [9] },
                      { alpha2: "EG", alpha3: "EGY", country_code: "20", country_name: "Egypt", mobile_begin_with: ["1"], phone_number_lengths: [10, 8] },
                      { alpha2: "ER", alpha3: "ERI", country_code: "291", country_name: "Eritrea", mobile_begin_with: ["1", "7", "8"], phone_number_lengths: [7] },
                      { alpha2: "ES", alpha3: "ESP", country_code: "34", country_name: "Spain", mobile_begin_with: ["6", "7"], phone_number_lengths: [9] },
                      { alpha2: "EE", alpha3: "EST", country_code: "372", country_name: "Estonia", mobile_begin_with: ["5", "81", "82", "83"], phone_number_lengths: [7, 8] },
                      { alpha2: "ET", alpha3: "ETH", country_code: "251", country_name: "Ethiopia", mobile_begin_with: ["9"], phone_number_lengths: [9] },
                      { alpha2: "FI", alpha3: "FIN", country_code: "358", country_name: "Finland", mobile_begin_with: ["4", "5"], phone_number_lengths: [9, 10] },
                      { alpha2: "FJ", alpha3: "FJI", country_code: "679", country_name: "Fiji", mobile_begin_with: ["2", "7", "8", "9"], phone_number_lengths: [7] },
                      { alpha2: "FK", alpha3: "FLK", country_code: "500", country_name: "Falkland Islands (Malvinas)", mobile_begin_with: ["5", "6"], phone_number_lengths: [5] },
                      { alpha2: "FR", alpha3: "FRA", country_code: "33", country_name: "France", mobile_begin_with: ["6", "7"], phone_number_lengths: [9] },
                      { alpha2: "FO", alpha3: "FRO", country_code: "298", country_name: "Faroe Islands", mobile_begin_with: [], phone_number_lengths: [6] },
                      { alpha2: "FM", alpha3: "FSM", country_code: "691", country_name: "Micronesia, Federated States Of", mobile_begin_with: [], phone_number_lengths: [7] },
                      { alpha2: "GA", alpha3: "GAB", country_code: "241", country_name: "Gabon", mobile_begin_with: ["2", "3", "4", "5", "6", "7"], phone_number_lengths: [7] },
                      { alpha2: "GB", alpha3: "GBR", country_code: "44", country_name: "United Kingdom", mobile_begin_with: ["7"], phone_number_lengths: [10] },
                      { alpha2: "GE", alpha3: "GEO", country_code: "995", country_name: "Georgia", mobile_begin_with: ["5", "7"], phone_number_lengths: [9] },
                      { alpha2: "GH", alpha3: "GHA", country_code: "233", country_name: "Ghana", mobile_begin_with: ["2", "5"], phone_number_lengths: [9] },
                      { alpha2: "GI", alpha3: "GIB", country_code: "350", country_name: "Gibraltar", mobile_begin_with: ["5"], phone_number_lengths: [8] },
                      { alpha2: "GN", alpha3: "GIN", country_code: "224", country_name: "Guinea", mobile_begin_with: ["6"], phone_number_lengths: [9] },
                      { alpha2: "GP", alpha3: "GLP", country_code: "590", country_name: "Guadeloupe", mobile_begin_with: ["690"], phone_number_lengths: [9] },
                      { alpha2: "GM", alpha3: "GMB", country_code: "220", country_name: "Gambia", mobile_begin_with: ["7", "9"], phone_number_lengths: [7] },
                      { alpha2: "GW", alpha3: "GNB", country_code: "245", country_name: "Guinea-Bissau", mobile_begin_with: ["5", "6", "7"], phone_number_lengths: [7] },
                      { alpha2: "GQ", alpha3: "GNQ", country_code: "240", country_name: "Equatorial Guinea", mobile_begin_with: ["222", "551"], phone_number_lengths: [9] },
                      { alpha2: "GR", alpha3: "GRC", country_code: "30", country_name: "Greece", mobile_begin_with: ["6"], phone_number_lengths: [10] },
                      { alpha2: "GD", alpha3: "GRD", country_code: "1", country_name: "Grenada", mobile_begin_with: ["473"], phone_number_lengths: [10] },
                      { alpha2: "GL", alpha3: "GRL", country_code: "299", country_name: "Greenland", mobile_begin_with: ["2", "4", "5"], phone_number_lengths: [6] },
                      { alpha2: "GT", alpha3: "GTM", country_code: "502", country_name: "Guatemala", mobile_begin_with: ["3", "4", "5"], phone_number_lengths: [8] },
                      { alpha2: "GF", alpha3: "GUF", country_code: "594", country_name: "French Guiana", mobile_begin_with: ["694"], phone_number_lengths: [9] },
                      { alpha2: "GU", alpha3: "GUM", country_code: "1", country_name: "Guam", mobile_begin_with: ["671"], phone_number_lengths: [10] },
                      { alpha2: "GY", alpha3: "GUY", country_code: "592", country_name: "Guyana", mobile_begin_with: ["6"], phone_number_lengths: [7] },
                      {
                          alpha2: "HK",
                          alpha3: "HKG",
                          country_code: "852",
                          country_name: "Hong Kong",
                          mobile_begin_with: ["4", "5", "6", "70", "71", "72", "73", "81", "82", "83", "84", "85", "86", "87", "88", "89", "9"],
                          phone_number_lengths: [8],
                      },
                      { alpha2: "HN", alpha3: "HND", country_code: "504", country_name: "Honduras", mobile_begin_with: ["3", "7", "8", "9"], phone_number_lengths: [8] },
                      { alpha2: "HR", alpha3: "HRV", country_code: "385", country_name: "Croatia", mobile_begin_with: ["9"], phone_number_lengths: [8, 9] },
                      { alpha2: "HT", alpha3: "HTI", country_code: "509", country_name: "Haiti", mobile_begin_with: ["3", "4"], phone_number_lengths: [8] },
                      { alpha2: "HU", alpha3: "HUN", country_code: "36", country_name: "Hungary", mobile_begin_with: ["20", "30", "31", "50", "70"], phone_number_lengths: [9] },
                      { alpha2: "ID", alpha3: "IDN", country_code: "62", country_name: "Indonesia", mobile_begin_with: ["8"], phone_number_lengths: [9, 10, 11, 12] },
                      { alpha2: "IN", alpha3: "IND", country_code: "91", country_name: "India", mobile_begin_with: ["6", "7", "8", "9"], phone_number_lengths: [10] },
                      { alpha2: "IE", alpha3: "IRL", country_code: "353", country_name: "Ireland", mobile_begin_with: ["82", "83", "84", "85", "86", "87", "88", "89"], phone_number_lengths: [9] },
                      { alpha2: "IR", alpha3: "IRN", country_code: "98", country_name: "Iran, Islamic Republic Of", mobile_begin_with: ["9"], phone_number_lengths: [10] },
                      { alpha2: "IQ", alpha3: "IRQ", country_code: "964", country_name: "Iraq", mobile_begin_with: ["7"], phone_number_lengths: [10] },
                      { alpha2: "IS", alpha3: "ISL", country_code: "354", country_name: "Iceland", mobile_begin_with: ["6", "7", "8"], phone_number_lengths: [7] },
                      { alpha2: "IL", alpha3: "ISR", country_code: "972", country_name: "Israel", mobile_begin_with: ["5"], phone_number_lengths: [9] },
                      { alpha2: "IT", alpha3: "ITA", country_code: "39", country_name: "Italy", mobile_begin_with: ["3"], phone_number_lengths: [9, 10] },
                      { alpha2: "JM", alpha3: "JAM", country_code: "1", country_name: "Jamaica", mobile_begin_with: ["876"], phone_number_lengths: [10] },
                      { alpha2: "JO", alpha3: "JOR", country_code: "962", country_name: "Jordan", mobile_begin_with: ["7"], phone_number_lengths: [9] },
                      { alpha2: "JP", alpha3: "JPN", country_code: "81", country_name: "Japan", mobile_begin_with: ["70", "80", "90"], phone_number_lengths: [10] },
                      { alpha2: "KZ", alpha3: "KAZ", country_code: "7", country_name: "Kazakhstan", mobile_begin_with: ["70", "74", "77"], phone_number_lengths: [10] },
                      { alpha2: "KE", alpha3: "KEN", country_code: "254", country_name: "Kenya", mobile_begin_with: ["7", "1"], phone_number_lengths: [9] },
                      { alpha2: "KG", alpha3: "KGZ", country_code: "996", country_name: "Kyrgyzstan", mobile_begin_with: ["5", "7", "8", "9"], phone_number_lengths: [9] },
                      { alpha2: "KH", alpha3: "KHM", country_code: "855", country_name: "Cambodia", mobile_begin_with: ["1", "6", "7", "8", "9"], phone_number_lengths: [8, 9] },
                      { alpha2: "KI", alpha3: "KIR", country_code: "686", country_name: "Kiribati", mobile_begin_with: ["9", "30"], phone_number_lengths: [5] },
                      { alpha2: "KN", alpha3: "KNA", country_code: "1", country_name: "Saint Kitts And Nevis", mobile_begin_with: ["869"], phone_number_lengths: [10] },
                      { alpha2: "KR", alpha3: "KOR", country_code: "82", country_name: "Korea, Republic of", mobile_begin_with: ["1"], phone_number_lengths: [9, 10] },
                      { alpha2: "KW", alpha3: "KWT", country_code: "965", country_name: "Kuwait", mobile_begin_with: ["5", "6", "9"], phone_number_lengths: [8] },
                      { alpha2: "LA", alpha3: "LAO", country_code: "856", country_name: "Lao People's Democratic Republic", mobile_begin_with: ["20"], phone_number_lengths: [10] },
                      { alpha2: "LB", alpha3: "LBN", country_code: "961", country_name: "Lebanon", mobile_begin_with: ["3", "7", "8"], phone_number_lengths: [7, 8] },
                      { alpha2: "LR", alpha3: "LBR", country_code: "231", country_name: "Liberia", mobile_begin_with: ["4", "5", "6", "7"], phone_number_lengths: [7, 8] },
                      { alpha2: "LY", alpha3: "LBY", country_code: "218", country_name: "Libyan Arab Jamahiriya", mobile_begin_with: ["9"], phone_number_lengths: [9] },
                      { alpha2: "LC", alpha3: "LCA", country_code: "1", country_name: "Saint Lucia", mobile_begin_with: ["758"], phone_number_lengths: [10] },
                      { alpha2: "LI", alpha3: "LIE", country_code: "423", country_name: "Liechtenstein", mobile_begin_with: ["7"], phone_number_lengths: [7] },
                      { alpha2: "LK", alpha3: "LKA", country_code: "94", country_name: "Sri Lanka", mobile_begin_with: ["7"], phone_number_lengths: [9] },
                      { alpha2: "LS", alpha3: "LSO", country_code: "266", country_name: "Lesotho", mobile_begin_with: ["5", "6"], phone_number_lengths: [8] },
                      { alpha2: "LT", alpha3: "LTU", country_code: "370", country_name: "Lithuania", mobile_begin_with: ["6"], phone_number_lengths: [8] },
                      { alpha2: "LU", alpha3: "LUX", country_code: "352", country_name: "Luxembourg", mobile_begin_with: ["6"], phone_number_lengths: [9] },
                      { alpha2: "LV", alpha3: "LVA", country_code: "371", country_name: "Latvia", mobile_begin_with: ["2"], phone_number_lengths: [8] },
                      { alpha2: "MO", alpha3: "MAC", country_code: "853", country_name: "Macao", mobile_begin_with: ["6"], phone_number_lengths: [8] },
                      { alpha2: "MA", alpha3: "MAR", country_code: "212", country_name: "Morocco", mobile_begin_with: ["6", "7"], phone_number_lengths: [9] },
                      { alpha2: "MC", alpha3: "MCO", country_code: "377", country_name: "Monaco", mobile_begin_with: ["4", "6"], phone_number_lengths: [8, 9] },
                      { alpha2: "MD", alpha3: "MDA", country_code: "373", country_name: "Moldova, Republic of", mobile_begin_with: ["6", "7"], phone_number_lengths: [8] },
                      { alpha2: "MG", alpha3: "MDG", country_code: "261", country_name: "Madagascar", mobile_begin_with: ["3"], phone_number_lengths: [9] },
                      { alpha2: "MV", alpha3: "MDV", country_code: "960", country_name: "Maldives", mobile_begin_with: ["7", "9"], phone_number_lengths: [7] },
                      { alpha2: "MX", alpha3: "MEX", country_code: "52", country_name: "Mexico", mobile_begin_with: [""], phone_number_lengths: [10, 11] },
                      { alpha2: "MH", alpha3: "MHL", country_code: "692", country_name: "Marshall Islands", mobile_begin_with: [], phone_number_lengths: [7] },
                      { alpha2: "MK", alpha3: "MKD", country_code: "389", country_name: "Macedonia, the Former Yugoslav Republic Of", mobile_begin_with: ["7"], phone_number_lengths: [8] },
                      { alpha2: "ML", alpha3: "MLI", country_code: "223", country_name: "Mali", mobile_begin_with: ["6", "7"], phone_number_lengths: [8] },
                      { alpha2: "MT", alpha3: "MLT", country_code: "356", country_name: "Malta", mobile_begin_with: ["7", "9"], phone_number_lengths: [8] },
                      { alpha2: "MM", alpha3: "MMR", country_code: "95", country_name: "Myanmar", mobile_begin_with: ["9"], phone_number_lengths: [8, 9, 10] },
                      { alpha2: "ME", alpha3: "MNE", country_code: "382", country_name: "Montenegro", mobile_begin_with: ["6"], phone_number_lengths: [8] },
                      { alpha2: "MN", alpha3: "MNG", country_code: "976", country_name: "Mongolia", mobile_begin_with: ["5", "8", "9"], phone_number_lengths: [8] },
                      { alpha2: "MP", alpha3: "MNP", country_code: "1", country_name: "Northern Mariana Islands", mobile_begin_with: ["670"], phone_number_lengths: [10] },
                      { alpha2: "MZ", alpha3: "MOZ", country_code: "258", country_name: "Mozambique", mobile_begin_with: ["8"], phone_number_lengths: [9] },
                      { alpha2: "MR", alpha3: "MRT", country_code: "222", country_name: "Mauritania", mobile_begin_with: [], phone_number_lengths: [8] },
                      { alpha2: "MS", alpha3: "MSR", country_code: "1", country_name: "Montserrat", mobile_begin_with: ["664"], phone_number_lengths: [10] },
                      { alpha2: "MQ", alpha3: "MTQ", country_code: "596", country_name: "Martinique", mobile_begin_with: ["696"], phone_number_lengths: [9] },
                      { alpha2: "MU", alpha3: "MUS", country_code: "230", country_name: "Mauritius", mobile_begin_with: ["5"], phone_number_lengths: [8] },
                      { alpha2: "MW", alpha3: "MWI", country_code: "265", country_name: "Malawi", mobile_begin_with: ["77", "88", "99"], phone_number_lengths: [9] },
                      { alpha2: "MY", alpha3: "MYS", country_code: "60", country_name: "Malaysia", mobile_begin_with: ["1", "6"], phone_number_lengths: [9, 10, 8] },
                      { alpha2: "YT", alpha3: "MYT", country_code: "262", country_name: "Mayotte", mobile_begin_with: ["639"], phone_number_lengths: [9] },
                      { alpha2: "NA", alpha3: "NAM", country_code: "264", country_name: "Namibia", mobile_begin_with: ["60", "81", "82", "85"], phone_number_lengths: [9] },
                      { alpha2: "NC", alpha3: "NCL", country_code: "687", country_name: "New Caledonia", mobile_begin_with: ["7", "8", "9"], phone_number_lengths: [6] },
                      { alpha2: "NE", alpha3: "NER", country_code: "227", country_name: "Niger", mobile_begin_with: ["9"], phone_number_lengths: [8] },
                      { alpha2: "NF", alpha3: "NFK", country_code: "672", country_name: "Norfolk Island", mobile_begin_with: ["5", "8"], phone_number_lengths: [5] },
                      { alpha2: "NG", alpha3: "NGA", country_code: "234", country_name: "Nigeria", mobile_begin_with: ["70", "80", "81", "90", "91"], phone_number_lengths: [10] },
                      { alpha2: "NI", alpha3: "NIC", country_code: "505", country_name: "Nicaragua", mobile_begin_with: ["8"], phone_number_lengths: [8] },
                      { alpha2: "NU", alpha3: "NIU", country_code: "683", country_name: "Niue", mobile_begin_with: [], phone_number_lengths: [4] },
                      { alpha2: "NL", alpha3: "NLD", country_code: "31", country_name: "Netherlands", mobile_begin_with: ["6"], phone_number_lengths: [9] },
                      { alpha2: "NO", alpha3: "NOR", country_code: "47", country_name: "Norway", mobile_begin_with: ["4", "9"], phone_number_lengths: [8] },
                      { alpha2: "NP", alpha3: "NPL", country_code: "977", country_name: "Nepal", mobile_begin_with: ["97", "98"], phone_number_lengths: [10] },
                      { alpha2: "NR", alpha3: "NRU", country_code: "674", country_name: "Nauru", mobile_begin_with: ["555"], phone_number_lengths: [7] },
                      { alpha2: "NZ", alpha3: "NZL", country_code: "64", country_name: "New Zealand", mobile_begin_with: ["2"], phone_number_lengths: [8, 9, 10] },
                      { alpha2: "OM", alpha3: "OMN", country_code: "968", country_name: "Oman", mobile_begin_with: ["9"], phone_number_lengths: [8] },
                      { alpha2: "PK", alpha3: "PAK", country_code: "92", country_name: "Pakistan", mobile_begin_with: ["3"], phone_number_lengths: [10] },
                      { alpha2: "PA", alpha3: "PAN", country_code: "507", country_name: "Panama", mobile_begin_with: ["6"], phone_number_lengths: [8] },
                      { alpha2: "PE", alpha3: "PER", country_code: "51", country_name: "Peru", mobile_begin_with: ["9"], phone_number_lengths: [9] },
                      { alpha2: "PH", alpha3: "PHL", country_code: "63", country_name: "Philippines", mobile_begin_with: ["9"], phone_number_lengths: [10] },
                      { alpha2: "PW", alpha3: "PLW", country_code: "680", country_name: "Palau", mobile_begin_with: [], phone_number_lengths: [7] },
                      { alpha2: "PG", alpha3: "PNG", country_code: "675", country_name: "Papua New Guinea", mobile_begin_with: ["7"], phone_number_lengths: [8] },
                      { alpha2: "PL", alpha3: "POL", country_code: "48", country_name: "Poland", mobile_begin_with: ["4", "5", "6", "7", "8"], phone_number_lengths: [9] },
                      { alpha2: "PR", alpha3: "PRI", country_code: "1", country_name: "Puerto Rico", mobile_begin_with: ["787", "939"], phone_number_lengths: [10] },
                      { alpha2: "PT", alpha3: "PRT", country_code: "351", country_name: "Portugal", mobile_begin_with: ["9"], phone_number_lengths: [9] },
                      { alpha2: "PY", alpha3: "PRY", country_code: "595", country_name: "Paraguay", mobile_begin_with: ["9"], phone_number_lengths: [9] },
                      { alpha2: "PS", alpha3: "PSE", country_code: "970", country_name: "Palestinian Territory, Occupied", mobile_begin_with: ["5"], phone_number_lengths: [9] },
                      { alpha2: "PF", alpha3: "PYF", country_code: "689", country_name: "French Polynesia", mobile_begin_with: ["8"], phone_number_lengths: [8] },
                      { alpha2: "QA", alpha3: "QAT", country_code: "974", country_name: "Qatar", mobile_begin_with: ["3", "5", "6", "7"], phone_number_lengths: [8] },
                      { alpha2: "RE", alpha3: "REU", country_code: "262", country_name: "Réunion", mobile_begin_with: ["692", "693"], phone_number_lengths: [9] },
                      { alpha2: "RO", alpha3: "ROU", country_code: "40", country_name: "Romania", mobile_begin_with: ["7"], phone_number_lengths: [9] },
                      { alpha2: "RU", alpha3: "RUS", country_code: "7", country_name: "Russian Federation", mobile_begin_with: ["9", "495", "498", "499", "835"], phone_number_lengths: [10] },
                      { alpha2: "RW", alpha3: "RWA", country_code: "250", country_name: "Rwanda", mobile_begin_with: ["7"], phone_number_lengths: [9] },
                      { alpha2: "SA", alpha3: "SAU", country_code: "966", country_name: "Saudi Arabia", mobile_begin_with: ["5"], phone_number_lengths: [9] },
                      { alpha2: "SD", alpha3: "SDN", country_code: "249", country_name: "Sudan", mobile_begin_with: ["9"], phone_number_lengths: [9] },
                      { alpha2: "SS", alpha3: "SSD", country_code: "211", country_name: "South Sudan", mobile_begin_with: ["9"], phone_number_lengths: [9] },
                      { alpha2: "SN", alpha3: "SEN", country_code: "221", country_name: "Senegal", mobile_begin_with: ["7"], phone_number_lengths: [9] },
                      { alpha2: "SG", alpha3: "SGP", country_code: "65", country_name: "Singapore", mobile_begin_with: ["8", "9"], phone_number_lengths: [8] },
                      { alpha2: "SH", alpha3: "SHN", country_code: "290", country_name: "Saint Helena", mobile_begin_with: [], phone_number_lengths: [4] },
                      { alpha2: "SJ", alpha3: "SJM", country_code: "47", country_name: "Svalbard And Jan Mayen", mobile_begin_with: ["79"], phone_number_lengths: [8] },
                      { alpha2: "SB", alpha3: "SLB", country_code: "677", country_name: "Solomon Islands", mobile_begin_with: ["7", "8"], phone_number_lengths: [7] },
                      { alpha2: "SL", alpha3: "SLE", country_code: "232", country_name: "Sierra Leone", mobile_begin_with: ["21", "25", "30", "33", "34", "40", "44", "50", "55", "76", "77", "78", "79", "88"], phone_number_lengths: [8] },
                      { alpha2: "SV", alpha3: "SLV", country_code: "503", country_name: "El Salvador", mobile_begin_with: ["7"], phone_number_lengths: [8] },
                      { alpha2: "SM", alpha3: "SMR", country_code: "378", country_name: "San Marino", mobile_begin_with: ["3", "6"], phone_number_lengths: [10] },
                      { alpha2: "SO", alpha3: "SOM", country_code: "252", country_name: "Somalia", mobile_begin_with: ["61", "62", "63", "65", "66", "68", "69", "71", "90"], phone_number_lengths: [9] },
                      { alpha2: "SX", alpha3: "SXM", country_code: "1", country_name: "Sint Maarten", mobile_begin_with: ["721"], phone_number_lengths: [10] },
                      { alpha2: "PM", alpha3: "SPM", country_code: "508", country_name: "Saint Pierre And Miquelon", mobile_begin_with: ["55", "41"], phone_number_lengths: [6] },
                      { alpha2: "RS", alpha3: "SRB", country_code: "381", country_name: "Serbia", mobile_begin_with: ["6"], phone_number_lengths: [8, 9] },
                      { alpha2: "ST", alpha3: "STP", country_code: "239", country_name: "Sao Tome and Principe", mobile_begin_with: ["98", "99"], phone_number_lengths: [7] },
                      { alpha2: "SR", alpha3: "SUR", country_code: "597", country_name: "Suriname", mobile_begin_with: ["6", "7", "8"], phone_number_lengths: [7] },
                      { alpha2: "SK", alpha3: "SVK", country_code: "421", country_name: "Slovakia", mobile_begin_with: ["9"], phone_number_lengths: [9] },
                      { alpha2: "SI", alpha3: "SVN", country_code: "386", country_name: "Slovenia", mobile_begin_with: ["3", "4", "5", "6", "7"], phone_number_lengths: [8] },
                      { alpha2: "SE", alpha3: "SWE", country_code: "46", country_name: "Sweden", mobile_begin_with: ["7"], phone_number_lengths: [9] },
                      { alpha2: "SC", alpha3: "SYC", country_code: "248", country_name: "Seychelles", mobile_begin_with: ["2"], phone_number_lengths: [7] },
                      { alpha2: "SY", alpha3: "SYR", country_code: "963", country_name: "Syrian Arab Republic", mobile_begin_with: ["9"], phone_number_lengths: [9] },
                      { alpha2: "TC", alpha3: "TCA", country_code: "1", country_name: "Turks and Caicos Islands", mobile_begin_with: ["6492", "6493", "6494"], phone_number_lengths: [10] },
                      { alpha2: "TD", alpha3: "TCD", country_code: "235", country_name: "Chad", mobile_begin_with: ["6", "7", "9"], phone_number_lengths: [8] },
                      { alpha2: "TG", alpha3: "TGO", country_code: "228", country_name: "Togo", mobile_begin_with: ["9"], phone_number_lengths: [8] },
                      { alpha2: "TH", alpha3: "THA", country_code: "66", country_name: "Thailand", mobile_begin_with: ["6", "8", "9"], phone_number_lengths: [9] },
                      { alpha2: "TJ", alpha3: "TJK", country_code: "992", country_name: "Tajikistan", mobile_begin_with: ["9"], phone_number_lengths: [9] },
                      { alpha2: "TK", alpha3: "TKL", country_code: "690", country_name: "Tokelau", mobile_begin_with: [], phone_number_lengths: [4] },
                      { alpha2: "TM", alpha3: "TKM", country_code: "993", country_name: "Turkmenistan", mobile_begin_with: ["6"], phone_number_lengths: [8] },
                      { alpha2: "TL", alpha3: "TLS", country_code: "670", country_name: "Timor-Leste", mobile_begin_with: ["7"], phone_number_lengths: [8] },
                      { alpha2: "TO", alpha3: "TON", country_code: "676", country_name: "Tonga", mobile_begin_with: [], phone_number_lengths: [5] },
                      { alpha2: "TT", alpha3: "TTO", country_code: "1", country_name: "Trinidad and Tobago", mobile_begin_with: ["868"], phone_number_lengths: [10] },
                      { alpha2: "TN", alpha3: "TUN", country_code: "216", country_name: "Tunisia", mobile_begin_with: ["2", "4", "5", "9"], phone_number_lengths: [8] },
                      { alpha2: "TR", alpha3: "TUR", country_code: "90", country_name: "Turkey", mobile_begin_with: ["5"], phone_number_lengths: [10] },
                      { alpha2: "TV", alpha3: "TUV", country_code: "688", country_name: "Tuvalu", mobile_begin_with: [], phone_number_lengths: [5] },
                      { alpha2: "TW", alpha3: "TWN", country_code: "886", country_name: "Taiwan", mobile_begin_with: ["9"], phone_number_lengths: [9] },
                      { alpha2: "TZ", alpha3: "TZA", country_code: "255", country_name: "Tanzania, United Republic of", mobile_begin_with: ["7", "6"], phone_number_lengths: [9] },
                      { alpha2: "UG", alpha3: "UGA", country_code: "256", country_name: "Uganda", mobile_begin_with: ["7"], phone_number_lengths: [9] },
                      { alpha2: "UA", alpha3: "UKR", country_code: "380", country_name: "Ukraine", mobile_begin_with: ["39", "50", "63", "66", "67", "68", "73", "9"], phone_number_lengths: [9] },
                      { alpha2: "UY", alpha3: "URY", country_code: "598", country_name: "Uruguay", mobile_begin_with: ["9"], phone_number_lengths: [8] },
                      { alpha2: "UZ", alpha3: "UZB", country_code: "998", country_name: "Uzbekistan", mobile_begin_with: ["9", "88", "33"], phone_number_lengths: [9] },
                      { alpha2: "VC", alpha3: "VCT", country_code: "1", country_name: "Saint Vincent And The Grenedines", mobile_begin_with: ["784"], phone_number_lengths: [10] },
                      { alpha2: "VE", alpha3: "VEN", country_code: "58", country_name: "Venezuela, Bolivarian Republic of", mobile_begin_with: ["4"], phone_number_lengths: [10] },
                      { alpha2: "VG", alpha3: "VGB", country_code: "1", country_name: "Virgin Islands, British", mobile_begin_with: ["284"], phone_number_lengths: [10] },
                      { alpha2: "VI", alpha3: "VIR", country_code: "1", country_name: "Virgin Islands, U.S.", mobile_begin_with: ["340"], phone_number_lengths: [10] },
                      { alpha2: "VN", alpha3: "VNM", country_code: "84", country_name: "Viet Nam", mobile_begin_with: ["8", "9", "3", "7", "5"], phone_number_lengths: [9] },
                      { alpha2: "VU", alpha3: "VUT", country_code: "678", country_name: "Vanuatu", mobile_begin_with: ["5", "7"], phone_number_lengths: [7] },
                      { alpha2: "WF", alpha3: "WLF", country_code: "681", country_name: "Wallis and Futuna", mobile_begin_with: [], phone_number_lengths: [6] },
                      { alpha2: "WS", alpha3: "WSM", country_code: "685", country_name: "Samoa", mobile_begin_with: ["7"], phone_number_lengths: [7] },
                      { alpha2: "YE", alpha3: "YEM", country_code: "967", country_name: "Yemen", mobile_begin_with: ["7"], phone_number_lengths: [9] },
                      { alpha2: "ZA", alpha3: "ZAF", country_code: "27", country_name: "South Africa", mobile_begin_with: ["1", "2", "3", "4", "5", "6", "7", "8"], phone_number_lengths: [9] },
                      { alpha2: "ZM", alpha3: "ZMB", country_code: "260", country_name: "Zambia", mobile_begin_with: ["9", "7"], phone_number_lengths: [9] },
                      { alpha2: "ZW", alpha3: "ZWE", country_code: "263", country_name: "Zimbabwe", mobile_begin_with: ["71", "73", "77", "78"], phone_number_lengths: [9] },
                  ]);
          },
          7382: function (e, t, a) {
              "use strict";
              var i =
                  (this && this.__importDefault) ||
                  function (e) {
                      return e && e.__esModule ? e : { default: e };
                  };
              Object.defineProperty(t, "__esModule", { value: !0 }), (t.countryPhoneData = t.phone = void 0);
              const r = i(a(6509));
              t.countryPhoneData = r.default;
              const u = a(3391);
              function n(e, { country: t = "", validateMobilePrefix: a = !0, strictDetection: i = !1 } = {}) {
                  const r = { isValid: !1, phoneNumber: null, countryIso2: null, countryIso3: null, countryCode: null };
                  let n = "string" != typeof e ? "" : e.trim();
                  const o = "string" != typeof t ? "" : t.trim(),
                      l = Boolean(n.match(/^\+/));
                  n = n.replace(/\D/g, "");
                  let s = (0, u.findCountryPhoneDataByCountry)(o);
                  if (!s) return r;
                  let b = !1;
                  if (o)
                      ["CIV", "COG"].includes(s.alpha3) || (n = n.replace(/^0+/, "")),
                          "RUS" === s.alpha3 && 11 === n.length && null !== n.match(/^89/) && (n = n.replace(/^8+/, "")),
                          !l && s.phone_number_lengths.includes(n.length) && (n = `${s.country_code}${n}`);
                  else if (l) {
                      const { exactCountryPhoneData: e, possibleCountryPhoneData: t } = (0, u.findCountryPhoneDataByPhoneNumber)(n, a);
                      e ? (s = e) : t && !i ? ((s = t), (n = s.country_code + n.replace(new RegExp(`^${s.country_code}\\d`), ""))) : (s = null);
                  } else -1 !== s.phone_number_lengths.indexOf(n.length) && ((n = `1${n}`), (b = !0));
                  if (!s) return r;
                  let m = (0, u.validatePhoneISO3166)(n, s, a, l);
                  return m || (b && ((s = (0, u.findCountryPhoneDataByCountry)("CAN")), (m = (0, u.validatePhoneISO3166)(n, s, a, l)), m))
                      ? { isValid: !0, phoneNumber: `+${n}`, countryIso2: s.alpha2, countryIso3: s.alpha3, countryCode: `+${s.country_code}` }
                      : r;
              }
              (t.default = n), (t.phone = n);
          },
          3391: function (e, t, a) {
              "use strict";
              var i =
                  (this && this.__importDefault) ||
                  function (e) {
                      return e && e.__esModule ? e : { default: e };
                  };
              Object.defineProperty(t, "__esModule", { value: !0 }), (t.validatePhoneISO3166 = t.findCountryPhoneDataByPhoneNumber = t.findPossibleCountryPhoneData = t.findExactCountryPhoneData = t.findCountryPhoneDataByCountry = void 0);
              const r = i(a(6509));
              function u(e, t, a) {
                  return a.phone_number_lengths.some((t) => a.country_code.length + t === e.length)
                      ? a.mobile_begin_with.length && t
                          ? a.mobile_begin_with.some((t) => e.match(new RegExp("^" + a.country_code + t)))
                              ? a
                              : null
                          : a
                      : null;
              }
              function n(e, t, a) {
                  return a.phone_number_lengths.some((t) => a.country_code.length + t + 1 === e.length)
                      ? a.mobile_begin_with.length && t
                          ? a.mobile_begin_with.some((t) => e.match(new RegExp("^" + a.country_code + "\\d?" + t)))
                              ? a
                              : void 0
                          : a
                      : null;
              }
              (t.findCountryPhoneDataByCountry = function (e) {
                  return e
                      ? 2 === e.length
                          ? r.default.find((t) => e.toUpperCase() === t.alpha2) || null
                          : 3 === e.length
                          ? r.default.find((t) => e.toUpperCase() === t.alpha3) || null
                          : r.default.find((t) => e.toUpperCase() === t.country_name.toUpperCase()) || null
                      : r.default.find((e) => "USA" === e.alpha3) || null;
              }),
                  (t.findExactCountryPhoneData = u),
                  (t.findPossibleCountryPhoneData = n),
                  (t.findCountryPhoneDataByPhoneNumber = function (e, t) {
                      let a, i;
                      for (const o of r.default) e.match(new RegExp("^" + o.country_code)) && (a || (a = u(e, t, o)), i || (i = n(e, t, o)));
                      return { exactCountryPhoneData: a, possibleCountryPhoneData: i };
                  }),
                  (t.validatePhoneISO3166 = function (e, t, a, i) {
                      if (!t.phone_number_lengths) return !1;
                      const r = e.replace(new RegExp("^" + t.country_code), "");
                      if (i && t && r.length === e.length) return !1;
                      const u = t.phone_number_lengths,
                          n = t.mobile_begin_with,
                          o = u.some((e) => r.length === e),
                          l = !n.length || n.some((e) => r.match(new RegExp("^" + e)));
                      return o && (!a || l);
                  });
          },
          6601: (e) => {
              function t(e, t) {
                  (this.onResolvedAll = t), (this.onFailedOne = e), (this.resolvers = {}), (this.resolversCount = 0), (this.passed = []), (this.failed = []), (this.firing = !1);
              }
              (t.prototype = {
                  add: function (e) {
                      var t = this.resolversCount;
                      return (this.resolvers[t] = e), this.resolversCount++, t;
                  },
                  resolve: function (e) {
                      var t = this.resolvers[e];
                      !0 === t.passes ? this.passed.push(t) : !1 === t.passes && (this.failed.push(t), this.onFailedOne(t)), this.fire();
                  },
                  isAllResolved: function () {
                      return this.passed.length + this.failed.length === this.resolversCount;
                  },
                  fire: function () {
                      this.firing && this.isAllResolved() && this.onResolvedAll(0 === this.failed.length);
                  },
                  enableFiring: function () {
                      this.firing = !0;
                  },
              }),
                  (e.exports = t);
          },
          6319: (e) => {
              e.exports = {
                  replacements: {
                      between: function (e, t) {
                          var a = t.getParameters();
                          return this._replacePlaceholders(t, e, { min: a[0], max: a[1] });
                      },
                      digits_between: function (e, t) {
                          var a = t.getParameters();
                          return this._replacePlaceholders(t, e, { min: a[0], max: a[1] });
                      },
                      required_if: function (e, t) {
                          var a = t.getParameters();
                          return this._replacePlaceholders(t, e, { other: this._getAttributeName(a[0]), value: a[1] });
                      },
                      required_unless: function (e, t) {
                          var a = t.getParameters();
                          return this._replacePlaceholders(t, e, { other: this._getAttributeName(a[0]), value: a[1] });
                      },
                      required_with: function (e, t) {
                          var a = t.getParameters();
                          return this._replacePlaceholders(t, e, { field: this._getAttributeName(a[0]) });
                      },
                      required_with_all: function (e, t) {
                          var a = t.getParameters(),
                              i = this._getAttributeName.bind(this);
                          return this._replacePlaceholders(t, e, { fields: a.map(i).join(", ") });
                      },
                      required_without: function (e, t) {
                          var a = t.getParameters();
                          return this._replacePlaceholders(t, e, { field: this._getAttributeName(a[0]) });
                      },
                      required_without_all: function (e, t) {
                          var a = t.getParameters(),
                              i = this._getAttributeName.bind(this);
                          return this._replacePlaceholders(t, e, { fields: a.map(i).join(", ") });
                      },
                      after: function (e, t) {
                          var a = t.getParameters();
                          return this._replacePlaceholders(t, e, { after: this._getAttributeName(a[0]) });
                      },
                      before: function (e, t) {
                          var a = t.getParameters();
                          return this._replacePlaceholders(t, e, { before: this._getAttributeName(a[0]) });
                      },
                      after_or_equal: function (e, t) {
                          var a = t.getParameters();
                          return this._replacePlaceholders(t, e, { after_or_equal: this._getAttributeName(a[0]) });
                      },
                      before_or_equal: function (e, t) {
                          var a = t.getParameters();
                          return this._replacePlaceholders(t, e, { before_or_equal: this._getAttributeName(a[0]) });
                      },
                      same: function (e, t) {
                          var a = t.getParameters();
                          return this._replacePlaceholders(t, e, { same: this._getAttributeName(a[0]) });
                      },
                  },
                  formatter: function (e) {
                      return e.replace(/[_\[]/g, " ").replace(/]/g, "");
                  },
              };
          },
          3995: (e) => {
              var t = function () {
                  this.errors = {};
              };
              (t.prototype = {
                  constructor: t,
                  add: function (e, t) {
                      this.has(e) || (this.errors[e] = []), -1 === this.errors[e].indexOf(t) && this.errors[e].push(t);
                  },
                  get: function (e) {
                      return this.has(e) ? this.errors[e] : [];
                  },
                  first: function (e) {
                      return !!this.has(e) && this.errors[e][0];
                  },
                  all: function () {
                      return this.errors;
                  },
                  has: function (e) {
                      return !!this.errors.hasOwnProperty(e);
                  },
              }),
                  (e.exports = t);
          },
          8972: (e, t, a) => {
              var i = a(3367);
              a(437);
              var r = {
                  messages: {},
                  _set: function (e, t) {
                      this.messages[e] = t;
                  },
                  _setRuleMessage: function (e, t, a) {
                      this._load(e), void 0 === a && (a = this.messages[e].def), (this.messages[e][t] = a);
                  },
                  _load: function (e) {
                      if (!this.messages[e])
                          try {
                              var t = a(2060)("./" + e);
                              this._set(e, t);
                          } catch (e) {}
                  },
                  _get: function (e) {
                      return this._load(e), this.messages[e];
                  },
                  _make: function (e) {
                      return this._load(e), new i(e, this.messages[e]);
                  },
              };
              e.exports = r;
          },
          8528: (e) => {
              e.exports = {
                  accepted: "الصفة :attribute يجب أن تكون مقبولة",
                  after: "الصفة :attribute يجب أن تكون بعد الصفة :after.",
                  after_or_equal: "الصفة :attribute يجب أن تكون مساوية أو بعد الصفة :after_or_equal.",
                  alpha: "حقل الصفة  :attribute يجب أن تحتوي على أحرف فقط",
                  alpha_dash: "حقل الصفة :attribute مسموح بأن يحتوي على حروف و أرقام و شرطة و شرطة منخفضة",
                  alpha_num: "حقل الصفة :attribute يجب أن يحتوي على أحرف و أرقام",
                  before: "الصفة :attribute يجب أن تكون قبل :before.",
                  before_or_equal: "الصفة :attribute يجب أن تكون مساوية أو قبل الصفة :before_or_equal.",
                  between: "حقل الصفة :attribute يجب أن يكون بين :min و :max.",
                  confirmed: "تأكيد الصفة :attribute غير متطابق.",
                  email: "الصفة :attribute صيغتها غير صحيحة",
                  date: "الصفة :attribute صيغتها ليست تاريخ صحيح",
                  def: "الصفة :attribute تحتوي على أخطاء",
                  digits: "الصفة :attribute يجب أن تكون :digits أرقام.",
                  digits_between: "يجب أن يحتوي :attribute بين :min و :max رقمًا/أرقام .",
                  different: "الصفة :attribute و الصفة :different يجب أن تكونا مختلفتين",
                  in: "الصفة :attribute المختارة، غير صحيحة.",
                  integer: "الصفة :attribute يجب أن تكون عدد صحيح",
                  hex: "حقل الصفة :attribute يجب أن يحتوي على صيغة هكسيديسمل",
                  min: { numeric: "الصفة :attribute يجب أن تكون :min على الأقل", string: "الصفة :attribute يجب أن تكون :min حرف على الأقل." },
                  max: { numeric: "الصفة :attribute لا يمكن أن تكون أكبر من  :max.", string: "الصفة :attribute يجب أن لا تكون أكثر من :max حرف." },
                  not_in: "الصفة :attribute المختارة غير صحيحة.",
                  numeric: "الصفة :attribute يجب أن تكون رقما.",
                  present: "حقل الصفة :attribute يجب أن يكون معرفا ، يمكن أن يكون فارغا.",
                  required: "حقل الصفة :attribute مطلوب.",
                  required_if: "حقل الصفة :attribute مطلوب حين تكون قيمة الحقل :other تساوي :value.",
                  required_unless: "حقل الصفة :attribute مطلوب حين تكون قيم الحقل :other لا تساوي :value.",
                  required_with: "حقل الصفة :attribute مطلوب حين يكون الحقا :field غير فارغ.",
                  required_with_all: "حقل الصفة :attribute مطلوب حين تكون الحقول :fields غير فارغة.",
                  required_without: "حقل الصفة :attribute مطلوب حين يكون الحقل :field فارغا.",
                  required_without_all: "حقل الصفة :attribute مطلوب حين تكون الحقول :fields فارغة.",
                  same: "حقل الصفة :attribute و حقل الصفة :same يجب أن يتطابقا.",
                  size: { numeric: "الصفة :attribute يجب أن تكون :size.", string: "الصفة :attribute يجب أن تكون :size حرفا." },
                  string: "الصفة :attribute يجب أن تكون نص.",
                  url: "الصفة :attribute صياغتها غير صحيحة.",
                  regex: "الصفة :attribute صياغتها غير صحيحة.",
                  attributes: {
                      username: "اسم المستخدم",
                      password: "كلمة المرور",
                      email: "البريد الالكتروني",
                      website: "الموقع الالكتروني",
                      firstname: "الاسم الاول",
                      lastname: "الاسم الاخير",
                      subject: "الموضوع",
                      city: "المدينة",
                      region: "المنطقة",
                      country: "الدولة",
                      street: "الشارع",
                      zipcode: "الرمز البريدي",
                      phone: "رقم الهاتف",
                      mobile: "رقم الجوال",
                  },
              };
          },
          8173: (e) => {
              e.exports = {
                  accepted: ":attribute qəbul edilməlidir",
                  active_url: ":attribute doğru URL deyil",
                  after: ":attribute :date tarixindən sonra olmalıdır",
                  after_or_equal: ":attribute :date tarixi ilə eyni və ya sonra olmalıdır",
                  alpha: ":attribute yalnız hərflərdən ibarət ola bilər",
                  alpha_dash: ":attribute yalnız hərf, rəqəm və tire simvolundan ibarət ola bilər",
                  alpha_num: ":attribute yalnız hərf və rəqəmlərdən ibarət ola bilər",
                  array: ":attribute massiv formatında olmalıdır",
                  before: ":attribute :date tarixindən əvvəl olmalıdır",
                  before_or_equal: ":attribute :date tarixindən əvvəl və ya bərabər olmalıdır",
                  between: {
                      numeric: ":attribute :min ilə :max arasında olmalıdır",
                      file: ":attribute :min ilə :max KB ölçüsü intervalında olmalıdır",
                      string: ":attribute :min ilə :max simvolu intervalında olmalıdır",
                      array: ":attribute :min ilə :max intervalında hissədən ibarət olmalıdır",
                  },
                  boolean: " :attribute doğru və ya yanlış ola bilər",
                  confirmed: " :attribute doğrulanması yanlışdır",
                  date: " :attribute tarix formatında olmalıdır",
                  date_format: " :attribute :format formatında olmalıdır",
                  different: " :attribute və :other fərqli olmalıdır",
                  digits: " :attribute :digits rəqəmli olmalıdır",
                  digits_between: " :attribute :min ilə :max rəqəmləri intervalında olmalıdır",
                  dimensions: " :attribute doğru şəkil ölçülərində deyil",
                  distinct: " :attribute dublikat qiymətlidir",
                  email: " :attribute doğru email formatında deyil",
                  exists: " seçilmiş :attribute yanlışdır",
                  file: " :attribute fayl formatında olmalıdır",
                  filled: " :attribute qiyməti olmalıdır",
                  gt: {
                      numeric: "The :attribute must be greater than :value.",
                      file: "The :attribute must be greater than :value kilobytes.",
                      string: "The :attribute must be greater than :value characters.",
                      array: "The :attribute must have more than :value items.",
                  },
                  gte: {
                      numeric: "The :attribute must be greater than or equal :value.",
                      file: "The :attribute must be greater than or equal :value kilobytes.",
                      string: "The :attribute must be greater than or equal :value characters.",
                      array: "The :attribute must have :value items or more.",
                  },
                  image: " :attribute şəkil formatında olmalıdır",
                  in: " seçilmiş :attribute yanlışdır",
                  in_array: " :attribute :other qiymətləri arasında olmalıdır",
                  integer: " :attribute tam ədəd olmalıdır",
                  hex: "The :attribute field should have hexadecimal format",
                  ip: " :attribute İP adres formatında olmalıdır",
                  ipv4: " :attribute İPv4 adres formatında olmalıdır",
                  ipv6: " :attribute İPv6 adres formatında olmalıdır",
                  json: " :attribute JSON formatında olmalıdır",
                  lt: {
                      numeric: "The :attribute must be less than :value.",
                      file: "The :attribute must be less than :value kilobytes.",
                      string: "The :attribute must be less than :value characters.",
                      array: "The :attribute must have less than :value items.",
                  },
                  lte: {
                      numeric: "The :attribute must be less than or equal :value.",
                      file: "The :attribute must be less than or equal :value kilobytes.",
                      string: "The :attribute must be less than or equal :value characters.",
                      array: "The :attribute must not have more than :value items.",
                  },
                  max: {
                      numeric: " :attribute maksiumum :max rəqəmdən ibarət ola bilər",
                      file: " :attribute maksimum :max KB ölçüsündə ola bilər",
                      string: " :attribute maksimum :max simvoldan ibarət ola bilər",
                      array: " :attribute maksimum :max hədd'dən ibarət ola bilər",
                  },
                  mimes: " :attribute :values tipində fayl olmalıdır",
                  mimetypes: " :attribute :values tipində fayl olmalıdır",
                  min: {
                      numeric: " :attribute minimum :min rəqəmdən ibarət ola bilər",
                      file: " :attribute minimum :min KB ölçüsündə ola bilər",
                      string: " :attribute minimum :min simvoldan ibarət ola bilər",
                      array: " :attribute minimum :min hədd'dən ibarət ola bilər",
                  },
                  not_in: " seçilmiş :attribute yanlışdır",
                  numeric: " :attribute rəqəmlərdən ibarət olmalıdır",
                  present: " :attribute iştirak etməlidir",
                  regex: " :attribute formatı yanlışdır",
                  required: " :attribute mütləqdir",
                  required_if: " :attribute (:other :value ikən) mütləqdir",
                  required_unless: " :attribute (:other :values 'ə daxil ikən) mütləqdir",
                  required_with: " :attribute (:values var ikən) mütləqdir",
                  required_with_all: " :attribute (:values var ikən) mütləqdir",
                  required_without: " :attribute (:values yox ikən) mütləqdir",
                  required_without_all: " :attribute (:values yox ikən) mütləqdir",
                  same: " :attribute və :other eyni olmalıdır",
                  size: { numeric: " :attribute :size ölçüsündə olmalıdır", file: " :attribute :size KB ölçüsündə olmalıdır", string: " :attribute :size simvoldan ibarət olmalıdır", array: " :attribute :size hədd'dən ibarət olmalıdır" },
                  string: " :attribute hərf formatında olmalıdır",
                  timezone: " :attribute ərazi formatında olmalıdır",
                  unique: " :attribute artıq iştirak edib",
                  uploaded: " :attribute yüklənməsi mümkün olmadı",
                  url: " :attribute formatı yanlışdır",
              };
          },
          7931: (e) => {
              e.exports = {
                  accepted: "Вы павінны прыняць :attribute.",
                  active_url: "Поле :attribute утрымлівае несапраўдны URL.",
                  after: "У полі :attribute павінна быць дата пасля :date.",
                  after_or_equal: "The :attribute must be a date after or equal to :date.",
                  alpha: "Поле :attribute можа мець толькі літары.",
                  alpha_dash: "Поле :attribute можа мець толькі літары, лічбы і злучок.",
                  alpha_num: "Поле :attribute можа мець толькі літары і лічбы.",
                  array: "Поле :attribute павінна быць масівам.",
                  before: "У полі :attribute павінна быць дата да :date.",
                  before_or_equal: "The :attribute must be a date before or equal to :date.",
                  between: {
                      numeric: "Поле :attribute павінна быць паміж :min і :max.",
                      file: "Памер файла ў поле :attribute павінен быць паміж :min і :max кілабайт.",
                      string: "Колькасць сiмвалаў у поле :attribute павінна быць паміж :min і :max.",
                      array: "Колькасць элементаў у поле :attribute павінна быць паміж :min і :max.",
                  },
                  boolean: "Поле :attribute павінна мець значэнне лагічнага тыпу.",
                  confirmed: "Поле :attribute не супадае з пацвярджэннем.",
                  date: "Поле :attribute не з'яўляецца датай.",
                  date_format: "Поле :attribute не адпавядае фармату :format.",
                  different: "Палі :attribute і :other павінны адрознівацца.",
                  digits: "Даўжыня лічбавага поля :attribute павінна быць :digits.",
                  digits_between: "Даўжыня лічбавага поля :attribute павінна быць паміж :min і :max.",
                  dimensions: "The :attribute has invalid image dimensions.",
                  distinct: "The :attribute field has a duplicate value.",
                  email: "Поле :attribute павінна быць сапраўдным электронным адрасам.",
                  file: "The :attribute must be a file.",
                  filled: "Поле :attribute абавязкова для запаўнення.",
                  exists: "Выбранае значэнне для :attribute некарэктна.",
                  gt: {
                      numeric: "The :attribute must be greater than :value.",
                      file: "The :attribute must be greater than :value kilobytes.",
                      string: "The :attribute must be greater than :value characters.",
                      array: "The :attribute must have more than :value items.",
                  },
                  gte: {
                      numeric: "The :attribute must be greater than or equal :value.",
                      file: "The :attribute must be greater than or equal :value kilobytes.",
                      string: "The :attribute must be greater than or equal :value characters.",
                      array: "The :attribute must have :value items or more.",
                  },
                  hex: "The :attribute field should have hexadecimal format",
                  image: "Поле :attribute павінна быць малюнкам.",
                  in: "Выбранае значэнне для :attribute памылкова.",
                  in_array: "The :attribute field does not exist in :other.",
                  integer: "Поле :attribute павінна быць цэлым лікам.",
                  ip: "Поле :attribute дпавінна быць сапраўдным IP-адрасам.",
                  ipv4: "The :attribute must be a valid IPv4 address.",
                  ipv6: "The :attribute must be a valid IPv6 address.",
                  json: "Поле :attribute павінна быць JSON радком.",
                  lt: {
                      numeric: "The :attribute must be less than :value.",
                      file: "The :attribute must be less than :value kilobytes.",
                      string: "The :attribute must be less than :value characters.",
                      array: "The :attribute must have less than :value items.",
                  },
                  lte: {
                      numeric: "The :attribute must be less than or equal :value.",
                      file: "The :attribute must be less than or equal :value kilobytes.",
                      string: "The :attribute must be less than or equal :value characters.",
                      array: "The :attribute must not have more than :value items.",
                  },
                  max: {
                      numeric: "Поле :attribute не можа быць больш :max.",
                      file: "Памер файла ў поле :attribute не можа быць больш :max кілабайт).",
                      string: "Колькасць сiмвалаў у поле :attribute не можа перавышаць :max.",
                      array: "Колькасць элементаў у поле :attribute не можа перавышаць :max.",
                  },
                  mimes: "Поле :attribute павінна быць файлам аднаго з наступных тыпаў: :values.",
                  mimetypes: "Поле :attribute павінна быць файлам аднаго з наступных тыпаў: :values.",
                  min: {
                      numeric: "Поле :attribute павінна быць не менш :min.",
                      file: "Памер файла ў полее :attribute павінен быць не менш :min кілабайт.",
                      string: "Колькасць сiмвалаў у поле :attribute павінна быць не менш :min.",
                      array: "Колькасць элементаў у поле :attribute павінна быць не менш :min.",
                  },
                  not_in: "Выбранае значэнне для :attribute памылкова.",
                  not_regex: "The :attribute format is invalid.",
                  numeric: "Поле :attribute павінна быць лікам.",
                  present: "The :attribute field must be present.",
                  regex: "Поле :attribute мае памылковы фармат.",
                  required: "Поле :attribute абавязкова для запаўнення.",
                  required_if: "Поле :attribute абавязкова для запаўнення, калі :other раўняецца :value.",
                  required_unless: "Поле :attribute абавязкова для запаўнення, калі :other не раўняецца :values.",
                  required_with: "Поле :attribute абавязкова для запаўнення, калі :values ўказана.",
                  required_with_all: "Поле :attribute абавязкова для запаўнення, калі :values ўказана.",
                  required_without: "Поле :attribute абавязкова для запаўнення, калі :values не ўказана.",
                  required_without_all: "Поле :attribute абавязкова для запаўнення, калі ні адно з :values не ўказана.",
                  same: "Значэнне :attribute павінна супадаць з :other.",
                  size: {
                      numeric: "Поле :attribute павінна быць :size.",
                      file: "Размер файла в поле :attribute павінен быць :size кілабайт.",
                      string: "Колькасць сiмвалаў у поле :attribute павінна быць :size.",
                      array: "Колькасць элементаў у поле :attribute павінна быць :size.",
                  },
                  string: "Поле :attribute павінна быць радком.",
                  timezone: "Поле :attribute павінна быць сапраўдным гадзінным поясам.",
                  unique: "Такое значэнне поля :attribute ўжо існуе.",
                  uploaded: "The :attribute failed to upload.",
                  url: "Поле :attribute мае памылковы фармат.",
              };
          },
          3188: (e) => {
              e.exports = {
                  accepted: "Трябва да приемете :attribute.",
                  active_url: "Полето :attribute не е валиден URL адрес.",
                  after: "Полето :attribute трябва да бъде дата след :date.",
                  after_or_equal: "Полето :attribute трябва да бъде дата след или равна на :date.",
                  alpha: "Полето :attribute трябва да съдържа само букви.",
                  alpha_dash: "Полето :attribute трябва да съдържа само букви, цифри, долна черта и тире.",
                  alpha_num: "Полето :attribute трябва да съдържа само букви и цифри.",
                  array: "Полето :attribute трябва да бъде масив.",
                  before: "Полето :attribute трябва да бъде дата преди :date.",
                  before_or_equal: "Полето :attribute трябва да бъде дата преди или равна на :date.",
                  between: {
                      numeric: "Полето :attribute трябва да бъде между :min и :max.",
                      file: "Полето :attribute трябва да бъде между :min и :max килобайта.",
                      string: "Полето :attribute трябва да бъде между :min и :max знака.",
                      array: "Полето :attribute трябва да има между :min - :max елемента.",
                  },
                  boolean: "Полето :attribute трябва да съдържа Да или Не",
                  confirmed: "Полето :attribute не е потвърдено.",
                  date: "Полето :attribute не е валидна дата.",
                  date_format: "Полето :attribute не е във формат :format.",
                  different: "Полетата :attribute и :other трябва да са различни.",
                  digits: "Полето :attribute трябва да има :digits цифри.",
                  digits_between: "Полето :attribute трябва да има между :min и :max цифри.",
                  dimensions: "Невалидни размери за снимка :attribute.",
                  distinct: "Данните в полето :attribute се дублират.",
                  email: "Полето :attribute е в невалиден формат.",
                  exists: "Избранато поле :attribute вече съществува.",
                  file: "Полето :attribute трябва да бъде файл.",
                  filled: "Полето :attribute е задължително.",
                  gt: {
                      numeric: "The :attribute must be greater than :value.",
                      file: "The :attribute must be greater than :value kilobytes.",
                      string: "The :attribute must be greater than :value characters.",
                      array: "The :attribute must have more than :value items.",
                  },
                  gte: {
                      numeric: "The :attribute must be greater than or equal :value.",
                      file: "The :attribute must be greater than or equal :value kilobytes.",
                      string: "The :attribute must be greater than or equal :value characters.",
                      array: "The :attribute must have :value items or more.",
                  },
                  hex: "The :attribute field should have hexadecimal format",
                  image: "Полето :attribute трябва да бъде изображение.",
                  in: "Избраното поле :attribute е невалидно.",
                  in_array: "Полето :attribute не съществува в :other.",
                  integer: "Полето :attribute трябва да бъде цяло число.",
                  ip: "Полето :attribute трябва да бъде IP адрес.",
                  ipv4: "Полето :attribute трябва да бъде IPv4 адрес.",
                  ipv6: "Полето :attribute трябва да бъде IPv6 адрес.",
                  json: "Полето :attribute трябва да бъде JSON низ.",
                  lt: {
                      numeric: "The :attribute must be less than :value.",
                      file: "The :attribute must be less than :value kilobytes.",
                      string: "The :attribute must be less than :value characters.",
                      array: "The :attribute must have less than :value items.",
                  },
                  lte: {
                      numeric: "The :attribute must be less than or equal :value.",
                      file: "The :attribute must be less than or equal :value kilobytes.",
                      string: "The :attribute must be less than or equal :value characters.",
                      array: "The :attribute must not have more than :value items.",
                  },
                  max: {
                      numeric: "Полето :attribute трябва да бъде по-малко от :max.",
                      file: "Полето :attribute трябва да бъде по-малко от :max килобайта.",
                      string: "Полето :attribute трябва да бъде по-малко от :max знака.",
                      array: "Полето :attribute трябва да има по-малко от :max елемента.",
                  },
                  mimes: "Полето :attribute трябва да бъде файл от тип: :values.",
                  mimetypes: "Полето :attribute трябва да бъде файл от тип: :values.",
                  min: {
                      numeric: "Полето :attribute трябва да бъде минимум :min.",
                      file: "Полето :attribute трябва да бъде минимум :min килобайта.",
                      string: "Полето :attribute трябва да бъде минимум :min знака.",
                      array: "Полето :attribute трябва има минимум :min елемента.",
                  },
                  not_in: "Избраното поле :attribute е невалидно.",
                  not_regex: "The :attribute format is invalid.",
                  numeric: "Полето :attribute трябва да бъде число.",
                  present: "Полето :attribute трябва да съествува.",
                  regex: "Полето :attribute е в невалиден формат.",
                  required: "Полето :attribute е задължително.",
                  required_if: "Полето :attribute се изисква, когато :other е :value.",
                  required_unless: "Полето :attribute се изисква, освен ако :other не е в :values.",
                  required_with: "Полето :attribute се изисква, когато :values има стойност.",
                  required_with_all: "Полето :attribute е задължително, когато :values имат стойност.",
                  required_without: "Полето :attribute се изисква, когато :values няма стойност.",
                  required_without_all: "Полето :attribute се изисква, когато никое от полетата :values няма стойност.",
                  same: "Полетата :attribute и :other трябва да съвпадат.",
                  size: {
                      numeric: "Полето :attribute трябва да бъде :size.",
                      file: "Полето :attribute трябва да бъде :size килобайта.",
                      string: "Полето :attribute трябва да бъде :size знака.",
                      array: "Полето :attribute трябва да има :size елемента.",
                  },
                  string: "Полето :attribute трябва да бъде знаков низ.",
                  timezone: "Полето :attribute трябва да съдържа валидна часова зона.",
                  unique: "Полето :attribute вече съществува.",
                  uploaded: "Неуспешно качване на :attribute.",
                  url: "Полето :attribute е в невалиден формат.",
              };
          },
          842: (e) => {
              e.exports = {
                  accepted: "Polje :attribute mora biti prihvaćeno.",
                  active_url: "Polje :attribute nije validan URL.",
                  after: "Polje :attribute mora biti datum poslije :date.",
                  after_or_equal: "The :attribute must be a date after or equal to :date.",
                  alpha: "Polje :attribute može sadržati samo slova.",
                  alpha_dash: "Polje :attribute može sadržati samo slova, brojeve i povlake.",
                  alpha_num: "Polje :attribute može sadržati samo slova i brojeve.",
                  attributes: {},
                  array: "Polje :attribute mora biti niz.",
                  before: "Polje :attribute mora biti datum prije :date.",
                  before_or_equal: "The :attribute must be a date before or equal to :date.",
                  between: {
                      numeric: "Polje :attribute mora biti izmedju :min - :max.",
                      file: "Fajl :attribute mora biti izmedju :min - :max kilobajta.",
                      string: "Polje :attribute mora biti izmedju :min - :max karaktera.",
                      array: "Polje :attribute mora biti između :min - :max karaktera.",
                  },
                  boolean: "Polje :attribute mora biti tačno ili netačno",
                  confirmed: "Potvrda polja :attribute se ne poklapa.",
                  date: "Polje :attribute nema ispravan datum.",
                  date_format: "Polje :attribute nema odgovarajući format :format.",
                  different: "Polja :attribute i :other moraju biti različita.",
                  digits: "Polje :attribute mora da sadži :digits brojeve.",
                  digits_between: "Polje :attribute mora biti između :min i :max broja.",
                  dimensions: "The :attribute has invalid image dimensions.",
                  distinct: "The :attribute field has a duplicate value.",
                  email: "Format polja :attribute mora biti validan email.",
                  exists: "Odabrano polje :attribute nije validno.",
                  file: "The :attribute must be a file.",
                  filled: "Polje :attribute je obavezno.",
                  gt: {
                      numeric: "The :attribute must be greater than :value.",
                      file: "The :attribute must be greater than :value kilobytes.",
                      string: "The :attribute must be greater than :value characters.",
                      array: "The :attribute must have more than :value items.",
                  },
                  gte: {
                      numeric: "The :attribute must be greater than or equal :value.",
                      file: "The :attribute must be greater than or equal :value kilobytes.",
                      string: "The :attribute must be greater than or equal :value characters.",
                      array: "The :attribute must have :value items or more.",
                  },
                  hex: "The :attribute field should have hexadecimal format",
                  image: "Polje :attribute mora biti slika.",
                  in: "Odabrano polje :attribute nije validno.",
                  in_array: "The :attribute field does not exist in :other.",
                  integer: "Polje :attribute mora biti broj.",
                  ip: "Polje :attribute mora biti validna IP adresa.",
                  ipv4: "The :attribute must be a valid IPv4 address.",
                  ipv6: "The :attribute must be a valid IPv6 address.",
                  json: "The :attribute must be a valid JSON string.",
                  lt: {
                      numeric: "The :attribute must be less than :value.",
                      file: "The :attribute must be less than :value kilobytes.",
                      string: "The :attribute must be less than :value characters.",
                      array: "The :attribute must have less than :value items.",
                  },
                  lte: {
                      numeric: "The :attribute must be less than or equal :value.",
                      file: "The :attribute must be less than or equal :value kilobytes.",
                      string: "The :attribute must be less than or equal :value characters.",
                      array: "The :attribute must not have more than :value items.",
                  },
                  max: {
                      numeric: "Polje :attribute mora biti manje od :max.",
                      file: "Polje :attribute mora biti manje od :max kilobajta.",
                      string: "Polje :attribute mora sadržati manje od :max karaktera.",
                      array: "Polje :attribute mora sadržati manje od :max karaktera.",
                  },
                  mimes: "Polje :attribute mora biti fajl tipa: :values.",
                  mimetypes: "Polje :attribute mora biti fajl tipa: :values.",
                  min: {
                      numeric: "Polje :attribute mora biti najmanje :min.",
                      file: "Fajl :attribute mora biti najmanje :min kilobajta.",
                      string: "Polje :attribute mora sadržati najmanje :min karaktera.",
                      array: "Polje :attribute mora sadržati najmanje :min karaktera.",
                  },
                  not_in: "Odabrani element polja :attribute nije validan.",
                  not_regex: "The :attribute format is invalid.",
                  numeric: "Polje :attribute mora biti broj.",
                  present: "The :attribute field must be present.",
                  regex: "Polje :attribute ima neispravan format.",
                  required: "Polje :attribute je obavezno.",
                  required_if: "Polje :attribute je obavezno kada :other je :value.",
                  required_unless: "The :attribute field is required unless :other is in :values.",
                  required_with: "Polje :attribute je obavezno kada je :values prikazano.",
                  required_with_all: "Polje :attribute je obavezno kada je :values prikazano.",
                  required_without: "Polje :attribute je obavezno kada :values nije prikazano.",
                  required_without_all: "Polje :attribute je obavezno kada nijedno :values nije prikazano.",
                  same: "Polja :attribute i :other se moraju poklapati.",
                  size: { numeric: "Polje :attribute mora biti :size.", file: "Fajl :attribute mora biti :size kilobajta.", string: "Polje :attribute mora biti :size karaktera.", array: "Polje :attribute mora biti :size karaktera." },
                  string: "Polje :attribute mora sadrzavati slova.",
                  timezone: "Polje :attribute mora biti ispravna vremenska zona.",
                  unique: "Polje :attribute već postoji.",
                  uploaded: "The :attribute failed to upload.",
                  url: "Format polja :attribute nije validan.",
              };
          },
          6918: (e) => {
              e.exports = {
                  accepted: "El camp :attribute pot ser aceptat.",
                  after: "El camp :attribute pot ser una data posterior a :after.",
                  alpha: "El camp :attribute només pot contenir lletras.",
                  alpha_dash: "El camp :attribute només pot contenir lletras, nombres y guions.",
                  alpha_num: "El camp :attribute només pot contenir lletras y nombres.",
                  attributes: {},
                  between: "El camp :attribute té que estar entre :min - :max.",
                  confirmed: "La confirmació de :attribute no coincideix.",
                  different: "El camp :attribute y :other poden ser diferents.",
                  digits: "El camp :attribute pot tindre :digits dígitos.",
                  digits_between: "El camp  :attribute ha de tenir entre :min i :max dígits.",
                  email: "El camp :attribute no es un correu válido.",
                  in: "El camp :attribute es invàlid.",
                  integer: "El camp :attribute pot ser un nombre enter.",
                  hex: "El camp :attribute hauria de tenir format hexadecimal",
                  max: { numeric: "El camp :attribute no pot ser mayor a :max.", string: "El camp :attribute no pot ser mayor que :max caràcters." },
                  min: { numeric: "La mida del camp :attribute pot ser de al menys :min.", string: "El camp :attribute pot contenir al menys :min caràcters." },
                  not_in: "El camp :attribute es invàlid.",
                  numeric: "El camp :attribute pot ser numéric.",
                  present: "El camp de :attribute pot estar present (però pot estar buit).",
                  regex: "El format del camp :attribute es invàlid.",
                  required: "El camp :attribute es obligatori.",
                  required_if: "El camp :attribute es obligatori quan :other es :value.",
                  same: "El camp :attribute y :other poden coincidir.",
                  size: { numeric: "La mida del camp :attribute pot ser :size.", string: "El camp :attribute pot contenir :size caràcters." },
                  url: "El format de :attribute es invàlid.",
              };
          },
          4590: (e) => {
              e.exports = {
                  accepted: ":attribute musí být přijat.",
                  active_url: ":attribute není platnou URL adresou.",
                  after: ":attribute musí být datum po :date.",
                  after_or_equal: "The :attribute must be a date after or equal to :date.",
                  alpha: ":attribute může obsahovat pouze písmena.",
                  alpha_dash: ":attribute může obsahovat pouze písmena, číslice, pomlčky a podtržítka. České znaky (á, é, í, ó, ú, ů, ž, š, č, ř, ď, ť, ň) nejsou podporovány.",
                  alpha_num: ":attribute může obsahovat pouze písmena a číslice.",
                  attributes: {},
                  array: ":attribute musí být pole.",
                  before: ":attribute musí být datum před :date.",
                  before_or_equal: "The :attribute must be a date before or equal to :date.",
                  between: {
                      numeric: ":attribute musí být hodnota mezi :min a :max.",
                      file: ":attribute musí být větší než :min a menší než :max Kilobytů.",
                      string: ":attribute musí být delší než :min a kratší než :max znaků.",
                      array: ":attribute musí obsahovat nejméně :min a nesmí obsahovat více než :max prvků.",
                  },
                  boolean: ":attribute musí být true nebo false",
                  confirmed: ":attribute nebylo odsouhlaseno.",
                  date: ":attribute musí být platné datum.",
                  date_format: ":attribute není platný formát data podle :format.",
                  different: ":attribute a :other se musí lišit.",
                  digits: ":attribute musí být :digits pozic dlouhé.",
                  digits_between: ":attribute musí být dlouhé nejméně :min a nejvíce :max pozic.",
                  dimensions: ":attribute má neplatné rozměry.",
                  distinct: ":attribute má duplicitní hodnotu.",
                  email: ":attribute není platný formát.",
                  exists: "Zvolená hodnota pro :attribute není platná.",
                  file: ":attribute musí být soubor.",
                  filled: ":attribute musí být vyplněno.",
                  gt: {
                      numeric: "The :attribute must be greater than :value.",
                      file: "The :attribute must be greater than :value kilobytes.",
                      string: "The :attribute must be greater than :value characters.",
                      array: "The :attribute must have more than :value items.",
                  },
                  gte: {
                      numeric: "The :attribute must be greater than or equal :value.",
                      file: "The :attribute must be greater than or equal :value kilobytes.",
                      string: "The :attribute must be greater than or equal :value characters.",
                      array: "The :attribute must have :value items or more.",
                  },
                  hex: "The :attribute field should have hexadecimal format",
                  image: ":attribute musí být obrázek.",
                  in: "Zvolená hodnota pro :attribute je neplatná.",
                  in_array: ":attribute není obsažen v :other.",
                  integer: ":attribute musí být celé číslo.",
                  ip: ":attribute musí být platnou IP adresou.",
                  ipv4: "The :attribute must be a valid IPv4 address.",
                  ipv6: "The :attribute must be a valid IPv6 address.",
                  json: ":attribute musí být platný JSON řetězec.",
                  lt: {
                      numeric: "The :attribute must be less than :value.",
                      file: "The :attribute must be less than :value kilobytes.",
                      string: "The :attribute must be less than :value characters.",
                      array: "The :attribute must have less than :value items.",
                  },
                  lte: {
                      numeric: "The :attribute must be less than or equal :value.",
                      file: "The :attribute must be less than or equal :value kilobytes.",
                      string: "The :attribute must be less than or equal :value characters.",
                      array: "The :attribute must not have more than :value items.",
                  },
                  max: {
                      numeric: ":attribute musí být nižší než :max.",
                      file: ":attribute musí být menší než :max Kilobytů.",
                      string: ":attribute musí být kratší než :max znaků.",
                      array: ":attribute nesmí obsahovat více než :max prvků.",
                  },
                  mimes: ":attribute musí být jeden z následujících datových typů :values.",
                  mimetypes: ":attribute musí být jeden z následujících datových typů :values.",
                  min: { numeric: ":attribute musí být větší než :min.", file: ":attribute musí být větší než :min Kilobytů.", string: ":attribute musí být delší než :min znaků.", array: ":attribute musí obsahovat více než :min prvků." },
                  not_in: "Zvolená hodnota pro :attribute je neplatná.",
                  not_regex: "The :attribute format is invalid.",
                  numeric: ":attribute musí být číslo.",
                  present: ":attribute musí být vyplněno.",
                  regex: ":attribute nemá správný formát.",
                  required: ":attribute musí být vyplněno.",
                  required_if: ":attribute musí být vyplněno pokud :other je :value.",
                  required_unless: ":attribute musí být vyplněno dokud :other je v :value.",
                  required_with: ":attribute musí být vyplněno pokud :field je vyplněno.",
                  required_with_all: ":attribute musí být vyplněno pokud :fields je zvoleno.",
                  required_without: ":attribute musí být vyplněno pokud :field není vyplněno.",
                  required_without_all: ":attribute musí být vyplněno pokud není žádné z :fields zvoleno.",
                  same: ":attribute a :other se musí shodovat.",
                  size: { numeric: ":attribute musí být přesně :size.", file: ":attribute musí mít přesně :size Kilobytů.", string: ":attribute musí být přesně :size znaků dlouhý.", array: ":attribute musí obsahovat právě :size prvků." },
                  string: ":attribute musí být řetězec znaků.",
                  timezone: ":attribute musí být platná časová zóna.",
                  unique: ":attribute musí být unikátní.",
                  uploaded: "Nahrávání :attribute se nezdařilo.",
                  url: "Formát :attribute je neplatný.",
              };
          },
          4475: (e) => {
              e.exports = {
                  accepted: "Rhaid derbyn :attribute.",
                  active_url: "Nid yw :attribute yn URL dilys.",
                  after: "Rhaid i :attribute fod yn ddyddiad sydd ar ôl :date.",
                  after_or_equal: "The :attribute must be a date after or equal to :date.",
                  alpha: "Dim ond llythrennau'n unig gall :attribute gynnwys.",
                  alpha_dash: "Dim ond llythrennau, rhifau a dash yn unig gall :attribute gynnwys.",
                  alpha_num: "Dim ond llythrennau a rhifau yn unig gall :attribute gynnwys.",
                  attributes: {},
                  array: "Rhaid i :attribute fod yn array.",
                  before: "Rhaid i :attribute fod yn ddyddiad sydd cyn :date.",
                  before_or_equal: "The :attribute must be a date before or equal to :date.",
                  between: {
                      numeric: "Rhaid i :attribute fod rhwng :min a :max.",
                      file: "Rhaid i :attribute fod rhwng :min a :max kilobytes.",
                      string: "Rhaid i :attribute fod rhwng :min a :max nodyn.",
                      array: "Rhaid i :attribute fod rhwng :min a :max eitem.",
                  },
                  boolean: "Rhaid i'r maes :attribute fod yn wir neu gau.",
                  confirmed: "Nid yw'r cadarnhad :attribute yn gyfwerth.",
                  date: "Nid yw :attribute yn ddyddiad dilys.",
                  date_format: "Nid yw :attribute yn y fformat :format.",
                  different: "Rhaid i :attribute a :other fod yn wahanol.",
                  digits: "Rhaid i :attribute fod yn :digits digid.",
                  digits_between: "Rhaid i :attribute fod rhwng :min a :max digid.",
                  dimensions: "The :attribute has invalid image dimensions.",
                  distinct: "The :attribute field has a duplicate value.",
                  email: "Rhaid i :attribute fod yn gyfeiriad ebost dilys.",
                  file: "The :attribute must be a file.",
                  filled: "Rhaid cynnwys :attribute.",
                  exists: "Nid yw :attribute yn ddilys.",
                  gt: {
                      numeric: "The :attribute must be greater than :value.",
                      file: "The :attribute must be greater than :value kilobytes.",
                      string: "The :attribute must be greater than :value characters.",
                      array: "The :attribute must have more than :value items.",
                  },
                  gte: {
                      numeric: "The :attribute must be greater than or equal :value.",
                      file: "The :attribute must be greater than or equal :value kilobytes.",
                      string: "The :attribute must be greater than or equal :value characters.",
                      array: "The :attribute must have :value items or more.",
                  },
                  hex: "The :attribute field should have hexadecimal format",
                  image: "Rhaid i :attribute fod yn lun.",
                  in: "Nid yw :attribute yn ddilys.",
                  in_array: "The :attribute field does not exist in :other.",
                  integer: "Rhaid i :attribute fod yn integer.",
                  ip: "Rhaid i :attribute fod yn gyfeiriad IP dilys.",
                  ipv4: "The :attribute must be a valid IPv4 address.",
                  ipv6: "The :attribute must be a valid IPv6 address.",
                  json: "The :attribute must be a valid JSON string.",
                  lt: {
                      numeric: "The :attribute must be less than :value.",
                      file: "The :attribute must be less than :value kilobytes.",
                      string: "The :attribute must be less than :value characters.",
                      array: "The :attribute must have less than :value items.",
                  },
                  lte: {
                      numeric: "The :attribute must be less than or equal :value.",
                      file: "The :attribute must be less than or equal :value kilobytes.",
                      string: "The :attribute must be less than or equal :value characters.",
                      array: "The :attribute must not have more than :value items.",
                  },
                  max: {
                      numeric: "Ni chai :attribute fod yn fwy na :max.",
                      file: "Ni chai :attribute fod yn fwy na :max kilobytes.",
                      string: "Ni chai :attribute fod yn fwy na :max nodyn.",
                      array: "Ni chai :attribute fod yn fwy na :max eitem.",
                  },
                  mimes: "Rhaid i :attribute fod yn ffeil o'r math: :values.",
                  mimetypes: "Rhaid i :attribute fod yn ffeil o'r math: :values.",
                  min: { numeric: "Rhaid i :attribute fod o leiaf :min.", file: "Rhaid i :attribute fod o leiaf :min kilobytes.", string: "Rhaid i :attribute fod o leiaf :min nodyn.", array: "Rhaid i :attribute fod o leiaf :min eitem." },
                  not_in: "Nid yw :attribute yn ddilys.",
                  not_regex: "The :attribute format is invalid.",
                  numeric: "Rhaid i :attribute fod yn rif.",
                  present: "The :attribute field must be present.",
                  regex: "Nid yw fformat :attribute yn ddilys.",
                  required: "Rhaid cynnwys :attribute.",
                  required_if: "Rhaid cynnwys :attribute pan mae :other yn :value.",
                  required_unless: "The :attribute field is required unless :other is in :values.",
                  required_with: "Rhaid cynnwys :attribute pan mae :values yn bresennol.",
                  required_with_all: "Rhaid cynnwys :attribute pan mae :values yn bresennol.",
                  required_without: "Rhaid cynnwys :attribute pan nad oes :values yn bresennol.",
                  required_without_all: "Rhaid cynnwys :attribute pan nad oes :values yn bresennol.",
                  same: "Rhaid i :attribute a :other fod yn gyfwerth.",
                  size: { numeric: "Rhaid i :attribute fod yn :size.", file: "Rhaid i :attribute fod yn :size kilobytes.", string: "Rhaid i :attribute fod yn :size nodyn.", array: "Rhaid i :attribute fod yn :size eitem." },
                  string: "The :attribute must be a string.",
                  timezone: "Rhaid i :attribute fod yn timezone dilys.",
                  unique: "Mae :attribute eisoes yn bodoli.",
                  uploaded: "The :attribute failed to upload.",
                  url: "Nid yw fformat :attribute yn ddilys.",
              };
          },
          9210: (e) => {
              e.exports = {
                  accepted: ":attribute skal accepteres.",
                  after: ":attribute skal være en dato efter :after.",
                  after_or_equal: ":attribute skal være en dato efter eller lig med :after_or_equal.",
                  alpha: ":attribute må kun bestå af bogstaver.",
                  alpha_dash: ":attribute må kun bestå af bogstaver, tal og bindestreger.",
                  alpha_num: ":attribute må kun bestå af bogstaver og tal.",
                  before: ":attribute skal være en dato før :before.",
                  before_or_equal: ":attribute skal være en dato før eller lig med :before_or_equal.",
                  between: ":attribute skal være mellem :min og :max.",
                  confirmed: ":attribute er ikke det samme som bekræftelsesfeltet.",
                  email: ":attribute skal være en gyldig email.",
                  date: ":attribute er ikke en gyldig dato.",
                  def: ":attribute attributen har fejl.",
                  digits: ":attribute skal have :digits cifre.",
                  digits_between: ":attribute skal have mellem :min og :max cifre.",
                  different: ":attribute og :different skal være forskellige.",
                  in: "Det valgte :attribute er ugyldigt.",
                  integer: ":attribute skal være et heltal.",
                  hex: ":attribute skal have hexadecimalt format",
                  min: { numeric: ":attribute skal være mindst :min.", string: ":attribute skal være mindst :min tegn." },
                  max: { numeric: ":attribute skal være højest :max.", string: ":attribute skal være højest :max tegn." },
                  not_in: "Den valgte :attribute er ugyldig",
                  numeric: ":attribute skal være et tal.",
                  present: ":attribute skal være tilstede.",
                  required: ":attribute skal udfyldes.",
                  required_if: ":attribute skal udfyldes når :other er :value.",
                  required_unless: ":attribute er påkrævet medmindre :other findes i :values.",
                  required_with: ":attribute skal udfyldes når :field er udfyldt.",
                  required_with_all: ":attribute skal udfyldes når :fields er udfyldt.",
                  required_without: ":attribute skal udfyldes når :field ikke er udfyldt.",
                  required_without_all: ":attribute skal udfyldes når ingen af :fields er udfyldt.",
                  same: ":attribute og :same skal være ens.",
                  size: { numeric: ":attribute skal være :size.", string: ":attribute skal være :size tegn lang." },
                  string: ":attribute skal være en streng.",
                  url: ":attribute formatet er ugyldigt.",
                  regex: ":attribute formatet er ugyldigt.",
                  attributes: {},
              };
          },
          1245: (e) => {
              e.exports = {
                  accepted: "Das :attribute Feld muss akzeptiert werden.",
                  after: "Das :attribute muss ein Datum nach dem :after sein.",
                  after_or_equal: "Das :attribute Datum muss kleiner oder gleich dem :after_or_equal sein.",
                  alpha: "Das :attribute Feld darf nur aus Buchstaben bestehen.",
                  alpha_dash: "Das :attribute Feld darf nur aus Buchstaben, Zahlen, Binde- und Unterstrichen bestehen.",
                  alpha_num: "Das :attribute Feld darf nur aus Buchstaben und Zahlen bestehen.",
                  before: "Das :attribute muss ein Datum vor dem :before sein.",
                  before_or_equal: "Das :attribute Datum muss größer oder gleich dem :before_or_equal sein.",
                  between: "Das :attribute Feld muss zwischen :min und :max liegen.",
                  confirmed: "Das :attribute Feld stimmt nicht mit der Bestätigung überein.",
                  email: "Das :attribute Format ist ungültig.",
                  date: "Das :attribute Feld muss ein gültiges Datum sein.",
                  def: "Das :attribute Feld hat Fehler.",
                  digits: "Das :attribute Feld muss :digits Stellen haben.",
                  digits_between: "Das :attribute Feld muss zwischen :min und :max Stellen haben.",
                  different: "Die Felder :attribute und :different müssen sich unterscheiden.",
                  in: "Der gewählte Wert für :attribute ist ungültig.",
                  integer: "Das :attribute Feld muss eine ganze Zahl sein.",
                  hex: "Das :attribute Feld sollte hexadezimal sein",
                  min: { numeric: "Das :attribute Feld muss mindestens :min sein.", string: "Das :attribute Feld muss mindestens :min Zeichen lang sein." },
                  max: { numeric: "Das :attribute Feld darf maximal :max sein.", string: "Das :attribute Feld darf maximal :max Zeichen haben." },
                  not_in: "Der gewählte Wert für :attribute ist ungültig.",
                  numeric: "Das :attribute Feld muss eine Zahl sein.",
                  present: "Das Feld :attribute muss vorhanden sein (kann aber leer sein).",
                  required: "Das :attribute Feld muss ausgefüllt sein.",
                  required_if: "Das :attribute Feld muss ausgefüllt sein, wenn :other :value ist.",
                  same: "Die Felder :attribute und :same müssen übereinstimmen.",
                  size: { numeric: "Das :attribute Feld muss gleich :size sein.", string: "Das :attribute Feld muss :size Zeichen lang sein." },
                  string: "Das :attribute Feld muss ein Satz sein.",
                  url: "Das Format von :attribute ist ungültig.",
                  regex: "Das :attribute Format ist ungültig.",
                  attributes: {},
              };
          },
          4630: (e) => {
              e.exports = {
                  accepted: "Το πεδίο :attribute πρέπει να γίνει αποδεκτό.",
                  after: "Το πεδίο :attribute πρέπει να είναι μία ημερομηνία μετά από :after.",
                  alpha: "Το πεδίο :attribute μπορεί να περιέχει μόνο γράμματα.",
                  alpha_dash: "Το πεδίο :attribute μπορεί να περιέχει μόνο γράμματα, αριθμούς, και παύλες.",
                  alpha_num: "Το πεδίο :attribute μπορεί να περιέχει μόνο γράμματα και αριθμούς.",
                  between: "Το πεδίο :attribute πρέπει να είναι μεταξύ :min και :max.",
                  confirmed: "Η επιβεβαίωση του :attribute δεν ταιριάζει.",
                  email: "Το πεδίο :attribute πρέπει να είναι μία έγκυρη διεύθυνση email.",
                  date: "Το πεδίο :attribute δεν είναι έγκυρη ημερομηνία.",
                  def: "Το πεδίο :attribute περιέχει σφάλματα.",
                  digits: "Το πεδίο :attribute πρέπει να είναι :digits ψηφία.",
                  digits_between: "Το πεδίο :attribute πρέπει να είναι μεταξύ :min και :max ψηφία.",
                  different: "Το πεδίο :attribute  και :different πρέπει να είναι διαφορετικά.",
                  in: "Το επιλεγμένο :attribute δεν είναι έγκυρο.",
                  integer: "Το πεδίο :attribute πρέπει να είναι ακέραιος.",
                  hex: "Το πεδίο :attribute πρέπει να είναι σε δεκαεξαδική μορφή.",
                  min: { numeric: "Το πεδίο :attribute πρέπει να είναι τουλάχιστον :min.", string: "Το πεδίο :attribute πρέπει να έχει τουλάχιστον :min χαρακτήρες." },
                  max: { numeric: "Το πεδίο :attribute δεν μπορεί να είναι μεγαλύτερο από :max.", string: "Το πεδίο :attribute δεν μπορεί να έχει περισσότερους από :max χαρακτήρες." },
                  not_in: "Το επιλεγμένο :attribute δεν είναι αποδεκτό.",
                  numeric: "Το πεδίο :attribute πρέπει να είναι αριθμός.",
                  present: "The :attribute field must be present (but can be empty).",
                  required: "Το πεδίο :attribute είναι απαραίτητο.",
                  required_if: "Το πεδίο :attribute είναι απαραίτητο όταν το πεδίο :other είναι :value.",
                  same: "Τα πεδία :attribute και :same πρέπει να είναι ίδια.",
                  size: { numeric: "Το πεδίο :attribute πρέπει να είναι :size.", string: "Το πεδίο :attribute πρέπει να είναι :size χαρακτήρες." },
                  string: "Το πεδίο :attribute πρέπει να είναι αλφαριθμητικό.",
                  url: "Το πεδίο :attribute δεν είναι έγκυρη διεύθυνση URL.",
                  regex: "Η μορφή του :attribute δεν είναι αποδεκτή.",
                  attributes: {},
              };
          },
          437: (e) => {
              e.exports = {
                  accepted: "The :attribute must be accepted.",
                  after: "The :attribute must be after :after.",
                  after_or_equal: "The :attribute must be equal or after :after_or_equal.",
                  alpha: "The :attribute field must contain only alphabetic characters.",
                  alpha_dash: "The :attribute field may only contain alpha-numeric characters, as well as dashes and underscores.",
                  alpha_num: "The :attribute field must be alphanumeric.",
                  before: "The :attribute must be before :before.",
                  before_or_equal: "The :attribute must be equal or before :before_or_equal.",
                  between: { numeric: "The :attribute field must be between :min and :max.", string: "The :attribute field must be between :min and :max characters." },
                  confirmed: "The :attribute confirmation does not match.",
                  email: "The :attribute format is invalid.",
                  date: "The :attribute is not a valid date format.",
                  def: "The :attribute attribute has errors.",
                  digits: "The :attribute must be :digits digits.",
                  digits_between: "The :attribute field must be between :min and :max digits.",
                  different: "The :attribute and :different must be different.",
                  in: "The selected :attribute is invalid.",
                  integer: "The :attribute must be an integer.",
                  hex: "The :attribute field should have hexadecimal format",
                  min: { numeric: "The :attribute must be at least :min.", string: "The :attribute must be at least :min characters." },
                  max: { numeric: "The :attribute may not be greater than :max.", string: "The :attribute may not be greater than :max characters." },
                  not_in: "The selected :attribute is invalid.",
                  numeric: "The :attribute must be a number.",
                  present: "The :attribute field must be present (but can be empty).",
                  required: "The :attribute field is required.",
                  required_if: "The :attribute field is required when :other is :value.",
                  required_unless: "The :attribute field is required when :other is not :value.",
                  required_with: "The :attribute field is required when :field is not empty.",
                  required_with_all: "The :attribute field is required when :fields are not empty.",
                  required_without: "The :attribute field is required when :field is empty.",
                  required_without_all: "The :attribute field is required when :fields are empty.",
                  same: "The :attribute and :same fields must match.",
                  size: { numeric: "The :attribute must be :size.", string: "The :attribute must be :size characters." },
                  string: "The :attribute must be a string.",
                  url: "The :attribute format is invalid.",
                  regex: "The :attribute format is invalid.",
                  attributes: {},
              };
          },
          5322: (e) => {
              e.exports = {
                  accepted: "El campo :attribute debe ser aceptado.",
                  after: "El campo :attribute debe ser una fecha posterior a :after.",
                  alpha: "El campo :attribute solo debe contener letras.",
                  alpha_dash: "El campo :attribute solo debe contener letras, números y guiones.",
                  alpha_num: "El campo :attribute solo debe contener letras y números.",
                  attributes: {},
                  between: "El campo :attribute tiene que estar entre :min - :max.",
                  confirmed: "La confirmación de :attribute no coincide.",
                  different: "El campo :attribute y :other deben ser diferentes.",
                  digits: "El campo :attribute debe tener :digits dígitos.",
                  digits_between: "El campo :attribute debe tener entre :min y :max dígitos.",
                  email: "El campo :attribute no es un correo válido.",
                  in: "El campo :attribute es inválido.",
                  integer: "El campo :attribute debe ser un número entero.",
                  hex: "El campo :attribute debe tener formato hexadecimal.",
                  max: { numeric: "El campo :attribute no debe ser mayor a :max.", string: "El campo :attribute no debe ser mayor que :max caracteres." },
                  min: { numeric: "El tamaño del campo :attribute debe ser de al menos :min.", string: "El campo :attribute debe contener al menos :min caracteres." },
                  not_in: "El campo :attribute es inválido.",
                  numeric: "El campo :attribute debe ser numérico.",
                  present: "El campo de :attribute debe estar presente (pero puede estar vacío).",
                  regex: "El formato del campo :attribute es inválido.",
                  required: "El campo :attribute es obligatorio.",
                  required_if: "El campo :attribute es obligatorio cuando :other es :value.",
                  same: "El campo :attribute y :other deben coincidir.",
                  size: { numeric: "El tamaño del campo :attribute debe ser :size.", string: "El campo :attribute debe contener :size caracteres." },
                  url: "El formato de :attribute es inválido.",
              };
          },
          279: (e) => {
              e.exports = {
                  accepted: ":attribute tuleb aktsepteerida.",
                  active_url: ":attribute ei ole kehtiv URL.",
                  after: ":attribute peab olema kuupäev pärast :date.",
                  after_or_equal: ":attribute peab olema kuupäev pärast või samastuma :date.",
                  alpha: ":attribute võib sisaldada vaid tähemärke.",
                  alpha_dash: ":attribute võib sisaldada vaid tähti, numbreid ja kriipse.",
                  alpha_num: ":attribute võib sisaldada vaid tähti ja numbreid.",
                  attributes: {},
                  array: ":attribute peab olema massiiv.",
                  before: ":attribute peab olema kuupäev enne :date.",
                  before_or_equal: ":attribute peab olema kuupäev enne või samastuma :date.",
                  between: {
                      numeric: ":attribute peab olema :min ja :max vahel.",
                      file: ":attribute peab olema :min ja :max kilobaidi vahel.",
                      string: ":attribute peab olema :min ja :max tähemärgi vahel.",
                      array: ":attribute peab olema :min ja :max kirje vahel.",
                  },
                  boolean: ":attribute väli peab olema tõene või väär.",
                  confirmed: ":attribute kinnitus ei vasta.",
                  date: ":attribute pole kehtiv kuupäev.",
                  date_format: ":attribute ei vasta formaadile :format.",
                  different: ":attribute ja :other peavad olema erinevad.",
                  digits: ":attribute peab olema :digits numbrit.",
                  digits_between: ":attribute peab olema :min ja :max numbri vahel.",
                  dimensions: ":attribute on valed pildi suurused.",
                  distinct: ":attribute väljal on topeltväärtus.",
                  email: ":attribute peab olema kehtiv e-posti aadress.",
                  exists: "Valitud :attribute on vigane.",
                  file: ":attribute peab olema fail.",
                  filled: ":attribute väli on nõutav.",
                  gt: {
                      numeric: "The :attribute must be greater than :value.",
                      file: "The :attribute must be greater than :value kilobytes.",
                      string: "The :attribute must be greater than :value characters.",
                      array: "The :attribute must have more than :value items.",
                  },
                  gte: {
                      numeric: "The :attribute must be greater than or equal :value.",
                      file: "The :attribute must be greater than or equal :value kilobytes.",
                      string: "The :attribute must be greater than or equal :value characters.",
                      array: "The :attribute must have :value items or more.",
                  },
                  hex: "The :attribute field should have hexadecimal format",
                  image: ":attribute peab olema pilt.",
                  in: "Valitud :attribute on vigane.",
                  in_array: ":attribute väli ei eksisteeri :other sees.",
                  integer: ":attribute peab olema täisarv.",
                  ip: ":attribute peab olema kehtiv IP aadress.",
                  ipv4: ":attribute peab olema kehtiv IPv4 aadress.",
                  ipv6: ":attribute peab olema kehtiv IPv6 aadress.",
                  json: ":attribute peab olema kehtiv JSON string.",
                  lt: {
                      numeric: "The :attribute must be less than :value.",
                      file: "The :attribute must be less than :value kilobytes.",
                      string: "The :attribute must be less than :value characters.",
                      array: "The :attribute must have less than :value items.",
                  },
                  lte: {
                      numeric: "The :attribute must be less than or equal :value.",
                      file: "The :attribute must be less than or equal :value kilobytes.",
                      string: "The :attribute must be less than or equal :value characters.",
                      array: "The :attribute must not have more than :value items.",
                  },
                  max: {
                      numeric: ":attribute ei tohi olla suurem kui :max.",
                      file: ":attribute ei tohi olla suurem kui :max kilobaiti.",
                      string: ":attribute ei tohi olla suurem kui :max tähemärki.",
                      array: ":attribute ei tohi sisaldada rohkem kui :max kirjet.",
                  },
                  mimes: ":attribute peab olema :values tüüpi.",
                  mimetypes: ":attribute peab olema :values tüüpi.",
                  min: {
                      numeric: ":attribute peab olema vähemalt :min.",
                      file: ":attribute peab olema vähemalt :min kilobaiti.",
                      string: ":attribute peab olema vähemalt :min tähemärki.",
                      array: ":attribute peab olema vähemalt :min kirjet.",
                  },
                  not_in: "Valitud :attribute on vigane.",
                  not_regex: "The :attribute format is invalid.",
                  numeric: ":attribute peab olema number.",
                  present: ":attribute väli peab olema esindatud.",
                  regex: ":attribute vorming on vigane.",
                  required: ":attribute väli on nõutud.",
                  required_if: ":attribute väli on nõutud, kui :other on :value.",
                  required_unless: ":attribute väli on nõutud, välja arvatud, kui :other on :values.",
                  required_with: ":attribute väli on nõutud, kui :values on esindatud.",
                  required_with_all: ":attribute väli on nõutud, kui :values on esindatud.",
                  required_without: ":attribute väli on nõutud, kui :values ei ole esindatud.",
                  required_without_all: ":attribute väli on nõutud, kui ükski :values pole esindatud.",
                  same: ":attribute ja :other peavad sobima.",
                  size: { numeric: ":attribute peab olema :size.", file: ":attribute peab olema :size kilobaiti.", string: ":attribute peab olema :size tähemärki.", array: ":attribute peab sisaldama :size kirjet." },
                  string: ":attribute peab olema string.",
                  timezone: ":attribute peab olema kehtiv tsoon.",
                  unique: ":attribute on juba hõivatud.",
                  uploaded: ":attribute ei õnnestunud laadida.",
                  url: ":attribute vorming on vigane.",
              };
          },
          5e3: (e) => {
              e.exports = {
                  accepted: ":attribute onartua izan behar da.",
                  active_url: ":attribute ez da baliozko URL bat.",
                  after: ":attribute :date osteko data izan behar da.",
                  after_or_equal: ":attribute :date osteko data edo data berdina izan behar da.",
                  alpha: ":attribute hizkiak besterik ezin ditu izan.",
                  alpha_dash: ":attribute hizkiak, zenbakiak eta marrak besterik ezin ditu izan.",
                  alpha_num: ":attribute hizkiak eta zenbakiak besterik ezin ditu izan.",
                  attributes: {},
                  array: ":attribute bilduma izan behar da.",
                  before: ":attribute :date aurreko data izan behar da.",
                  before_or_equal: ":attribute :date aurreko data edo data berdina izan behar da.",
                  between: {
                      numeric: ":attribute :min eta :max artean egon behar da.",
                      file: ":attribute-k :min eta :max kilobyte arteko pisua izan behar du.",
                      string: ":attribute :min eta :max karaktere artean egon behar da.",
                      array: ":attribute-k :min eta :max arteko ale kantitatea euki behar du.",
                  },
                  boolean: ":attribute-ren balioa egia edo gezurra izan behar da.",
                  confirmed: ":attribute-ren konfirmazioa ez dator bat.",
                  date: ":attribute ez da baliozko data.",
                  date_format: ":attribute datak ez du :format formatua.",
                  different: ":attribute eta :other ezberdinak izan behar dira.",
                  digits: ":attribute-k :digits digitu euki behar ditu.",
                  digits_between: ":attribute-k :min eta :max arteko digitu kantitatea euki behar du.",
                  dimensions: ":attribute-k ez ditu irudi neurri aproposak.",
                  distinct: ":attribute-k balio bikoiztua dauka.",
                  email: ":attribute-k baliozko posta helbidea euki behar du.",
                  exists: "Hautatutako :attribute baliogabea da.",
                  file: ":attribute fitxategi bat izan behar da.",
                  filled: ":attribute-k balioren bat euki behar du.",
                  gt: {
                      numeric: "The :attribute must be greater than :value.",
                      file: "The :attribute must be greater than :value kilobytes.",
                      string: "The :attribute must be greater than :value characters.",
                      array: "The :attribute must have more than :value items.",
                  },
                  gte: {
                      numeric: "The :attribute must be greater than or equal :value.",
                      file: "The :attribute must be greater than or equal :value kilobytes.",
                      string: "The :attribute must be greater than or equal :value characters.",
                      array: "The :attribute must have :value items or more.",
                  },
                  hex: "The :attribute field should have hexadecimal format",
                  image: ":attribute irudi bat izan behar da.",
                  in: "Hautatutako :attribute baliogabea da.",
                  in_array: ":attribute ez da :other-en existizen.",
                  integer: ":attribute zenbaki osoa izan behar da.",
                  ip: ":attribute baliozko IP helbidea izan behar da.",
                  ipv4: ":attribute baliozko IPv4 helbidea izan behar da.",
                  ipv6: ":attribute baliozko IPv6 helbidea izan behar da.",
                  json: ":attribute-k baliozko JSON karaktere-katea euki behar du.",
                  lt: {
                      numeric: "The :attribute must be less than :value.",
                      file: "The :attribute must be less than :value kilobytes.",
                      string: "The :attribute must be less than :value characters.",
                      array: "The :attribute must have less than :value items.",
                  },
                  lte: {
                      numeric: "The :attribute must be less than or equal :value.",
                      file: "The :attribute must be less than or equal :value kilobytes.",
                      string: "The :attribute must be less than or equal :value characters.",
                      array: "The :attribute must not have more than :value items.",
                  },
                  max: {
                      numeric: ":attribute ezin da :max baino handiagoa izan.",
                      file: ":attribute-k ezin du :max kilobyte baino gehiagoko pisua euki.",
                      string: ":attribute-k ezin du :max karaktere baino gehiago euki.",
                      array: ":attribute-k ezin du :max ale baino gehiago euki.",
                  },
                  mimes: ":attribute :values motatako fitxategia izan behar da.",
                  mimetypes: ":attribute :values motatako fitxategia izan behar da.",
                  min: {
                      numeric: ":attribute-k gutxienez :min-eko tamaina izan behar du.",
                      file: ":attribute-k gutxienez :min kilobyteko pisua euki behar du.",
                      string: ":attribute-k gutxienez :min karaktere euki behar ditu.",
                      array: ":attribute-k gutxienez :min ale euki behar ditu.",
                  },
                  not_in: "Hautatutako :attribute baliogabea da.",
                  not_regex: "The :attribute format is invalid.",
                  numeric: ":attribute zenbaki bat izan behar da.",
                  present: ":attribute bertan egon behar da.",
                  regex: ":attribute-k ez dauka formatu egokirik.",
                  required: ":attribute derrigorrezkoa da.",
                  required_if: ":attribute derrigorrezkoa da :other :value denean.",
                  required_unless: ":attribute derrigorrezkoa da :other :values-en egon ezean.",
                  required_with: ":attribute derrigorrezkoa da :values bertan dagoenean.",
                  required_with_all: ":attribute derrigorrezkoa da :values bertan dagoenean.",
                  required_without: ":attribute derrigorrezkoa da :values bertan ez dagoenean.",
                  required_without_all: ":attribute derrigorrezkoa da :values bertan ez dagoenean.",
                  same: ":attribute eta :other bat etorri behar dira.",
                  size: {
                      numeric: ":attribute-k :size-eko tamaina izan behar du.",
                      file: ":attribute-k :size kilobyteko pisua euki behar du.",
                      string: ":attribute-k :size karaktere euki beha ditu.",
                      array: ":attribute-k :size ale euki behar ditu.",
                  },
                  string: ":attribute karaktere-katea izan behar da.",
                  timezone: ":attribute baliozko gunea izan behar da.",
                  unique: ":attribute jadanik erregistratua izan da.",
                  uploaded: ":attribute igotzerakoan huts egin du.",
                  url: ":attribute-k ez dauka formatu egokirik.",
              };
          },
          2927: (e) => {
              e.exports = {
                  accepted: "فیلد :attribute می بایست تایید شود",
                  alpha: "فیلد :attribute می بایست فقط شامل حروف انگلیسی باشد",
                  alpha_dash: "فیلد :attribute می بایست فقط شامل حروف انگلیسی و خط تیره و زیرخط باشد",
                  alpha_num: "فیلد :attribute می بایست فقط شامل حروف و اعداد باشد",
                  between: "فیلد :attribute می بایست بزرگتر از :min و کوچکتر از :max باشد",
                  confirmed: "تطبیق فیلد :attribute صحیح نمی باشد",
                  email: "فرمت ایمیل وارد شده در :attribute صحیح نمی‌باشد",
                  date: "تاریخ درج شده در فیلد :attribute صحیح نیست",
                  def: "فیلد :attribute اشکال دارد",
                  digits: "فیلد :attribute می بایست شامل :digits رقم باشد",
                  digits_between: ":attribute باید بین :min و :max رقم باشد.",
                  different: "فیلد :attribute می بایست مقداری غیر از :different داشته باشد",
                  in: "فیلد :attribute انتخاب شده صحیح نمی باشد",
                  integer: "فیلد :attribute می بایست عددی باشد",
                  hex: "فیلد :attribute باید در فرمت مبنای ۱۶ باشد",
                  min: { numeric: "فیلد :attribute می بایست از :min بزرگتر باشد", string: "فیلد :attribute بایستی حداقل :min کاراکتر طول داشته باشد" },
                  max: { numeric: "فیلد :attribute می بایست از :max کوچکتر باشد", string: "فیلد :attribute نباید بیشتر از :max کاراکتر طول داشته باشد" },
                  not_in: "فیلد :attribute انتخاب شده صحیح نمی باشد",
                  numeric: "فیلد :attribute می بایست عددی باشد",
                  present: "The :attribute field must be present (but can be empty).",
                  required: "فیلد :attribute الزامی است",
                  required_if: "در صورت دادن :value به :other تکمیل فیلد :attribute الزامی است",
                  same: "فیلد :attribute می بایست با فیلد :same یکی باشد",
                  size: { numeric: "فیلد :attribute می بایست :size باشد", string: "فیلد :attribute می بایست :size کاراکتر طول داشته باشد" },
                  string: "فیلد :attribute می بایست متنی باشد",
                  url: "آدرس فیلد :attribute صحیح نمی باشد",
                  regex: "فرمت آدرس :attribute صحیح نمی باشد",
                  attributes: {},
              };
          },
          6496: (e) => {
              e.exports = {
                  accepted: ":attribute on oltava hyväksytty.",
                  after: ":attribute on oltava :after jälkeen.",
                  after_or_equal: ":attribute täytyy olla sama kuin :after_or_equal tai sen jälkeen.",
                  alpha: ":attribute kenttä saa sisältää ainoastaan kirjaimia.",
                  alpha_dash: ":attribute kenttä saa sisältää ainoastaan kirjaimia tai numeroita, sekä pisteitä ja alaviivoja.",
                  alpha_num: ":attribute kenttä saa sisältää ainoastaan kirjaimia tai numeroita.",
                  before: ":attribute on oltava ennen kuin :before.",
                  before_or_equal: ":attribute on oltava sama tai ennen kuin :before_or_equal.",
                  between: ":attribute on oltava :min ja :max väliltä.",
                  confirmed: ":attribute vahvistus ei täsmää.",
                  email: ":attribute on väärässä muodossa.",
                  date: ":attribute ei ole päivämäärä.",
                  def: ":attribute sisältää virheitä.",
                  digits: ":attribute on oltava :digits numeroa pitkä.",
                  digits_between: "Kentän :attribute arvon tulee olla :min - :max numeroa.",
                  different: ":attribute ei saa olla yhtä kuin :different.",
                  in: "Valittu :attribute ei kelpaa.",
                  integer: ":attribute ei ole numero.",
                  hex: ":attribute on oltava heksadesimaali.",
                  min: { numeric: ":attribute on oltava vähintään :min.", string: ":attribute on oltava vähintään :min merkkiä pitkä." },
                  max: { numeric: ":attribute on oltava enintään :max.", string: ":attribute on oltava enintään :max merkkiä pitkä." },
                  not_in: "Valittu :attribute ei kelpaa.",
                  numeric: ":attribute on oltava numero.",
                  present: ":attribute kenttä on oltava (mutta saa olla tyhjä).",
                  required: ":attribute kenttä on pakollinen.",
                  required_if: ":attribute kenttä on pakollinen, jos kenttä :other on :value.",
                  required_unless: ":attribute kenttä on pakollinen, jos kenttä :other ei ole :value.",
                  required_with: ":attribute kenttä on pakollinen, jos kenttä :field ei ole tyhjä.",
                  required_with_all: ":attribute kenttä on pakollinen, jos kentät :fields eivät ole tyhjiä.",
                  required_without: ":attribute kenttä on pakollinen, jos kenttä :field on tyhjä.",
                  required_without_all: ":attribute kenttä on pakollinen, jos kentät :fields ovat tyhjiä.",
                  same: ":attribute ja :same on oltava samat.",
                  size: { numeric: ":attribute on oltava :size.", string: ":attribute on oltava :size merkkiä pitkä." },
                  string: ":attribute on oltava merkkijono.",
                  url: ":attribute on väärässä muodossa.",
                  regex: ":attribute on väärässä muodossa.",
                  attributes: {},
              };
          },
          8899: (e) => {
              e.exports = {
                  accepted: "Le champ :attribute doit être accepté.",
                  alpha: "Le champ :attribute ne peut contenir que des caractères alphabétiques.",
                  alpha_dash: "Le champ :attribute ne peut contenir que des caractères alphanumériques, des tirets et des underscores.",
                  alpha_num: "Le champ :attribute ne peut contenir que des caractères alphanumériques.",
                  between: "La longueur du champ :attribute doit être comprise entre :min and :max.",
                  confirmed: "Le champ :attribute n'est pas confirmé.",
                  email: "Le champ :attribute contient un format invalide.",
                  def: "Le champ :attribute contient un attribut erroné.",
                  digits: "Le champ :attribute doit être composé de :digits chiffres.",
                  digits_between: "Le champ :attribute doit contenir entre :min et :max chiffres.",
                  different: "Les champs :attribute et :different doivent être différents.",
                  in: "Le champ :attribute est invalide.",
                  integer: "Le champ :attribute doit être un entier.",
                  hex: "Le champ :attribute doit être au format hexadécimal.",
                  min: { numeric: "Le champ :attribute doit être supérieur à :min.", string: "Le champ :attribute doit contenir plus de :min caractères." },
                  max: { numeric: "Le champ :attribute doit être inférieur à :max.", string: "Le champ :attribute doit contenir moins de :max caractères." },
                  not_in: "Le champ :attribute est invalide.",
                  numeric: "Le champ :attribute doit être un chiffre.",
                  present: "Le champ :attribute doit être présent (mais peut être vide).",
                  required: "Le champ :attribute est requis.",
                  required_if: "Le champ :attribute est requis quand :other est :value.",
                  same: "Les champs :attribute et :same doivent correspondre.",
                  size: { numeric: "Le champ :attribute doit être égal à :size.", string: "Le champ :attribute doit contenir :size caractères." },
                  url: "Le format du champ :attribute est invalide.",
                  regex: "Le format du champ :attribute est invalide.",
                  attributes: {},
              };
          },
          7494: (e) => {
              e.exports = {
                  accepted: "Polje :attribute mora biti prihvaćeno.",
                  active_url: "Polje :attribute nije ispravan URL.",
                  after: "Polje :attribute mora biti datum nakon :date.",
                  after_or_equal: "Polje :attribute mora biti datum veći ili jednak :date.",
                  alpha: "Polje :attribute smije sadržavati samo slova.",
                  alpha_dash: "Polje :attribute smije sadržavati samo slova, brojeve i crtice.",
                  alpha_num: "Polje :attribute smije sadržavati samo slova i brojeve.",
                  attributes: {},
                  array: "Polje :attribute mora biti niz.",
                  before: "Polje :attribute mora biti datum prije :date.",
                  before_or_equal: "Polje :attribute mora biti datum manji ili jednak :date.",
                  between: {
                      numeric: "Polje :attribute mora biti između :min - :max.",
                      file: "Polje :attribute mora biti između :min - :max kilobajta.",
                      string: "Polje :attribute mora biti između :min - :max znakova.",
                      array: "Polje :attribute mora imati između :min - :max stavki.",
                  },
                  boolean: "Polje :attribute mora biti false ili true.",
                  confirmed: "Potvrda polja :attribute se ne podudara.",
                  date: "Polje :attribute nije ispravan datum.",
                  date_format: "Polje :attribute ne podudara s formatom :format.",
                  different: "Polja :attribute i :other moraju biti različita.",
                  digits: "Polje :attribute mora sadržavati :digits znamenki.",
                  digits_between: "Polje :attribute mora imati između :min i :max znamenki.",
                  dimensions: "Polje :attribute ima neispravne dimenzije slike.",
                  distinct: "Polje :attribute ima dupliciranu vrijednost.",
                  email: "Polje :attribute mora biti ispravna e-mail adresa.",
                  exists: "Odabrano polje :attribute nije ispravno.",
                  file: "Polje :attribute mora biti datoteka.",
                  filled: "Polje :attribute je obavezno.",
                  gt: {
                      numeric: "Polje :attribute mora biti veće od :value.",
                      file: "Polje :attribute mora biti veće od :value kilobajta.",
                      string: "Polje :attribute mora biti veće od :value karaktera.",
                      array: "Polje :attribute mora biti veće od :value stavki.",
                  },
                  gte: {
                      numeric: "Polje :attribute mora biti veće ili jednako :value.",
                      file: "Polje :attribute mora biti veće ili jednako :value kilobajta.",
                      string: "Polje :attribute mora biti veće ili jednako :value znakova.",
                      array: "Polje :attribute mora imati :value stavki ili više.",
                  },
                  hex: "The :attribute field should have hexadecimal format",
                  image: "Polje :attribute mora biti slika.",
                  in: "Odabrano polje :attribute nije ispravno.",
                  in_array: "Polje :attribute ne postoji u :other.",
                  integer: "Polje :attribute mora biti broj.",
                  ip: "Polje :attribute mora biti ispravna IP adresa.",
                  ipv4: "Polje :attribute mora biti ispravna IPv4 adresa.",
                  ipv6: "Polje :attribute mora biti ispravna IPv6 adresa.",
                  json: "Polje :attribute mora biti ispravan JSON string.",
                  lt: {
                      numeric: "Polje :attribute mora biti manje od :value.",
                      file: "Polje :attribute mora biti manje od :value kilobajta.",
                      string: "Polje :attribute mora biti manje od :value znakova.",
                      array: "Polje :attribute mora biti manje od :value stavki.",
                  },
                  lte: {
                      numeric: "Polje :attribute mora biti manje ili jednako :value.",
                      file: "Polje :attribute mora biti manje ili jednako :value kilobajta.",
                      string: "Polje :attribute mora biti manje ili jednako :value znakova.",
                      array: "Polje :attribute ne smije imati više od :value stavki.",
                  },
                  max: {
                      numeric: "Polje :attribute mora biti manje od :max.",
                      file: "Polje :attribute mora biti manje od :max kilobajta.",
                      string: "Polje :attribute mora sadržavati manje od :max znakova.",
                      array: "Polje :attribute ne smije imati više od :max stavki.",
                  },
                  mimes: "Polje :attribute mora biti datoteka tipa: :values.",
                  mimetypes: "Polje :attribute mora biti datoteka tipa: :values.",
                  min: {
                      numeric: "Polje :attribute mora biti najmanje :min.",
                      file: "Polje :attribute mora biti najmanje :min kilobajta.",
                      string: "Polje :attribute mora sadržavati najmanje :min znakova.",
                      array: "Polje :attribute mora sadržavati najmanje :min stavki.",
                  },
                  not_in: "Odabrano polje :attribute nije ispravno.",
                  not_regex: "Format polja :attribute je neispravan.",
                  numeric: "Polje :attribute mora biti broj.",
                  present: "Polje :attribute mora biti prisutno.",
                  regex: "Polje :attribute se ne podudara s formatom.",
                  required: "Polje :attribute je obavezno.",
                  required_if: "Polje :attribute je obavezno kada polje :other sadrži :value.",
                  required_unless: "Polje :attribute je obavezno osim :other je u :values.",
                  required_with: "Polje :attribute je obavezno kada postoji polje :values.",
                  required_with_all: "Polje :attribute je obavezno kada postje polja :values.",
                  required_without: "Polje :attribute je obavezno kada ne postoji polje :values.",
                  required_without_all: "Polje :attribute je obavezno kada nijedno od polja :values ne postoji.",
                  same: "Polja :attribute i :other se moraju podudarati.",
                  size: { numeric: "Polje :attribute mora biti :size.", file: "Polje :attribute mora biti :size kilobajta.", string: "Polje :attribute mora biti :size znakova.", array: "Polje :attribute mora sadržavati :size stavki." },
                  string: "Polje :attribute mora biti string.",
                  timezone: "Polje :attribute mora biti ispravna vremenska zona.",
                  unique: "Polje :attribute već postoji.",
                  uploaded: "Polje :attribute nije uspešno učitano.",
                  url: "Polje :attribute nije ispravnog formata.",
              };
          },
          8789: (e) => {
              e.exports = {
                  accepted: "A(z) :attribute el kell legyen fogadva!",
                  active_url: "A(z) :attribute nem érvényes url!",
                  after: "A(z) :attribute :date utáni dátum kell, hogy legyen!",
                  after_or_equal: "A(z) :attribute nem lehet korábbi dátum, mint :date!",
                  alpha: "A(z) :attribute kizárólag betűket tartalmazhat!",
                  alpha_dash: "A(z) :attribute kizárólag betűket, számokat és kötőjeleket tartalmazhat!",
                  alpha_num: "A(z) :attribute kizárólag betűket és számokat tartalmazhat!",
                  attributes: {},
                  array: "A(z) :attribute egy tömb kell, hogy legyen!",
                  before: "A(z) :attribute :date előtti dátum kell, hogy legyen!",
                  before_or_equal: "A(z) :attribute nem lehet későbbi dátum, mint :date!",
                  between: {
                      numeric: "A(z) :attribute :min és :max közötti szám kell, hogy legyen!",
                      file: "A(z) :attribute mérete :min és :max kilobájt között kell, hogy legyen!",
                      string: "A(z) :attribute hossza :min és :max karakter között kell, hogy legyen!",
                      array: "A(z) :attribute :min - :max közötti elemet kell, hogy tartalmazzon!",
                  },
                  boolean: "A(z) :attribute mező csak true vagy false értéket kaphat!",
                  confirmed: "A(z) :attribute nem egyezik a megerősítéssel.",
                  date: "A(z) :attribute nem érvényes dátum.",
                  date_format: "A(z) :attribute nem egyezik az alábbi dátum formátummal :format!",
                  different: "A(z) :attribute és :other értékei különbözőek kell, hogy legyenek!",
                  digits: "A(z) :attribute :digits számjegyű kell, hogy legyen!",
                  digits_between: "A(z) :attribute értéke :min és :max közötti számjegy lehet!",
                  dimensions: "A(z) :attribute felbontása nem megfelelő.",
                  distinct: "A(z) :attribute értékének egyedinek kell lennie!",
                  email: "A(z) :attribute nem érvényes email formátum.",
                  exists: "A(z) :attribute már létezik.",
                  file: "A(z) :attribute fájl kell, hogy legyen!",
                  filled: "A(z) :attribute megadása kötelező!",
                  gt: {
                      numeric: "A(z) :attribute nagyobb kell, hogy legyen, mint :value!",
                      file: "A(z) :attribute mérete nagyobb kell, hogy legyen, mint :value kilobájt.",
                      string: "A(z) :attribute hosszabb kell, hogy legyen, mint :value karakter.",
                      array: "A(z) :attribute több, mint :value elemet kell, hogy tartalmazzon.",
                  },
                  gte: {
                      numeric: "A(z) :attribute nagyobb vagy egyenlő kell, hogy legyen, mint :value!",
                      file: "A(z) :attribute mérete nem lehet kevesebb, mint :value kilobájt.",
                      string: "A(z) :attribute hossza nem lehet kevesebb, mint :value karakter.",
                      array: "A(z) :attribute legalább :value elemet kell, hogy tartalmazzon.",
                  },
                  hex: "The :attribute field should have hexadecimal format",
                  image: "A(z) :attribute képfájl kell, hogy legyen!",
                  in: "A kiválasztott :attribute érvénytelen.",
                  in_array: "A(z) :attribute értéke nem található a(z) :other értékek között.",
                  integer: "A(z) :attribute értéke szám kell, hogy legyen!",
                  ip: "A(z) :attribute érvényes IP cím kell, hogy legyen!",
                  ipv4: "A(z) :attribute érvényes IPv4 cím kell, hogy legyen!",
                  ipv6: "A(z) :attribute érvényes IPv6 cím kell, hogy legyen!",
                  json: "A(z) :attribute érvényes JSON szöveg kell, hogy legyen!",
                  lt: {
                      numeric: "A(z) :attribute kisebb kell, hogy legyen, mint :value!",
                      file: "A(z) :attribute mérete kisebb kell, hogy legyen, mint :value kilobájt.",
                      string: "A(z) :attribute rövidebb kell, hogy legyen, mint :value karakter.",
                      array: "A(z) :attribute kevesebb, mint :value elemet kell, hogy tartalmazzon.",
                  },
                  lte: {
                      numeric: "A(z) :attribute kisebb vagy egyenlő kell, hogy legyen, mint :value!",
                      file: "A(z) :attribute mérete nem lehet több, mint :value kilobájt.",
                      string: "A(z) :attribute hossza nem lehet több, mint :value karakter.",
                      array: "A(z) :attribute legfeljebb :value elemet kell, hogy tartalmazzon.",
                  },
                  max: {
                      numeric: "A(z) :attribute értéke nem lehet nagyobb, mint :max!",
                      file: "A(z) :attribute mérete nem lehet több, mint :max kilobájt.",
                      string: "A(z) :attribute hossza nem lehet több, mint :max karakter.",
                      array: "A(z) :attribute legfeljebb :max elemet kell, hogy tartalmazzon.",
                  },
                  mimes: "A(z) :attribute kizárólag az alábbi fájlformátumok egyike lehet: :values.",
                  mimetypes: "A(z) :attribute kizárólag az alábbi fájlformátumok egyike lehet: :values.",
                  min: {
                      numeric: "A(z) :attribute értéke nem lehet kisebb, mint :min!",
                      file: "A(z) :attribute mérete nem lehet kevesebb, mint :min kilobájt.",
                      string: "A(z) :attribute hossza nem lehet kevesebb, mint :min karakter.",
                      array: "A(z) :attribute legalább :min elemet kell, hogy tartalmazzon.",
                  },
                  not_in: "A(z) :attribute értéke érvénytelen.",
                  not_regex: "A(z) :attribute formátuma érvénytelen.",
                  numeric: "A(z) :attribute szám kell, hogy legyen!",
                  present: "A(z) :attribute mező nem található!",
                  regex: "A(z) :attribute formátuma érvénytelen.",
                  required: "A(z) :attribute megadása kötelező!",
                  required_if: "A(z) :attribute megadása kötelező, ha a(z) :other értéke :value!",
                  required_unless: "A(z) :attribute megadása kötelező, ha a(z) :other értéke nem :values!",
                  required_with: "A(z) :attribute megadása kötelező, ha a(z) :values érték létezik.",
                  required_with_all: "A(z) :attribute megadása kötelező, ha a(z) :values értékek léteznek.",
                  required_without: "A(z) :attribute megadása kötelező, ha a(z) :values érték nem létezik.",
                  required_without_all: "A(z) :attribute megadása kötelező, ha egyik :values érték sem létezik.",
                  same: "A(z) :attribute és :other mezőknek egyezniük kell!",
                  size: {
                      numeric: "A(z) :attribute értéke :size kell, hogy legyen!",
                      file: "A(z) :attribute mérete :size kilobájt kell, hogy legyen!",
                      string: "A(z) :attribute hossza :size karakter kell, hogy legyen!",
                      array: "A(z) :attribute :size elemet kell tartalmazzon!",
                  },
                  string: "A(z) :attribute szöveg kell, hogy legyen.",
                  timezone: "A(z) :attribute nem létező időzona.",
                  unique: "A(z) :attribute már foglalt.",
                  uploaded: "A(z) :attribute feltöltése sikertelen.",
                  url: "A(z) :attribute érvénytelen link.",
              };
          },
          2846: (e) => {
              e.exports = {
                  accepted: ":attribute harus disetujui.",
                  after: ":attribute harus setelah :after.",
                  after_or_equal: ":attribute harus sama dengan atau setelah :after_or_equal.",
                  alpha: ":attribute hanya boleh berisi huruf.",
                  alpha_dash: ":attribute hanya boleh berisi huruf, - atau _.",
                  alpha_num: ":attribute hanya boleh berisi huruf dan angka.",
                  before: ":attribute harus sebelum :before.",
                  before_or_equal: ":attribute harus sama dengan atau sebelum :before_or_equal.",
                  between: ":attribute harus berisi antara :min dan :max.",
                  confirmed: ":attribute konfirmasi tidak sama.",
                  email: ":attribute harus berupa email.",
                  date: ":attribute format tanggal tidak benar.",
                  def: ":attribute attribute has errors.",
                  digits: ":attribute harus :digits digit.",
                  digits_between: "Isian :attribute harus antara angka :min dan :max.",
                  different: ":attribute dan :different harus berbeda.",
                  in: ":attribute tidak benar.",
                  integer: ":attribute harus berupa angka.",
                  hex: ":attribute harus berformat heksadesimal",
                  min: { numeric: ":attribute minimal :min.", string: ":attribute minimal :min karakter." },
                  max: { numeric: ":attribute harus lebih kecil :max.", string: ":attribute maksimal :max karakter." },
                  not_in: ":attribute tidak benar.",
                  numeric: ":attribute harus berupa angka.",
                  present: ":attribute harus ada (tapi boleh kosong).",
                  required: ":attribute tidak boleh kosong.",
                  required_if: ":attribute harus di isi jika :other berisi :value.",
                  required_unless: ":attribute harus di isi jika :other tidak berisi :value.",
                  required_with: ":attribute harus di isi jika :field tidak kosong.",
                  required_with_all: ":attribute harus di isi jika :fields tidak kosong.",
                  required_without: ":attribute harus di isi jika :field kosong.",
                  required_without_all: ":attribute harus di isi jika :fields kosong.",
                  same: ":attribute dan :same harus sama.",
                  size: { numeric: ":attribute harus berisi :size.", string: ":attribute harus berisi :size karakter." },
                  string: ":attribute harus berupa string.",
                  url: ":attribute harus berupa format url.",
                  regex: ":attribute format tidak benar.",
                  attributes: {},
              };
          },
          830: (e) => {
              e.exports = {
                  accepted: "Il campo :attribute deve essere accettato.",
                  alpha: "Il campo :attribute deve contenere sono caratteri alfabetici.",
                  alpha_dash: "Il campo :attribute può contenere solo caratteri alfanumerici oltre a trattini e trattini bassi.",
                  alpha_num: "Il campo :attribute deve essere alfanumerico.",
                  between: "Il campo :attribute deve essere compreso tra :min e :max.",
                  confirmed: "Il campo conferma :attribute non è uguale.",
                  email: "Il formato dell'attributo :attribute non è valido.",
                  def: "Gli attributi del campo :attribute contengono degli errori.",
                  digits: "Il campo :attribute deve essere di :digits cifre.",
                  digits_between: "Il campo :attribute deve essere tra :min e :max cifre.",
                  different: "Il campo :attribute e :different devo essere diversi.",
                  in: "Il valore del campo :attribute non è valido.",
                  integer: "Il campo :attribute deve essere un valore intero.",
                  hex: "Il campo :attribute deve essere in formato esadecimale",
                  min: { numeric: "Il campo :attribute deve essere maggiore o uguale di :min.", string: "Il campo :attribute deve essere composto da almeno :min caratteri." },
                  max: { numeric: "Il campo :attribute deve essere minore o uguale di :max.", string: "Il campo :attribute deve essere composto da massimo :max caratteri." },
                  not_in: "Il campo :attribute non è valido.",
                  numeric: "Il campo :attribute deve essere un numero.",
                  present: "Il campo :attribute deve essere presente (ma può essere vuoto).",
                  required: "Il campo :attribute è richiesto.",
                  required_if: "Il campo :attribute è richiesto quando il campo :other è uguale a :value.",
                  same: "I campi :attribute e :same devono essere uguali.",
                  size: { numeric: "La dimensione del campo :attribute deve essere uguale a :size.", string: "Il campo :attribute deve essere di :size caratteri." },
                  string: "Il campo :attribute deve essere una stringa.",
                  url: "Il formato del campo :attribute non è valido.",
                  regex: "Il formato del campo :attribute non è valido.",
                  attributes: {},
              };
          },
          8938: (e) => {
              e.exports = {
                  accepted: ":attributeを確認してください。",
                  after: ":attributeは:afterより後の日付を入力してください。",
                  after_or_equal: ":attributeは:after_or_equal以降の日付を入力してください。",
                  alpha: ":attributeは英字のみで入力してください。",
                  alpha_dash: ":attributeは英字とダッシュと下線のみで入力してください。",
                  alpha_num: ":attributeは英数字のみで入力してください。",
                  before: ":attributeは:beforeより前の日付を入力してください。",
                  before_or_equal: ":attributeは:before_or_equal以前の日付を入力してください。",
                  between: { numeric: ":attributeは:min〜:maxの間で指定してください", string: ":attributeは:min〜:max文字を入力してください" },
                  confirmed: ":attributeは確認が一致しません。",
                  email: ":attributeは正しいメールアドレスを入力してください。",
                  date: ":attributeは正しい日付形式を入力してください",
                  def: ":attributeは検証エラーが含まれています。",
                  digits: ":attributeは:digitsの数字のみで入力してください。",
                  digits_between: ":attributeは、:min桁から:max桁にしてください。",
                  different: ":attributeと:differentは同じであってはなりません。",
                  in: "選択された:attributeは無効です。",
                  integer: ":attributeは整数で入力してください。",
                  hex: ":attributeは16進数で入力してください。",
                  min: { numeric: ":attributeは:min以上で入力してください。", string: ":attributeは:min文字以上で入力してください。" },
                  max: { numeric: ":attributeは:max以下で入力してください。", string: ":attributeは:max文字以下で入力してください。" },
                  not_in: "選択された:attributeは無効です。",
                  numeric: ":attributeは数値で入力してください。",
                  present: ":attributeを入力してください（空欄も可能です）。",
                  required: ":attributeは必須です。",
                  required_if: ":otherは:valueになったら:attributeは必須です。",
                  required_unless: ":otherが:valueでなければ:attributeは必須です。",
                  required_with: ":fieldが空欄でなければ:attributeは必須です。",
                  required_with_all: ":fieldsが空欄でなければ:attributeは必須です。",
                  required_without: ":fieldが空欄なら:attributeは必須です。",
                  required_without_all: ":fieldsが空欄なら:attributeは必須です。",
                  same: ":attributeと:sameは同じでなければなりません。",
                  size: { numeric: ":attributeは:sizeを入力してください。", string: ":attributeは:size文字で入力してください。" },
                  string: ":attributeは文字のみで入力してください。",
                  url: ":attributeは正しいURIを入力してください。",
                  regex: ":attributeの値はパターンにマッチする必要があります。",
                  attributes: {},
              };
          },
          3330: (e) => {
              e.exports = {
                  accepted: ":attribute უნდა იყოს მონიშნული.",
                  active_url: ":attribute უნდა იყოს URL მისამართი.",
                  after: ":attribute უნდა იყოს :date-ის შემდეგ.",
                  after_or_equal: ":attribute უნდა იყოს :date-ის შემდეგ ან მისი ტოლი.",
                  alpha: ":attribute უნდა შეიცავდეს მხოლოდ ასოებს.",
                  alpha_dash: ":attribute უნდა შეიცავდეს მხოლოდ ასოებს, რიცხვებს და ტირეებს.",
                  alpha_num: ":attribute უნდა შეიცავდეს მხოლოდ ასოებს და რიცხვებს.",
                  attributes: {},
                  array: ":attribute უნდა იყოს მასივი.",
                  before: ":attribute უნდა იყოს :date-მდე.",
                  before_or_equal: ":attribute უნდა იყოს :date-მდე ან მისი ტოლი.",
                  between: {
                      numeric: ":attribute უნდა იყოს :min-სა და :max-ს შორის.",
                      file: ":attribute უნდა იყოს :min-სა და :max კილობაიტს შორის.",
                      string: ":attribute უნდა იყოს :min-სა და :max სიმბოლოს შორის.",
                      array: ":attribute-ის რაოდენობა უნდა იყოს :min-დან :max-მდე.",
                  },
                  boolean: ":attribute უნდა იყოს true, false, 0 ან 1.",
                  confirmed: ":attribute არ ემთხვევა დადასტურებას.",
                  date: ":attribute შეიცავს თარიღის არასწორ ფორმატს.",
                  date_format: ":attribute არ ემთხვევა თარიღის ფორმატს: :format.",
                  different: ":attribute და :other არ უნდა ემთხვეოდეს ერთმანეთს.",
                  digits: ":attribute უნდა შედგებოდეს :digits ციფრისგან.",
                  digits_between: ":attribute უნდა შედგებოდეს :min-დან :max ციფრამბდე.",
                  dimensions: ":attribute შეიცავს სურათის არასწორ ზომებს.",
                  distinct: ":attribute უნდა იყოს უნიკალური.",
                  email: ":attribute უნდა იყოს სწორი ელ.ფოსტა.",
                  exists: "ასეთი :attribute არ არსებობს.",
                  file: ":attribute უნდა იყოს ფაილი.",
                  filled: ":attribute აუცილებელია.",
                  gt: {
                      numeric: ":attribute უნდა იყოს :value-ზე მეტი.",
                      file: ":attribute უნდა იყოს :value კილობაიტზე მეტი.",
                      string: ":attribute უნდა შეიცავდეს :value სიმბოლოზე მეტს.",
                      array: ":attribute უნდა შეიცავლდეს :value ელემენტზე მეტს.",
                  },
                  gte: {
                      numeric: ":attribute უნდა იყოს მინიმუმ :value.",
                      file: ":attribute უნდა იყოს მინიმუმ :value კილობაიტი.",
                      string: ":attribute უნდა შეიცავდეს მინიმუმ :value სიმბოლოს.",
                      array: ":attribute უნდა შეიცავდეს მინიმუმ :value ელემენტს.",
                  },
                  hex: "The :attribute field should have hexadecimal format",
                  image: ":attribute უნდა იყოს სურათი.",
                  in: "მითითებული :attribute არასწორია.",
                  in_array: ":attribute უნდა არსებობდეს :other-ში.",
                  integer: ":attribute უნდა იყოს მთელი რიცხვი.",
                  ip: ":attribute უნდა იყოს IP მისამართი.",
                  ipv4: ":attribute უნდა იყოს IPv4 მისამართი.",
                  ipv6: ":attribute უნდა იყოს IPv6 მისამართი.",
                  json: ":attribute უნდა იყოს JSON ტიპის.",
                  lt: {
                      numeric: ":attribute უნდა იყოს :value-ზე ნაკლები.",
                      file: ":attribute უნდა იყოს :value კილობაიტზე ნაკლები.",
                      string: ":attribute უნდა შეიცავდეს :value სიმბოლოზე ნაკლებს.",
                      array: ":attribute უნდა შეიცავლდეს :value ელემენტზე ნაკლებს.",
                  },
                  lte: {
                      numeric: ":attribute უნდა იყოს მაქსიმუმ :value.",
                      file: ":attribute უნდა იყოს მაქსიმუმ :value კილობაიტი.",
                      string: ":attribute უნდა შეიცავდეს მაქსიმუმ :value სიმბოლოს.",
                      array: ":attribute უნდა შეიცავდეს მაქსიმუმ :value ელემენტს.",
                  },
                  max: {
                      numeric: ":attribute არ უნდა აღემატებოდეს :max-ს.",
                      file: ":attribute არ უნდა აღემატებოდეს :max კილობაიტს.",
                      string: ":attribute არ უნდა აღემატებოდეს :max სიმბოლოს.",
                      array: ":attribute-ის რაოდენობა არ უნდა აღემატებოდეს :max-ს.",
                  },
                  mimes: ":attribute უნდა იყოს შემდეგი ტიპის: :values.",
                  mimetypes: ":attribute უნდა იყოს შემდეგი ტიპის: :values.",
                  min: { numeric: ":attribute უნდა იყოს მინიმუმ :min.", file: ":attribute უნდა იყოს მინიმუმ :min კილობაიტი.", string: ":attribute უნდა შეიცავდეს მინიმუმ :min სიმბოლოს.", array: ":attribute უნდა იყოს მინიმუმ :min." },
                  not_in: "მითითებული :attribute არასწორია.",
                  not_regex: ":attribute არასწორ ფორმატშია.",
                  numeric: ":attribute უნდა იყოს რიცხვი.",
                  present: ":attribute უნდა არსებობდეს, თუნდაც ცარიელი.",
                  regex: ":attribute არ ემთხვევა ფორმატს.",
                  required: ":attribute აუცილებელია.",
                  required_if: ":attribute აუცილებელია, თუ :other-ის მნიშვნელობა ემთხვევა :value-ს.",
                  required_unless: ":attribute აუცილებელია, თუ :values არ შეიცავს :other-ს.",
                  required_with: ":attribute აუცილებელია, თუ :values მითითებულია.",
                  required_with_all: ":attribute აუცილებელია, თუ :values მითითებულია.",
                  required_without: ":attribute აუცილებელია, თუ :values არ არის მითითებული.",
                  required_without_all: ":attribute აუცილებელია, თუ :values არ არის მითითებული.",
                  same: ":attribute და :other უნდა ემთხვეოდეს ერთმანეთს.",
                  size: { numeric: ":attribute უნდა იყოს :size-ის ტოლი.", file: ":attribute უნდა იყოს :size კილობაიტი.", string: ":attribute უნდა შედგებოდეს :size სიმბოლოსგან.", array: ":attribute უნდა შეიცავდეს :size ელემენტს." },
                  string: ":attribute უნდა იყოს ტექსტი.",
                  timezone: ":attribute უნდა იყოს სასაათო სარტყელი.",
                  unique: "ასეთი :attribute უკვე არსებობს.",
                  uploaded: ":attribute-ის ატვირთვა ვერ მოხერხდა.",
                  url: ":attribute უნდა იყოს URL მისამართი.",
              };
          },
          646: (e) => {
              e.exports = {
                  accepted: ":attribute을(를) 동의해야 합니다.",
                  active_url: ":attribute은(는) 유효한 URL이 아닙니다.",
                  after: ":attribute은(는) :date 이후 날짜여야 합니다.",
                  after_or_equal: ":attribute은(는) :date 이후 날짜이거나 같은 날짜여야 합니다.",
                  alpha: ":attribute은(는) 문자만 포함할 수 있습니다.",
                  alpha_dash: ":attribute은(는) 문자, 숫자, 대쉬(-)만 포함할 수 있습니다.",
                  alpha_num: ":attribute은(는) 문자와 숫자만 포함할 수 있습니다.",
                  attributes: {},
                  array: ":attribute은(는) 배열이어야 합니다.",
                  before: ":attribute은(는) :date 이전 날짜여야 합니다.",
                  before_or_equal: ":attribute은(는) :date 이전 날짜이거나 같은 날짜여야 합니다.",
                  between: {
                      numeric: ":attribute은(는) :min에서 :max 사이여야 합니다.",
                      file: ":attribute은(는) :min에서 :max 킬로바이트 사이여야 합니다.",
                      string: ":attribute은(는) :min에서 :max 문자 사이여야 합니다.",
                      array: ":attribute은(는) :min에서 :max 개의 항목이 있어야 합니다.",
                  },
                  boolean: ":attribute은(는) true 또는 false 이어야 합니다.",
                  confirmed: ":attribute 확인 항목이 일치하지 않습니다.",
                  date: ":attribute은(는) 유효한 날짜가 아닙니다.",
                  date_format: ":attribute이(가) :format 형식과 일치하지 않습니다.",
                  different: ":attribute와(과) :other은(는) 서로 달라야 합니다.",
                  digits: ":attribute은(는) :digits 자리 숫자여야 합니다.",
                  digits_between: ":attribute)은(는) :min에서 :max 자리 사이여야 합니다.",
                  dimensions: ":attribute은(는) 유효하지 않는 이미지 크기입니다.",
                  distinct: ":attribute 필드에 중복된 값이 있습니다.",
                  email: ":attribute은(는) 유효한 이메일 주소여야 합니다.",
                  exists: "선택된 :attribute은(는) 유효하지 않습니다.",
                  file: ":attribute은(는) 파일이어야 합니다.",
                  filled: ":attribute 필드는 값이 있어야 합니다.",
                  gt: {
                      numeric: ":attribute의 값은 :value보다 커야 합니다.",
                      file: ":attribute의 용량은 :value킬로바이트보다 커야 합니다.",
                      string: ":attribute의 길이는 :value보다 길어야 합니다.",
                      array: ":attribute의 항목수는 :value개 보다 많아야 합니다.",
                  },
                  gte: {
                      numeric: ":attribute의 값은 :value보다 같거나 커야 합니다.",
                      file: ":attribute의 용량은 :value킬로바이트보다 같거나 커야 합니다.",
                      string: ":attribute의 길이는 :value보다 같거나 길어야 합니다.",
                      array: ":attribute의 항목수는 :value개 보다 같거나 많아야 합니다.",
                  },
                  hex: "The :attribute field should have hexadecimal format",
                  image: ":attribute은(는) 이미지여야 합니다.",
                  in: "선택된 :attribute은(는) 유효하지 않습니다.",
                  in_array: ":attribute 필드는 :other에 존재하지 않습니다.",
                  integer: ":attribute은(는) 정수여야 합니다.",
                  ip: ":attribute은(는) 유효한 IP 주소여야 합니다.",
                  ipv4: ":attribute은(는) 유효한 IPv4 주소여야 합니다.",
                  ipv6: ":attribute은(는) 유효한 IPv6 주소여야 합니다.",
                  json: ":attribute은(는) JSON 문자열이어야 합니다.",
                  lt: {
                      numeric: ":attribute의 값은 :value보다 작아야 합니다.",
                      file: ":attribute의 용량은 :value킬로바이트보다 작아야 합니다.",
                      string: ":attribute의 길이는 :value보다 짧아야 합니다.",
                      array: ":attribute의 항목수는 :value개 보다 작아야 합니다.",
                  },
                  lte: {
                      numeric: ":attribute의 값은 :value보다 같거나 작아야 합니다.",
                      file: ":attribute의 용량은 :value킬로바이트보다 같거나 작아야 합니다.",
                      string: ":attribute의 길이는 :value보다 같거나 짧아야 합니다.",
                      array: ":attribute의 항목수는 :value개 보다 같거나 작아야 합니다.",
                  },
                  max: {
                      numeric: ":attribute은(는) :max보다 클 수 없습니다.",
                      file: ":attribute은(는) :max킬로바이트보다 클 수 없습니다.",
                      string: ":attribute은(는) :max자보다 클 수 없습니다.",
                      array: ":attribute은(는) :max개보다 많을 수 없습니다.",
                  },
                  mimes: ":attribute은(는) 다음의 파일 형식이어야 합니다: :values.",
                  mimetypes: ":attribute은(는) 다음의 파일 형식이어야 합니다: :values.",
                  min: {
                      numeric: ":attribute은(는) 최소한 :min이어야 합니다.",
                      file: ":attribute은(는) 최소한 :min킬로바이트이어야 합니다.",
                      string: ":attribute은(는) 최소한 :min자이어야 합니다.",
                      array: ":attribute은(는) 최소한 :min개의 항목이 있어야 합니다.",
                  },
                  not_in: "선택된 :attribute이(가) 유효하지 않습니다.",
                  not_regex: ":attribute의 형식이 올바르지 않습니다.",
                  numeric: ":attribute은(는) 숫자여야 합니다.",
                  present: ":attribute 필드가 있어야 합니다.",
                  regex: ":attribute 형식이 유효하지 않습니다.",
                  required: ":attribute 필드는 필수입니다.",
                  required_if: ":other이(가) :value 일 때 :attribute 필드는 필수입니다.",
                  required_unless: ":other이(가) :value에 없다면 :attribute 필드는 필수입니다.",
                  required_with: ":values이(가) 있는 경우 :attribute 필드는 필수입니다.",
                  required_with_all: ":values이(가) 모두 있는 경우 :attribute 필드는 필수입니다.",
                  required_without: ":values이(가) 없는 경우 :attribute 필드는 필수입니다.",
                  required_without_all: ":values이(가) 모두 없는 경우 :attribute 필드는 필수입니다.",
                  same: ":attribute와(과) :other은(는) 일치해야 합니다.",
                  size: {
                      numeric: ":attribute은(는) :size (이)여야 합니다.",
                      file: ":attribute은(는) :size킬로바이트여야 합니다.",
                      string: ":attribute은(는) :size자여야 합니다.",
                      array: ":attribute은(는) :size개의 항목을 포함해야 합니다.",
                  },
                  string: ":attribute은(는) 문자열이어야 합니다.",
                  timezone: ":attribute은(는) 올바른 시간대 이어야 합니다.",
                  unique: ":attribute은(는) 이미 사용 중입니다.",
                  uploaded: ":attribute을(를) 업로드하지 못했습니다.",
                  url: ":attribute 형식은 유효하지 않습니다.",
              };
          },
          3772: (e) => {
              e.exports = {
                  accepted: "Laukas :attribute turi būti priimtas.",
                  active_url: "Laukas :attribute nėra galiojantis internetinis adresas.",
                  after: "Lauko :attribute reikšmė turi būti po :date datos.",
                  after_or_equal: "The :attribute must be a date after or equal to :date.",
                  alpha: "Laukas :attribute gali turėti tik raides.",
                  alpha_dash: "Laukas :attribute gali turėti tik raides, skaičius ir brūkšnelius.",
                  alpha_num: "Laukas :attribute gali turėti tik raides ir skaičius.",
                  attributes: {},
                  array: "Laukas :attribute turi būti masyvas.",
                  before: "Laukas :attribute turi būti data prieš :date.",
                  before_or_equal: "The :attribute must be a date before or equal to :date.",
                  between: {
                      numeric: "Lauko :attribute reikšmė turi būti tarp :min ir :max.",
                      file: "Failo dydis lauke :attribute turi būti tarp :min ir :max kilobaitų.",
                      string: "Simbolių skaičius lauke :attribute turi būti tarp :min ir :max.",
                      array: "Elementų skaičius lauke :attribute turi turėti nuo :min iki :max.",
                  },
                  boolean: "Lauko reikšmė :attribute turi būti 'taip' arba 'ne'.",
                  confirmed: "Lauko :attribute patvirtinimas nesutampa.",
                  date: "Lauko :attribute reikšmė nėra galiojanti data.",
                  date_format: "Lauko :attribute reikšmė neatitinka formato :format.",
                  different: "Laukų :attribute ir :other reikšmės turi skirtis.",
                  digits: "Laukas :attribute turi būti sudarytas iš :digits skaitmenų.",
                  digits_between: "Laukas :attribute tuti turėti nuo :min iki :max skaitmenų.",
                  dimensions: "Lauke :attribute įkeltas paveiksliukas neatitinka išmatavimų reikalavimo.",
                  distinct: "Laukas :attribute pasikartoja.",
                  email: "Lauko :attribute reikšmė turi būti galiojantis el. pašto adresas.",
                  file: "The :attribute must be a file.",
                  filled: "Laukas :attribute turi būti užpildytas.",
                  exists: "Pasirinkta negaliojanti :attribute reikšmė.",
                  gt: {
                      numeric: "The :attribute must be greater than :value.",
                      file: "The :attribute must be greater than :value kilobytes.",
                      string: "The :attribute must be greater than :value characters.",
                      array: "The :attribute must have more than :value items.",
                  },
                  gte: {
                      numeric: "The :attribute must be greater than or equal :value.",
                      file: "The :attribute must be greater than or equal :value kilobytes.",
                      string: "The :attribute must be greater than or equal :value characters.",
                      array: "The :attribute must have :value items or more.",
                  },
                  hex: "The :attribute field should have hexadecimal format",
                  image: "Lauko :attribute reikšmė turi būti paveikslėlis.",
                  in: "Pasirinkta negaliojanti :attribute reikšmė.",
                  in_array: "Laukas :attribute neegzistuoja :other lauke.",
                  integer: "Lauko :attribute reikšmė turi būti sveikasis skaičius.",
                  ip: "Lauko :attribute reikšmė turi būti galiojantis IP adresas.",
                  ipv4: "The :attribute must be a valid IPv4 address.",
                  ipv6: "The :attribute must be a valid IPv6 address.",
                  json: "Lauko :attribute reikšmė turi būti JSON tekstas.",
                  lt: {
                      numeric: "The :attribute must be less than :value.",
                      file: "The :attribute must be less than :value kilobytes.",
                      string: "The :attribute must be less than :value characters.",
                      array: "The :attribute must have less than :value items.",
                  },
                  lte: {
                      numeric: "The :attribute must be less than or equal :value.",
                      file: "The :attribute must be less than or equal :value kilobytes.",
                      string: "The :attribute must be less than or equal :value characters.",
                      array: "The :attribute must not have more than :value items.",
                  },
                  max: {
                      numeric: "Lauko :attribute reikšmė negali būti didesnė nei :max.",
                      file: "Failo dydis lauke :attribute reikšmė negali būti didesnė nei :max kilobaitų.",
                      string: "Simbolių kiekis lauke :attribute reikšmė negali būti didesnė nei :max simbolių.",
                      array: "Elementų kiekis lauke :attribute negali turėti daugiau nei :max elementų.",
                  },
                  mimes: "Lauko reikšmė :attribute turi būti failas vieno iš sekančių tipų: :values.",
                  mimetypes: "Lauko reikšmė :attribute turi būti failas vieno iš sekančių tipų: :values.",
                  min: {
                      numeric: "Lauko :attribute reikšmė turi būti ne mažesnė nei :min.",
                      file: "Failo dydis lauke :attribute turi būti ne mažesnis nei :min kilobaitų.",
                      string: "Simbolių kiekis lauke :attribute turi būti ne mažiau nei :min.",
                      array: "Elementų kiekis lauke :attribute turi būti ne mažiau nei :min.",
                  },
                  not_in: "Pasirinkta negaliojanti reikšmė :attribute.",
                  not_regex: "The :attribute format is invalid.",
                  numeric: "Lauko :attribute reikšmė turi būti skaičius.",
                  present: "Laukas :attribute turi egzistuoti.",
                  regex: "Negaliojantis lauko :attribute formatas.",
                  required: "Privaloma užpildyti lauką :attribute.",
                  required_if: "Privaloma užpildyti lauką :attribute kai :other yra :value.",
                  required_unless: "Laukas :attribute yra privalomas, nebent :other yra tarp :values reikšmių.",
                  required_with: "Privaloma užpildyti lauką :attribute kai pateikta :values.",
                  required_with_all: "Privaloma užpildyti lauką :attribute kai pateikta :values.",
                  required_without: "Privaloma užpildyti lauką :attribute kai nepateikta :values.",
                  required_without_all: "Privaloma užpildyti lauką :attribute kai nepateikta nei viena iš reikšmių :values.",
                  same: "Laukai :attribute ir :other turi sutapti.",
                  size: {
                      numeric: "Lauko :attribute reikšmė turi būti :size.",
                      file: "Failo dydis lauke :attribute turi būti :size kilobaitai.",
                      string: "Simbolių skaičius lauke :attribute turi būti :size.",
                      array: "Elementų kiekis lauke :attribute turi būti :size.",
                  },
                  string: "Laukas :attribute turi būti tekstinis.",
                  timezone: "Lauko :attribute reikšmė turi būti galiojanti laiko zona.",
                  unique: "Tokia :attribute reikšmė jau pasirinkta.",
                  uploaded: "The :attribute failed to upload.",
                  url: "Negaliojantis lauko :attribute formatas.",
              };
          },
          3421: (e) => {
              e.exports = {
                  accepted: " :attribute ir jābūt pieņemtam.",
                  active_url: " :attribute ir ar nederīgu linku.",
                  after: " :attribute ir jābūt ar datumu pēc :datums.",
                  after_or_equal: " :attribute ir jābūt ar datumu pēc vai vienādu ar :datums.",
                  alpha: " :attribute var saturēt tikai burtus.",
                  alpha_dash: " :attribute var saturēt tikai burtus, nummurus un atstarpes.",
                  alpha_num: " :attribute var tikai saturēt burtus un nummurus.",
                  attributes: {},
                  array: " :attribute ir jābūt sakārtotam.",
                  before: " :attribute ir jābūt ar datumu pirms :datums.",
                  before_or_equal: " :attribute ir jābūt ar datumu pirms vai vienādu ar :datums.",
                  between: {
                      numeric: " :attribute jābūt starp :min un :max.",
                      file: " :attribute jābūt starp :min un :max kilobaiti.",
                      string: " :attribute jābūt no :min līdz :max zīmēm.",
                      array: " :attribute jābūt no :min līdz :max vienībām.",
                  },
                  boolean: " :attribute laiciņam jābūt atbilstošam vai neatbilstošam.",
                  confirmed: " :attribute apstiprinājums neatbilst.",
                  date: " :attribute nav derīgs.",
                  date_format: " :attribute neatbilst formātam :format.",
                  different: " :attribute un :other ir jābūt citiem.",
                  digits: " :attribute ir jābūt :digits ciparam.",
                  digits_between: " :attribute ir jābūt :min un :max ciparam.",
                  dimensions: " :attribute ir nederīgs attēla izmērs.",
                  distinct: " :attribute laikam ir dubulta vērtība.",
                  email: " :attribute derīgam e-pastam.",
                  exists: "Izvēlētais :attribute ir nederīgs.",
                  file: " :attribute jābūt failam.",
                  filled: ":attribute lauks ir nepieciešams.",
                  gt: {
                      numeric: "The :attribute must be greater than :value.",
                      file: "The :attribute must be greater than :value kilobytes.",
                      string: "The :attribute must be greater than :value characters.",
                      array: "The :attribute must have more than :value items.",
                  },
                  gte: {
                      numeric: "The :attribute must be greater than or equal :value.",
                      file: "The :attribute must be greater than or equal :value kilobytes.",
                      string: "The :attribute must be greater than or equal :value characters.",
                      array: "The :attribute must have :value items or more.",
                  },
                  hex: "The :attribute field should have hexadecimal format",
                  image: " :attribute jābūt attēlam.",
                  in: "Izvēlētais :attribute ir nederīgs.",
                  in_array: " :attribute laiks neeksistē :cits.",
                  integer: " :attribute ir jabūt skaitim.",
                  ip: " :attribute jābūt derīgai IP adresei.",
                  ipv4: "The :attribute must be a valid IPv4 address.",
                  ipv6: "The :attribute must be a valid IPv6 address.",
                  json: " :attribute jābūt derīgai JSON virknei.",
                  lt: {
                      numeric: "The :attribute must be less than :value.",
                      file: "The :attribute must be less than :value kilobytes.",
                      string: "The :attribute must be less than :value characters.",
                      array: "The :attribute must have less than :value items.",
                  },
                  lte: {
                      numeric: "The :attribute must be less than or equal :value.",
                      file: "The :attribute must be less than or equal :value kilobytes.",
                      string: "The :attribute must be less than or equal :value characters.",
                      array: "The :attribute must not have more than :value items.",
                  },
                  max: {
                      numeric: " :attribute nedrīkst pārsniegt :max.",
                      file: " :attribute nedrīkst pārsniegt :max kilobaiti.",
                      string: " :attribute nedrīkst pārsniegt :max zīmes.",
                      array: " :attribute nedrīkst pārsniegt :max vienības.",
                  },
                  mimes: " :attribute jābūt faila tipam: :values",
                  mimetypes: " :attribute jābūt faile tipam: :values.",
                  min: { numeric: " :attribute jābūt vismaz :min.", file: " :attribute jābūt vismaz :min kilobaiti.", string: " :attribute jābūt vismaz :min zīmes.", array: " :attribute jāsatur vismaz :min vienības." },
                  not_in: " izvēlieties :attribute ir nederīgs.",
                  not_regex: "The :attribute format is invalid.",
                  numeric: " :attribute jābūt skaitlim.",
                  present: " :attribute laikums ir nepieciešams.",
                  regex: " :attribute formāts ir nederīgs.",
                  required: " :attribute laukums ir nepieciešams.",
                  required_if: " :attribute laukums ir nepieciešams, ja vien :other ir :values.",
                  required_unless: " :attribute laukums ir nepieciešams, ja vien :other ir :values.",
                  required_with: " :attribute laukums ir nepieciešams, kad :values ir pieejama.",
                  required_with_all: " :attribute laukums ir nepieciešams, kad :values ir pieejama.",
                  required_without: " :attribute laukums ir nepieciešams, kad :values nav pieejama.",
                  required_without_all: " :attribute laukums ir nepieciešams, kad neviena no :values nav pieejama.",
                  same: " :attribute un :citiem ir jāsakrīt.",
                  size: { numeric: " :attribute jābūt :size.", file: " :attribute jābūt :size kilobaiti.", string: " :attribute jābūt :size zīmes.", array: " :attribute jāsatur :size vienības." },
                  string: " :attribute jābūt virknē.",
                  timezone: " :attribute jābūt derīgā zonā.",
                  unique: " :attribute jau ir aizņemts.",
                  uploaded: " :attribute netika augšuplādēts.",
                  url: " :attribute formāts ir nederīgs.",
              };
          },
          403: (e) => {
              e.exports = {
                  accepted: "Полето :attribute мора да биде прифатено.",
                  active_url: "Полето :attribute не е валиден URL.",
                  after: "Полето :attribute мора да биде датум после :date.",
                  after_or_equal: "The :attribute must be a date after or equal to :date.",
                  alpha: "Полето :attribute може да содржи само букви.",
                  alpha_dash: "Полето :attribute може да содржи само букви, цифри, долна црта и тире.",
                  alpha_num: "Полето :attribute може да содржи само букви и цифри.",
                  attributes: {},
                  array: "Полето :attribute мора да биде низа.",
                  before: "Полето :attribute мора да биде датум пред :date.",
                  before_or_equal: "The :attribute must be a date before or equal to :date.",
                  between: {
                      numeric: "Полето :attribute мора да биде помеѓу :min и :max.",
                      file: "Полето :attribute мора да биде помеѓу :min и :max килобајти.",
                      string: "Полето :attribute мора да биде помеѓу :min и :max карактери.",
                      array: "Полето :attribute мора да има помеѓу :min - :max карактери.",
                  },
                  boolean: "The :attribute field must be true or false",
                  confirmed: "Полето :attribute не е потврдено.",
                  date: "Полето :attribute не е валиден датум.",
                  date_format: "Полето :attribute не е во формат :format.",
                  different: "Полињата :attribute и :other треба да се различни.",
                  digits: "Полето :attribute треба да има :digits цифри.",
                  digits_between: "Полето :attribute треба да има помеѓу :min и :max цифри.",
                  dimensions: "The :attribute has invalid image dimensions.",
                  distinct: "The :attribute field has a duplicate value.",
                  email: "Полето :attribute не е во валиден формат.",
                  exists: "Избранато поле :attribute веќе постои.",
                  file: "The :attribute must be a file.",
                  filled: "Полето :attribute е задолжително.",
                  gt: {
                      numeric: "The :attribute must be greater than :value.",
                      file: "The :attribute must be greater than :value kilobytes.",
                      string: "The :attribute must be greater than :value characters.",
                      array: "The :attribute must have more than :value items.",
                  },
                  gte: {
                      numeric: "The :attribute must be greater than or equal :value.",
                      file: "The :attribute must be greater than or equal :value kilobytes.",
                      string: "The :attribute must be greater than or equal :value characters.",
                      array: "The :attribute must have :value items or more.",
                  },
                  hex: "The :attribute field should have hexadecimal format",
                  image: "Полето :attribute мора да биде слика.",
                  in: "Избраното поле :attribute е невалидно.",
                  in_array: "The :attribute field does not exist in :other.",
                  integer: "Полето :attribute мора да биде цел број.",
                  ip: "Полето :attribute мора да биде IP адреса.",
                  ipv4: "The :attribute must be a valid IPv4 address.",
                  ipv6: "The :attribute must be a valid IPv6 address.",
                  json: "The :attribute must be a valid JSON string.",
                  lt: {
                      numeric: "The :attribute must be less than :value.",
                      file: "The :attribute must be less than :value kilobytes.",
                      string: "The :attribute must be less than :value characters.",
                      array: "The :attribute must have less than :value items.",
                  },
                  lte: {
                      numeric: "The :attribute must be less than or equal :value.",
                      file: "The :attribute must be less than or equal :value kilobytes.",
                      string: "The :attribute must be less than or equal :value characters.",
                      array: "The :attribute must not have more than :value items.",
                  },
                  max: {
                      numeric: "Полето :attribute мора да биде помало од :max.",
                      file: "Полето :attribute мора да биде помало од :max килобајти.",
                      string: "Полето :attribute мора да има помалку од :max карактери.",
                      array: "Полето :attribute не може да има повеќе од :max карактери.",
                  },
                  mimes: "Полето :attribute мора да биде фајл од типот: :values.",
                  mimetypes: "Полето :attribute мора да биде фајл од типот: :values.",
                  min: {
                      numeric: "Полето :attribute мора да биде минимум :min.",
                      file: "Полето :attribute мора да биде минимум :min килобајти.",
                      string: "Полето :attribute мора да има минимум :min карактери.",
                      array: "Полето :attribute мора да има минимум :min карактери.",
                  },
                  not_in: "Избраното поле :attribute е невалидно.",
                  not_regex: "The :attribute format is invalid.",
                  numeric: "Полето :attribute мора да биде број.",
                  present: "The :attribute field must be present.",
                  regex: "Полето :attribute е во невалиден формат.",
                  required: "Полето :attribute е задолжително.",
                  required_if: "Полето :attribute е задолжително, кога :other е :value.",
                  required_unless: "The :attribute field is required unless :other is in :values.",
                  required_with: "Полето :attribute е задолжително, кога е внесено :values.",
                  required_with_all: "The :attribute field is required when :values is present.",
                  required_without: "Полето :attribute е задолжително, кога не е внесено :values.",
                  required_without_all: "The :attribute field is required when none of :values are present.",
                  same: "Полињата :attribute и :other треба да совпаѓаат.",
                  size: {
                      numeric: "Полето :attribute мора да биде :size.",
                      file: "Полето :attribute мора да биде :size килобајти.",
                      string: "Полето :attribute мора да има :size карактери.",
                      array: "Полето :attribute мора да има :size карактери.",
                  },
                  string: "The :attribute must be a string.",
                  timezone: "The :attribute must be a valid zone.",
                  unique: "Полето :attribute веќе постои.",
                  uploaded: "The :attribute failed to upload.",
                  url: "Полето :attribute не е во валиден формат.",
              };
          },
          6079: (e) => {
              e.exports = {
                  accepted: ":Attribute баталсан байх шаардлагатай.",
                  active_url: ":Attribute талбарт зөв URL хаяг оруулна уу.",
                  after: ":Attribute талбарт :date-с хойш огноо оруулна уу.",
                  after_or_equal: ":Attribute талбарт :date эсвэл түүнээс хойш огноо оруулна уу.",
                  alpha: ":Attribute талбарт латин үсэг оруулна уу.",
                  alpha_dash: ":Attribute талбарт латин үсэг, тоо болон зураас оруулах боломжтой.",
                  alpha_num: ":Attribute талбарт латин үсэг болон тоо оруулах боломжтой.",
                  attributes: {},
                  array: ":Attribute талбар массив байх шаардлагатай.",
                  before: ":Attribute талбарт :date-с өмнөх огноо оруулна уу.",
                  before_or_equal: ":attribute талбарт :date эсвэл түүнээс өмнөх огноо оруулна уу.",
                  between: {
                      numeric: ":Attribute талбарт :min-:max хооронд тоо оруулна уу.",
                      file: ":Attribute талбарт :min-:max килобайт хэмжээтэй файл оруулна уу.",
                      string: ":Attribute талбарт :min-:max урттай текст оруулна уу.",
                      array: ":Attribute массивт :min-:max элемэнт байх шаардлагатай.",
                  },
                  boolean: ":Attribute талбарын утга үнэн эсвэл худал байх шаардлагатай.",
                  confirmed: ":Attribute талбарын баталагажуулалт тохирохгүй байна.",
                  date: ":Attribute талбарт оруулсан огноо буруу байна.",
                  date_format: ":Attribute талбарт :format хэлбэртэй огноо оруулна уу.",
                  different: ":Attribute талбарт :other -с өөр утга оруулах шаардлагатай.",
                  digits: ":Attribute талбарт дараах цифрүүдээс оруулах боломжтой. :digits.",
                  digits_between: ":Attribute талбарт :min-:max хоорондох цифр оруулах боломжтой.",
                  dimensions: ":Attribute талбарийн зургийн хэмжээс буруу байна.",
                  distinct: ":Attribute талбарт ялгаатай утга оруулах шаардлагатай.",
                  email: ":Attribute талбарт зөв и-мэйл хаяг оруулах шаардлагатай.",
                  exists: "Сонгогдсон :attribute буруу байна.",
                  file: ":Attribute талбарт файл оруулах шаардлагатай.",
                  filled: ":Attribute талбар шаардлагатай.",
                  gt: {
                      numeric: "The :attribute must be greater than :value.",
                      file: "The :attribute must be greater than :value kilobytes.",
                      string: "The :attribute must be greater than :value characters.",
                      array: "The :attribute must have more than :value items.",
                  },
                  gte: {
                      numeric: "The :attribute must be greater than or equal :value.",
                      file: "The :attribute must be greater than or equal :value kilobytes.",
                      string: "The :attribute must be greater than or equal :value characters.",
                      array: "The :attribute must have :value items or more.",
                  },
                  hex: "The :attribute field should have hexadecimal format",
                  image: ":Attribute талбарт зураг оруулна уу.",
                  in: "Сонгогдсон :attribute буруу байна.",
                  in_array: ":Attribute талбарт оруулсан утга :other -д байхгүй байна.",
                  integer: ":Attribute талбарт бүхэл тоо оруулах шаардлагатай.",
                  ip: ":Attribute талбарт зөв IP хаяг оруулах шаардлагатай.",
                  ipv4: "The :attribute must be a valid IPv4 address.",
                  ipv6: "The :attribute must be a valid IPv6 address.",
                  json: ":Attribute талбарт зөв JSON тэмдэгт мөр оруулах шаардлагатай.",
                  lt: {
                      numeric: "The :attribute must be less than :value.",
                      file: "The :attribute must be less than :value kilobytes.",
                      string: "The :attribute must be less than :value characters.",
                      array: "The :attribute must have less than :value items.",
                  },
                  lte: {
                      numeric: "The :attribute must be less than or equal :value.",
                      file: "The :attribute must be less than or equal :value kilobytes.",
                      string: "The :attribute must be less than or equal :value characters.",
                      array: "The :attribute must not have more than :value items.",
                  },
                  max: {
                      numeric: ":Attribute талбарт :max буюу түүнээс бага утга оруулна уу.",
                      file: ":Attribute талбарт :max килобайтаас бага хэмжээтэй файл оруулна уу.",
                      string: ":Attribute талбарт :max-с бага урттай текст оруулна уу.",
                      array: ":Attribute талбарт хамгийн ихдээ :max элемэнт оруулах боломжтой.",
                  },
                  mimes: ":Attribute талбарт дараах төрлийн файл оруулах боломжтой: :values.",
                  mimetypes: ":Attribute талбарт дараах төрлийн файл оруулах боломжтой: :values.",
                  min: {
                      numeric: ":Attribute талбарт :min буюу түүнээс их тоо оруулна уу.",
                      file: ":Attribute талбарт :min килобайтаас их хэмжээтэй файл оруулна уу.",
                      string: ":Attribute талбарт :min буюу түүнээс их үсэг бүхий текст оруулна уу.",
                      array: ":Attribute талбарт хамгийн багадаа :min элемэнт оруулах боломжтой.",
                  },
                  not_in: "Буруу :attribute сонгогдсон байна.",
                  not_regex: "The :attribute format is invalid.",
                  numeric: ":Attribute талбарт тоон утга оруулна уу.",
                  present: ":Attribute талбар байх шаардлагатай.",
                  regex: ":Attribute талбарт оруулсан утга буруу байна.",
                  required: ":Attribute талбар шаардлагатай.",
                  required_if: "Хэрэв :other :value бол :attribute табларт утга оруулах шаардлагатай.",
                  required_unless: ":other :values дотор байхгүй бол :attribute талбарт утга оруулах шаардлагатай.",
                  required_with: ":values утгуудийн аль нэг байвал :attribute талбар шаардлагатай.",
                  required_with_all: ":values утгууд байвал :attribute талбар шаардлагатай.",
                  required_without: "The :attribute field is required when :values is not present.",
                  required_without_all: "The :attribute field is required when none of :values are present.",
                  same: "The :attribute and :other must match.",
                  size: {
                      numeric: ":Attribute :size хэмжээтэй байх шаардлагатай.",
                      file: ":Attribute :size килобайт хэмжээтэй байх шаардлагатай.",
                      string: ":Attribute :size тэмдэгтийн урттай байх шаардлагатай.",
                      array: ":Attribute :size элемэнттэй байх шаардлагатай.",
                  },
                  string: ":Attribute талбарт текст оруулна уу.",
                  timezone: ":Attribute талбарт зөв цагийн бүс оруулна уу.",
                  unique: "Оруулсан :attribute аль хэдий нь бүртгэгдсэн байна.",
                  uploaded: ":Attribute талбарт оруулсан файлыг хуулхад алдаа гарлаа.",
                  url: ":Attribute зөв url хаяг оруулна уу.",
              };
          },
          6311: (e) => {
              e.exports = {
                  accepted: ":attribute mesti diterima pakai.",
                  active_url: ":attribute bukan URL yang sah.",
                  after: ":attribute mesti tarikh selepas :date.",
                  after_or_equal: ":attribute mesti tarikh selepas atau sama dengan :date.",
                  alpha: ":attribute hanya boleh mengandungi huruf.",
                  alpha_dash: ":attribute boleh mengandungi huruf, nombor, dan sengkang.",
                  alpha_num: ":attribute boleh mengandungi huruf dan nombor.",
                  attributes: {},
                  array: ":attribute mesti jujukan.",
                  before: ":attribute mesti tarikh sebelum :date.",
                  before_or_equal: ":attribute mesti tarikh sebelum atau sama dengan :date.",
                  between: {
                      numeric: ":attribute mesti mengandungi antara :min dan :max.",
                      file: ":attribute mesti mengandungi antara :min dan :max kilobait.",
                      string: ":attribute mesti mengandungi antara :min dan :max aksara.",
                      array: ":attribute mesti mengandungi antara :min dan :max perkara.",
                  },
                  boolean: ":attribute mesti benar atau salah.",
                  confirmed: ":attribute pengesahan yang tidak sepadan.",
                  date: ":attribute bukan tarikh yang sah.",
                  date_format: ":attribute tidak mengikut format :format.",
                  different: ":attribute dan :other mesti berlainan.",
                  dimensions: ":attribute tidak sah",
                  digits: ":attribute mesti :digits.",
                  digits_between: ":attribute mesti mengandungi antara :min dan :max digits.",
                  distinct: ":attribute adalah nilai yang berulang",
                  email: ":attribute tidak sah.",
                  exists: ":attribute tidak sah.",
                  file: ":attribute mesti fail yang sah.",
                  filled: ":attribute diperlukan.",
                  gt: {
                      numeric: ":attribute mesti melebihi :value.",
                      file: ":attribute mesti melebihi :value kilobait.",
                      string: ":attribute mesti melebihi :value aksara.",
                      array: ":attribute mesti mengandungi lebih daripada :value perkara.",
                  },
                  gte: {
                      numeric: ":attribute mesti melebihi atau bersamaan :value.",
                      file: ":attribute mesti melebihi atau bersamaan :value kilobait.",
                      string: ":attribute mesti melebihi atau bersamaan :value aksara.",
                      array: ":attribute mesti mengandungi :value perkara atau lebih.",
                  },
                  hex: "The :attribute field should have hexadecimal format",
                  image: ":attribute mesti imej.",
                  in: ":attribute tidak sah.",
                  in_array: ":attribute tidak wujud dalam :other.",
                  integer: ":attribute mesti integer.",
                  ip: ":attribute mesti alamat IP yang sah.",
                  ipv4: ":attribute mesti alamat IPv4 yang sah.",
                  ipv6: ":attribute mesti alamat IPv6 yang sah",
                  json: ":attribute mesti JSON yang sah.",
                  lt: {
                      numeric: ":attribute mesti kurang daripada :value.",
                      file: ":attribute mesti kurang daripada :value kilobait.",
                      string: ":attribute mesti kurang daripada :value aksara.",
                      array: ":attribute mesti mengandungi kurang daripada :value perkara.",
                  },
                  lte: {
                      numeric: ":attribute mesti kurang daripada atau bersamaan dengan :value.",
                      file: ":attribute mesti kurang daripada atau bersamaan dengan :value kilobait.",
                      string: ":attribute mesti kurang daripada atau bersamaan dengan :value aksara.",
                      array: ":attribute mesti mengandungi kurang daripada atau bersamaan dengan :value perkara.",
                  },
                  max: {
                      numeric: "Jumlah :attribute mesti tidak melebihi :max.",
                      file: "Jumlah :attribute mesti tidak melebihi :max kilobait.",
                      string: "Jumlah :attribute mesti tidak melebihi :max aksara.",
                      array: "Jumlah :attribute mesti tidak melebihi :max perkara.",
                  },
                  mimes: ":attribute mesti fail type: :values.",
                  mimetypes: ":attribute mesti fail type: :values.",
                  min: {
                      numeric: "Jumlah :attribute mesti sekurang-kurangnya :min.",
                      file: "Jumlah :attribute mesti sekurang-kurangnya :min kilobait.",
                      string: "Jumlah :attribute mesti sekurang-kurangnya :min aksara.",
                      array: "Jumlah :attribute mesti sekurang-kurangnya :min perkara.",
                  },
                  not_in: ":attribute tidak sah.",
                  not_regex: "Format :attribute adalah tidak sah.",
                  numeric: ":attribute mesti nombor.",
                  present: ":attribute mesti wujud.",
                  regex: "Format :attribute tidak sah.",
                  required: "Ruangan :attribute diperlukan.",
                  required_if: "Ruangan :attribute diperlukan bila :other sama dengan :value.",
                  required_unless: "Ruangan :attribute diperlukan sekiranya :other ada dalam :values.",
                  required_with: "Ruangan :attribute diperlukan bila :values wujud.",
                  required_with_all: "Ruangan :attribute diperlukan bila :values wujud.",
                  required_without: "Ruangan :attribute diperlukan bila :values tidak wujud.",
                  required_without_all: "Ruangan :attribute diperlukan bila kesemua :values wujud.",
                  same: "Ruangan :attribute dan :other mesti sepadan.",
                  size: { numeric: "Saiz :attribute mesti :size.", file: "Saiz :attribute mesti :size kilobait.", string: "Saiz :attribute mesti :size aksara.", array: "Saiz :attribute mesti mengandungi :size perkara." },
                  string: ":attribute mesti aksara.",
                  timezone: ":attribute mesti zon masa yang sah.",
                  unique: ":attribute telah wujud.",
                  uploaded: ":attribute gagal dimuat naik.",
                  url: ":attribute format tidak sah.",
              };
          },
          2265: (e) => {
              e.exports = {
                  accepted: ":attribute må være akseptert.",
                  alpha: ":attribute feltet kan kun inneholde alfabetiske tegn.",
                  alpha_dash: ":attribute feltet kan kun inneholde alfanumeriske tegn, i tillegg til bindestreker og understreker.",
                  alpha_num: ":attribute feltet må være alfanumerisk.",
                  between: ":attribute feltet må være mellom :min og :max.",
                  confirmed: ":attribute feltet stemmer ikke overens med bekreftelsen.",
                  email: ":attribute formatet er ugyldig.",
                  date: ":attribute er et ugyldig datoformat.",
                  def: ":attribute attributtet har feil.",
                  digits: ":attribute må være på :digits siffer.",
                  digits_between: ":attribute må være mellom :min og :max siffer.",
                  different: ":attribute og :different må være forskjellige.",
                  in: "Den oppgitte verdien for :attribute er ugyldig.",
                  integer: ":attribute må være et heltall.",
                  hex: "The :attribute should have hexadecimal format",
                  min: { numeric: ":attribute må minst være :min.", string: ":attribute må være på minst :min tegn." },
                  max: { numeric: ":attribute kan ikke være større enn :max.", string: ":attribute kan maks ha :max tegn." },
                  not_in: "Den oppgitte verdien for :attribute er ugyldig.",
                  numeric: ":attribute må være et tall.",
                  present: "The :attribute field must be present (but can be empty).",
                  required: ":attribute feltet er påkrevd.",
                  required_if: ":attribute er påkrevd når :other er :value.",
                  same: ":attribute og :same må være like.",
                  size: { numeric: ":attribute må ha størrelsen :size.", string: ":attribute må ha :size tegn." },
                  string: ":attribute må være tekst.",
                  url: ":attribute formatet er ugyldig.",
                  regex: ":attribute formatet er ugyldig.",
                  attributes: {},
              };
          },
          7741: (e) => {
              e.exports = {
                  accepted: "Het :attribute veld moet geaccepteerd worden.",
                  after: ":attribute moet een datum na :after zijn.",
                  after_or_equal: "De :attribute datum moet op of na :after_or_equal zijn.",
                  alpha: "Het :attribute veld mag alleen maar letters bevatten.",
                  alpha_dash: "Het :attribute veld mag alleen maar letters, cijfers en (liggende) streepjes bevatten.",
                  alpha_num: "Het :attribute veld mag alleen maar letters en cijfers bevatten.",
                  before: ":attribute moet vòòr :before zijn.",
                  before_or_equal: ":attribute moet vòòr of op :before_or_equal zijn.",
                  between: "Het :attribute veld moet tussen :min en :max liggen.",
                  confirmed: "Het :attribute veld komt niet met de bevestiging overeen.",
                  email: "Het :attribute formaat is ongeldig.",
                  date: "Het :attribute veld moet een geldige datum zijn.",
                  def: "Het :attribute veld bevat fouten.",
                  digits: "Het :attribute veld moet :digits cijfers hebben.",
                  digits_between: ":attribute moet bestaan uit minimaal :min en maximaal :max cijfers.",
                  different: "Het :attribute en :different veld moeten verschillend zijn.",
                  in: "De gekozen waarde voor :attribute is ongeldig.",
                  integer: "Het :attribute veld moet een geheel getal zijn.",
                  hex: "Het :attribute veld moet hexadecimaal zijn",
                  min: { numeric: "Het :attribute veld moet minstens :min zijn.", string: "Het :attribute veld moet minstens :min karakters bevatten." },
                  max: { numeric: "Het :attribute veld mag maximaal :max zijn.", string: "Het :attribute veld mag niet meer dan :max karakters bevatten." },
                  not_in: "De gekozen waarde voor :attribute is ongeldig.",
                  numeric: "Het :attribute veld moet een getal zijn.",
                  present: "Het :attribute veld moet aanwezig zijn (maar mag leeg zijn).",
                  required: "Het :attribute veld moet ingevuld zijn.",
                  required_if: "Het :attribute veld moet ingevuld zijn, wanneer :other :value is.",
                  required_unless: "Het :attribute veld moet ingevuld zijn, wanneer :other niet :value is.",
                  required_with: "Het :attribute veld moet ingevuld zijn, wanneer :field niet leeg is.",
                  required_with_all: "Het :attribute veld moet ingevuld zijn, wanneer :fields niet leeg zijn.",
                  required_without: "Het :attribute veld moet ingevuld zijn, wanneer :field leeg is.",
                  required_without_all: "Het :attribute veld moet ingevuld zijn, wanneer :fields leeg zijn.",
                  same: "De :attribute en :same velden moeten overeenkomen.",
                  size: { numeric: "Het :attribute veld moet :size zijn.", string: "Het :attribute veld moet :size karakters bevatten." },
                  string: "Het :attribute veld moet een woord of zin zijn.",
                  url: "Het :attribute veld heeft een ongeldig formaat.",
                  regex: "Het :attribute veld heeft een ongeldig formaat.",
                  attributes: {},
              };
          },
          2756: (e) => {
              e.exports = {
                  accepted: "Pole :attribute musi być zaakceptowane.",
                  alpha: "Pole :attribute może zawierać tylko litery.",
                  alpha_dash: "Pole :attribute moze zawierać tylko litery, myślnik i podrkeślenie.",
                  alpha_num: "Pole :attribute moze zawierac tylko znaki alfanumeryczne.",
                  between: "Pole :attribute musi mieć długość od :min do :max.",
                  confirmed: "Pole :attribute nie spełnia warunku potwierdzenia.",
                  email: "Pole :attribute ma niepoprawny format adresu email.",
                  date: "Pole :attribute musi mieć poprawny format daty.",
                  def: "Pole :attribute zawiera błędy.",
                  digits: "Pole :attribute może zawierać tylko cyfry ze zbioru :digits.",
                  digits_between: "Pole :attribute musi mieć od :min do :max cyfr.",
                  different: "Pola :attribute i :different muszą się różnić.",
                  in: "Pole :attribute musi należeć do zbioru :in.",
                  integer: "Pole :attribute musi być liczbą całkowitą.",
                  hex: "The :attribute should have hexadecimal format",
                  min: { numeric: "Pole :attribute musi być równe conajmniej :min.", string: "Pole :attribute musi zawierać conajmniej :min znaków." },
                  max: { numeric: "Pole :attribute nie moze być większe :max.", string: "Pole :attribute nie moze być dłuższe niż :max znaków." },
                  not_in: "Pole :attribute nie może należeć do zbioru :not_in.",
                  numeric: "Pole :attribute musi być liczbą.",
                  present: "Polu :attribute musi być obecny (ale może być pusta).",
                  required: "Pole :attribute jest wymagane.",
                  required_if: "Pole :attribute jest wymagane jeśli pole :other jest równe :value.",
                  same: "Pola :attribute i :same muszą być takie same.",
                  size: { numeric: "Pole :attribute musi być równe :size.", string: "Pole :attribute musi zawierać :size znaków." },
                  string: "Pole :attribute musi być ciągiem znaków.",
                  url: "Pole :attribute musi być poprawnym adresem URL.",
                  regex: "Pole :attribute nie spełnia warunku.",
                  attributes: {},
              };
          },
          4865: (e) => {
              e.exports = {
                  accepted: "O campo :attribute deverá ser aceite.",
                  active_url: "O campo :attribute não contém um URL válido.",
                  after: "O campo :attribute deverá conter uma data posterior a :date.",
                  after_or_equal: "O campo :attribute deverá conter uma data posterior ou igual a :date.",
                  alpha: "O campo :attribute deverá conter apenas letras.",
                  alpha_dash: "O campo :attribute deverá conter apenas letras, números e traços.",
                  alpha_num: "O campo :attribute deverá conter apenas letras e números .",
                  attributes: {},
                  array: "O campo :attribute deverá conter uma coleção de elementos.",
                  before: "O campo :attribute deverá conter uma data anterior a :date.",
                  before_or_equal: "O Campo :attribute deverá conter uma data anterior ou igual a :date.",
                  between: {
                      numeric: "O campo :attribute deverá ter um valor entre :min - :max.",
                      file: "O campo :attribute deverá ter um tamanho entre :min - :max kilobytes.",
                      string: "O campo :attribute deverá conter entre :min - :max caracteres.",
                      array: "O campo :attribute deverá conter entre :min - :max elementos.",
                  },
                  boolean: "O campo :attribute deverá conter o valor verdadeiro ou falso.",
                  confirmed: "A confirmação para o campo :attribute não coincide.",
                  date: "O campo :attribute não contém uma data válida.",
                  date_format: "A data indicada para o campo :attribute não respeita o formato :format.",
                  different: "Os campos :attribute e :other deverão conter valores diferentes.",
                  digits: "O campo :attribute deverá conter :digits caracteres.",
                  digits_between: "O campo :attribute deverá conter entre :min a :max caracteres.",
                  dimensions: "O campo :attribute deverá conter uma dimensão de imagem válida.",
                  distinct: "O campo :attribute contém um valor duplicado.",
                  email: "O campo :attribute não contém um endereço de correio eletrónico válido.",
                  exists: "O valor selecionado para o campo :attribute é inválido.",
                  file: "O campo :attribute deverá conter um ficheiro.",
                  filled: "É obrigatória a indicação de um valor para o campo :attribute.",
                  gt: {
                      numeric: "The :attribute must be greater than :value.",
                      file: "The :attribute must be greater than :value kilobytes.",
                      string: "The :attribute must be greater than :value characters.",
                      array: "The :attribute must have more than :value items.",
                  },
                  gte: {
                      numeric: "The :attribute must be greater than or equal :value.",
                      file: "The :attribute must be greater than or equal :value kilobytes.",
                      string: "The :attribute must be greater than or equal :value characters.",
                      array: "The :attribute must have :value items or more.",
                  },
                  hex: "The :attribute field should have hexadecimal format",
                  image: "O campo :attribute deverá conter uma imagem.",
                  in: "O campo :attribute não contém um valor válido.",
                  in_array: "O campo :attribute não existe em :other.",
                  integer: "O campo :attribute deverá conter um número inteiro.",
                  ip: "O campo :attribute deverá conter um IP válido.",
                  ipv4: "O campo :attribute deverá conter um IPv4 válido.",
                  ipv6: "O campo :attribute deverá conter um IPv6 válido.",
                  json: "O campo :attribute deverá conter um texto JSON válido.",
                  lt: {
                      numeric: "The :attribute must be less than :value.",
                      file: "The :attribute must be less than :value kilobytes.",
                      string: "The :attribute must be less than :value characters.",
                      array: "The :attribute must have less than :value items.",
                  },
                  lte: {
                      numeric: "The :attribute must be less than or equal :value.",
                      file: "The :attribute must be less than or equal :value kilobytes.",
                      string: "The :attribute must be less than or equal :value characters.",
                      array: "The :attribute must not have more than :value items.",
                  },
                  max: {
                      numeric: "O campo :attribute não deverá conter um valor superior a :max.",
                      file: "O campo :attribute não deverá ter um tamanho superior a :max kilobytes.",
                      string: "O campo :attribute não deverá conter mais de :max caracteres.",
                      array: "O campo :attribute não deverá conter mais de :max elementos.",
                  },
                  mimes: "O campo :attribute deverá conter um ficheiro do tipo: :values.",
                  mimetypes: "O campo :attribute deverá conter um ficheiro do tipo: :values.",
                  min: {
                      numeric: "O campo :attribute deverá ter um valor superior ou igual a :min.",
                      file: "O campo :attribute deverá ter no mínimo :min kilobytes.",
                      string: "O campo :attribute deverá conter no mínimo :min caracteres.",
                      array: "O campo :attribute deverá conter no mínimo :min elementos.",
                  },
                  not_in: "O campo :attribute contém um valor inválido.",
                  not_regex: "The :attribute format is invalid.",
                  numeric: "O campo :attribute deverá conter um valor numérico.",
                  present: "O campo :attribute deverá estar presente.",
                  regex: "O formato do valor para o campo :attribute é inválido.",
                  required: "É obrigatória a indicação de um valor para o campo :attribute.",
                  required_if: "É obrigatória a indicação de um valor para o campo :attribute quando o valor do campo :other é igual a :value.",
                  required_unless: "É obrigatória a indicação de um valor para o campo :attribute a menos que :other esteja presente em :values.",
                  required_with: "É obrigatória a indicação de um valor para o campo :attribute quando :values está presente.",
                  required_with_all: "É obrigatória a indicação de um valor para o campo :attribute quando um dos :values está presente.",
                  required_without: "É obrigatória a indicação de um valor para o campo :attribute quando :values não está presente.",
                  required_without_all: "É obrigatória a indicação de um valor para o campo :attribute quando nenhum dos :values está presente.",
                  same: "Os campos :attribute e :other deverão conter valores iguais.",
                  size: {
                      numeric: "O campo :attribute deverá conter o valor :size.",
                      file: "O campo :attribute deverá ter o tamanho de :size kilobytes.",
                      string: "O campo :attribute deverá conter :size caracteres.",
                      array: "O campo :attribute deverá conter :size elementos.",
                  },
                  string: "O campo :attribute deverá conter texto.",
                  timezone: "O campo :attribute deverá ter um fuso horário válido.",
                  unique: "O valor indicado para o campo :attribute já se encontra registado.",
                  uploaded: "O upload do ficheiro :attribute falhou.",
                  url: "O formato do URL indicado para o campo :attribute é inválido.",
              };
          },
          9157: (e) => {
              e.exports = {
                  accepted: "O campo :attribute deve ser aceito.",
                  active_url: "O campo :attribute deve conter uma URL válida.",
                  after: "O campo :attribute deve conter uma data posterior a :date.",
                  after_or_equal: "O campo :attribute deve conter uma data superior ou igual a :date.",
                  alpha: "O campo :attribute deve conter apenas letras.",
                  alpha_dash: "O campo :attribute deve conter apenas letras, números e traços.",
                  alpha_num: "O campo :attribute deve conter apenas letras e números .",
                  array: "O campo :attribute deve conter um array.",
                  before: "O campo :attribute deve conter uma data anterior a :date.",
                  before_or_equal: "O campo :attribute deve conter uma data inferior ou igual a :date.",
                  between: {
                      numeric: "O campo :attribute deve conter um número entre :min e :max.",
                      file: "O campo :attribute deve conter um arquivo de :min a :max kilobytes.",
                      string: "O campo :attribute deve conter entre :min a :max caracteres.",
                      array: "O campo :attribute deve conter de :min a :max itens.",
                  },
                  boolean: "O campo :attribute deve conter o valor verdadeiro ou falso.",
                  confirmed: "A confirmação para o campo :attribute não coincide.",
                  date: "O campo :attribute não contém uma data válida.",
                  date_format: "A data informada para o campo :attribute não respeita o formato :format.",
                  different: "Os campos :attribute e :other devem conter valores diferentes.",
                  digits: "O campo :attribute deve conter :digits dígitos.",
                  digits_between: "O campo :attribute deve conter entre :min a :max dígitos.",
                  dimensions: "O valor informado para o campo :attribute não é uma dimensão de imagem válida.",
                  distinct: "O campo :attribute contém um valor duplicado.",
                  email: "O campo :attribute não contém um endereço de email válido.",
                  exists: "O valor selecionado para o campo :attribute é inválido.",
                  file: "O campo :attribute deve conter um arquivo.",
                  filled: "O campo :attribute é obrigatório.",
                  gt: {
                      numeric: "O campo :attribute deve ser maior que :value.",
                      file: "O arquivo :attribute deve ser maior que :value kilobytes.",
                      string: "O campo :attribute deve ser maior que :value caracteres.",
                      array: "O campo :attribute deve ter mais que :value itens.",
                  },
                  gte: {
                      numeric: "O campo :attribute deve ser maior ou igual a :value.",
                      file: "O arquivo :attribute deve ser maior ou igual a :value kilobytes.",
                      string: "O campo :attribute deve ser maior ou igual a :value caracteres.",
                      array: "O campo :attribute deve ter :value itens ou mais.",
                  },
                  hex: "The :attribute field should have hexadecimal format",
                  image: "O campo :attribute deve conter uma imagem.",
                  in: "O campo :attribute não contém um valor válido.",
                  in_array: "O campo :attribute não existe em :other.",
                  integer: "O campo :attribute deve conter um número inteiro.",
                  ip: "O campo :attribute deve conter um IP válido.",
                  ipv4: "O campo :attribute deve conter um IPv4 válido.",
                  ipv6: "O campo :attribute deve conter um IPv6 válido.",
                  json: "O campo :attribute deve conter uma string JSON válida.",
                  lt: {
                      numeric: "O campo :attribute deve ser menor que :value.",
                      file: "O arquivo :attribute ser menor que :value kilobytes.",
                      string: "O campo :attribute deve ser menor que :value caracteres.",
                      array: "O campo :attribute deve ter menos que :value itens.",
                  },
                  lte: {
                      numeric: "O campo :attribute deve ser menor ou igual a :value.",
                      file: "O arquivo :attribute ser menor ou igual a :value kilobytes.",
                      string: "O campo :attribute deve ser menor ou igual a :value caracteres.",
                      array: "O campo :attribute não deve ter mais que :value itens.",
                  },
                  max: {
                      numeric: "O campo :attribute não pode conter um valor superior a :max.",
                      file: "O campo :attribute não pode conter um arquivo com mais de :max kilobytes.",
                      string: "O campo :attribute não pode conter mais de :max caracteres.",
                      array: "O campo :attribute deve conter no máximo :max itens.",
                  },
                  mimes: "O campo :attribute deve conter um arquivo do tipo: :values.",
                  mimetypes: "O campo :attribute deve conter um arquivo do tipo: :values.",
                  min: {
                      numeric: "O campo :attribute deve conter um número superior ou igual a :min.",
                      file: "O campo :attribute deve conter um arquivo com no mínimo :min kilobytes.",
                      string: "O campo :attribute deve conter no mínimo :min caracteres.",
                      array: "O campo :attribute deve conter no mínimo :min itens.",
                  },
                  not_in: "O campo :attribute contém um valor inválido.",
                  not_regex: "O formato do valor :attribute é inválido.",
                  numeric: "O campo :attribute deve conter um valor numérico.",
                  present: "O campo :attribute deve estar presente.",
                  regex: "O formato do valor informado no campo :attribute é inválido.",
                  required: "O campo :attribute é obrigatório.",
                  required_if: "O campo :attribute é obrigatório quando o valor do campo :other é igual a :value.",
                  required_unless: "O campo :attribute é obrigatório a menos que :other esteja presente em :values.",
                  required_with: "O campo :attribute é obrigatório quando :values está presente.",
                  required_with_all: "O campo :attribute é obrigatório quando um dos :values está presente.",
                  required_without: "O campo :attribute é obrigatório quando :values não está presente.",
                  required_without_all: "O campo :attribute é obrigatório quando nenhum dos :values está presente.",
                  same: "Os campos :attribute e :other devem conter valores iguais.",
                  size: {
                      numeric: "O campo :attribute deve conter o número :size.",
                      file: "O campo :attribute deve conter um arquivo com o tamanho de :size kilobytes.",
                      string: "O campo :attribute deve conter :size caracteres.",
                      array: "O campo :attribute deve conter :size itens.",
                  },
                  string: "O campo :attribute deve ser uma string.",
                  timezone: "O campo :attribute deve conter um fuso horário válido.",
                  unique: "O valor informado para o campo :attribute já está em uso.",
                  uploaded: "Falha no Upload do arquivo :attribute.",
                  url: "O formato da URL informada para o campo :attribute é inválido.",
              };
          },
          9296: (e) => {
              e.exports = {
                  accepted: ":attribute trebuie acceptat.",
                  after: ":attribute trebuie să fie după :after.",
                  after_or_equal: ":attribute trebuie să fie egal sau după :after_or_equal.",
                  alpha: "Câmpul :attribute rebuie să conțină numai caractere alfabetice.",
                  alpha_dash: "Câmpul:attribute poate conține numai caractere alfanumerice, precum și liniuțe și subliniere.",
                  alpha_num: "Câmpul :attribute trebuie să fie alfanumeric.",
                  before: ":attribute trebuie să fie înainte :before.",
                  before_or_equal: ":attribute trebuie să fie egal sau înainte :before_or_equal.",
                  between: ":attribute trebuie să fie între :min și :max.",
                  confirmed: "Confirmarea :attribute nu se potrivește.",
                  email: "Formatul :attribute nu este valid.",
                  date: ":attribute nu este un format de dată valid.",
                  def: "Atributul :attribute are erori.",
                  digits: ":attribute trebuie să aibă  :digits cifre.",
                  digits_between: "Câmpul :attribute trebuie să aibă între :min și :max cifre.",
                  different: ":attribute și :different trebuie sa fie diferite.",
                  in: "Atributul selectat :attribute nu este valid.",
                  integer: ":attribute trebuie să fie un număr întreg.",
                  hex: "Câmpul :attribute trebuie să aibă format hexazecimal.",
                  min: { numeric: ":attribute trebuie să fie mai mare de :min.", string: ":attribute trebuie să contină cel puțin :min caractere." },
                  max: { numeric: ":attribute nu trebuie să fie mai mare de :max.", string: ":attribute poate să contină maxim :max caractere." },
                  not_in: ":attribute selectat nu este valid.",
                  numeric: ":attribute trebuie sa fie un număr.",
                  present: ":attribute trebuie sa fie prezent(dar poate fi gol).",
                  required: " Câmpul :attribute este obligatoriu.",
                  required_if: "Câmpul :attribute este obligatoriu cănd :other este :value.",
                  required_unless: "Câmpul :attribute este obligatoriu cănd :other nu este :value.",
                  required_with: "Câmpul :attribute este obligatoriu cănd :field este completat.",
                  required_with_all: "Câmpul :attribute este obligatoriu cănd :fields sunt completate.",
                  required_without: "Câmpul :attribute este obligatoriu cănd :field nu este completat.",
                  required_without_all: "Câmpul :attribute este obligatoriu cănd :fields nu sunt completate.",
                  same: "Câmpurile :attribute și :same trebuie să fie egale.",
                  size: { numeric: ":attribute trebuie să fie :size.", string: ":attribute trebuie să contina :size caractere." },
                  string: ":attribute trebuie să fie un contina doar caractere alfabetice.",
                  url: "Formatul :attribute nu este valid.",
                  regex: "Formatul :attribute nu este valid.",
                  attributes: {},
              };
          },
          8576: (e) => {
              e.exports = {
                  accepted: "Вы должны принять :attribute.",
                  alpha: "Поле :attribute может содержать только буквы.",
                  alpha_dash: "Поле :attribute может содержать только буквы, цифры, дефисы и символы подчёркивания.",
                  alpha_num: "Поле :attribute может содержать только буквы и цифры.",
                  between: "Поле :attribute должно быть между :min и :max.",
                  confirmed: "Поле :attribute не совпадает с подтверждением.",
                  email: "Поле :attribute должно быть действительным электронным адресом.",
                  def: "Поле :attribute содержит ошибки.",
                  digits: "Длина цифрового поля :attribute должна быть :digits.",
                  digits_between: "Длинна цифрового поля :attribute должна быть от :min до :max знаков.",
                  different: "Поля :attribute и :different должны различаться.",
                  in: "Выбранное значение для :attribute ошибочно.",
                  integer: "Поле :attribute должно быть целым числом.",
                  hex: "Поле :attribute должно иметь шестнадцатеричный формат",
                  min: { numeric: "Значение поля :attribute должно быть больше или равно :min.", string: "Количество символов в поле :attribute должно быть не менее :min." },
                  max: { numeric: "Значение поля :attribute должно быть меньше или равно :max.", string: "Количество символов в поле :attribute не может превышать :max." },
                  not_in: "Выбранное значение для :attribute ошибочно.",
                  numeric: "Поле :attribute должно быть числом.",
                  present: "Поле :attribute должно присутствовать (но может быть пустым).",
                  required: "Поле :attribute обязательно для заполнения.",
                  required_if: "Поле :attribute требуется когда значения поля :other равно :value.",
                  same: "Значение :attribute должно совпадать с :same.",
                  size: { numeric: "Значение поля :attribute должно быть равным :size.", string: "Количество символов в поле :attribute должно быть равно :size." },
                  url: "Поле :attribute должно содержать валидный URL.",
                  regex: "Неверный формат поля :attribute.",
                  attributes: {},
              };
          },
          1944: (e) => {
              e.exports = {
                  accepted: ":attribute måste vara accepterat.",
                  after: ":attribute måste vara efter :after.",
                  after_or_equal: ":attribute måste vara samtidigt eller efter :after_or_equal.",
                  alpha: ":attribute får bara bestå av bokstäver.",
                  alpha_dash: ":attribute får bara bestå av alfanumeriska tecken, bindestreck och understreck.",
                  alpha_num: ":attribute får bara bestå av alfanumeriska tecken",
                  before: ":attribute måste vara före :before.",
                  before_or_equal: ":attribute måste vara samtidigt eller före :before_or_equal.",
                  between: ":attribute måste vara mellan :min och :max.",
                  confirmed: ":attribute stämmer inte överens med bekräftelsefältet.",
                  email: "Felaktigt format för :attribute.",
                  date: ":attribute är inte ett giltigt datum.",
                  def: "Attributet :attribute innehåller fel.",
                  digits: ":attribute ska innehålla :digits siffror.",
                  different: ":attribute och :different måste vara olika.",
                  in: "Det valda :attribute är ogiltigt.",
                  integer: ":attribute måste vara ett heltal.",
                  hex: ":attribute måste vara i hexadecimalt format",
                  min: { numeric: ":attribute måste vara minst :min.", string: ":attribute måste vara minst :min tecken." },
                  max: { numeric: ":attribute får inte vara högre än :max.", string: ":attribute får inte innehålla fler än :max tecken." },
                  not_in: "Det valda attributet :attribute är ogiltigt",
                  numeric: ":attribute måste vara en siffra.",
                  present: ":attribute måste vara tillgängligt.",
                  required: ":attribute måste vara ifyllt.",
                  required_if: ":attribute måste vara ifyllt när :other är :value.",
                  required_unless: ":attribute måste vara ifyllt när :other inte är :value.",
                  required_with: ":attribute måste vara ifyllt när :field är ifyllt.",
                  required_with_all: ":attribute måste vara ifyllt när :fields är ifyllda.",
                  required_without: ":attribute måste vara ifyllt när :field inte är ifyllt.",
                  required_without_all: ":attribute måste vara ifyllt när ingen av :fields är ifyllda.",
                  same: ":attribute och :same måste matcha.",
                  size: { numeric: ":attribute måste vara :size.", string: ":attribute måste vara :size tecken lång." },
                  string: ":attribute måste vara en sträng.",
                  url: ":attribute formatet är ogiltigt.",
                  regex: ":attribute formatet är ogiltigt.",
                  attributes: {},
              };
          },
          202: (e) => {
              e.exports = {
                  accepted: ":attribute mora biti sprejet.",
                  active_url: ":attribute ni pravilen.",
                  after: ":attribute mora biti za datumom :date.",
                  after_or_equal: ":attribute mora biti za ali enak :date.",
                  alpha: ":attribute lahko vsebuje samo črke.",
                  alpha_dash: ":attribute lahko vsebuje samo črke, številke in črtice.",
                  alpha_num: ":attribute lahko vsebuje samo črke in številke.",
                  attributes: {},
                  array: ":attribute mora biti polje.",
                  before: ":attribute mora biti pred datumom :date.",
                  before_or_equal: ":attribute mora biti pred ali enak :date.",
                  between: {
                      numeric: ":attribute mora biti med :min in :max.",
                      file: ":attribute mora biti med :min in :max kilobajti.",
                      string: ":attribute mora biti med :min in :max znaki.",
                      array: ":attribute mora imeti med :min in :max elementov.",
                  },
                  boolean: ":attribute polje mora biti 1 ali 0",
                  confirmed: ":attribute potrditev se ne ujema.",
                  date: ":attribute ni veljaven datum.",
                  date_format: ":attribute se ne ujema z obliko :format.",
                  different: ":attribute in :other mora biti drugačen.",
                  digits: ":attribute mora imeti :digits cifer.",
                  digits_between: ":attribute mora biti med :min in :max ciframi.",
                  dimensions: ":attribute ima napačne dimenzije slike.",
                  distinct: ":attribute je duplikat.",
                  email: ":attribute mora biti veljaven e-poštni naslov.",
                  exists: "izbran :attribute je neveljaven.",
                  file: ":attribute mora biti datoteka.",
                  filled: ":attribute mora biti izpolnjen.",
                  gt: {
                      numeric: "The :attribute must be greater than :value.",
                      file: "The :attribute must be greater than :value kilobytes.",
                      string: "The :attribute must be greater than :value characters.",
                      array: "The :attribute must have more than :value items.",
                  },
                  gte: {
                      numeric: "The :attribute must be greater than or equal :value.",
                      file: "The :attribute must be greater than or equal :value kilobytes.",
                      string: "The :attribute must be greater than or equal :value characters.",
                      array: "The :attribute must have :value items or more.",
                  },
                  hex: "The :attribute field should have hexadecimal format",
                  image: ":attribute mora biti slika.",
                  in: "izbran :attribute je neveljaven.",
                  in_array: ":attribute ne obstaja v :other.",
                  integer: ":attribute mora biti število.",
                  ip: ":attribute mora biti veljaven IP naslov.",
                  ipv4: ":attribute mora biti veljaven IPv4 naslov.",
                  ipv6: ":attribute mora biti veljaven IPv6 naslov.",
                  json: ":attribute mora biti veljaven JSON tekst.",
                  lt: {
                      numeric: "The :attribute must be less than :value.",
                      file: "The :attribute must be less than :value kilobytes.",
                      string: "The :attribute must be less than :value characters.",
                      array: "The :attribute must have less than :value items.",
                  },
                  lte: {
                      numeric: "The :attribute must be less than or equal :value.",
                      file: "The :attribute must be less than or equal :value kilobytes.",
                      string: "The :attribute must be less than or equal :value characters.",
                      array: "The :attribute must not have more than :value items.",
                  },
                  max: {
                      numeric: ":attribute ne sme biti večje od :max.",
                      file: ":attribute ne sme biti večje :max kilobajtov.",
                      string: ":attribute ne sme biti večje :max znakov.",
                      array: ":attribute ne smejo imeti več kot :max elementov.",
                  },
                  mimes: ":attribute mora biti datoteka tipa: :values.",
                  mimetypes: ":attribute mora biti datoteka tipa: :values.",
                  min: { numeric: ":attribute mora biti vsaj dolžine :min.", file: ":attribute mora imeti vsaj :min kilobajtov.", string: ":attribute mora imeti vsaj :min znakov.", array: ":attribute mora imeti vsaj :min elementov." },
                  not_in: "izbran :attribute je neveljaven.",
                  not_regex: "The :attribute format is invalid.",
                  numeric: ":attribute mora biti število.",
                  present: "Polje :attribute mora biti prisotno.",
                  regex: "Format polja :attribute je neveljaven.",
                  required: "Polje :attribute je obvezno.",
                  required_if: "Polje :attribute je obvezno, če je :other enak :value.",
                  required_unless: "Polje :attribute je obvezno, razen če je :other v :values.",
                  required_with: "Polje :attribute je obvezno, če je :values prisoten.",
                  required_with_all: "Polje :attribute je obvezno, če so :values prisoten.",
                  required_without: "Polje :attribute je obvezno, če :values ni prisoten.",
                  required_without_all: "Polje :attribute je obvezno, če :values niso prisotni.",
                  same: "Polje :attribute in :other se morata ujemati.",
                  size: { numeric: ":attribute mora biti :size.", file: ":attribute mora biti :size kilobajtov.", string: ":attribute mora biti :size znakov.", array: ":attribute mora vsebovati :size elementov." },
                  string: ":attribute mora biti tekst.",
                  timezone: ":attribute mora biti časovna cona.",
                  unique: ":attribute je že zaseden.",
                  uploaded: "Nalaganje :attribute ni uspelo.",
                  url: ":attribute format je neveljaven.",
              };
          },
          6782: (e) => {
              e.exports = {
                  accepted: ":attribute duhet të pranohet.",
                  active_url: ":attribute nuk është adresë e saktë.",
                  after: ":attribute duhet të jetë datë pas :date.",
                  after_or_equal: "The :attribute must be a date after or equal to :date.",
                  alpha: ":attribute mund të përmbajë vetëm shkronja.",
                  alpha_dash: ":attribute mund të përmbajë vetëm shkronja, numra, dhe viza.",
                  alpha_num: ":attribute mund të përmbajë vetëm shkronja dhe numra.",
                  attributes: {},
                  array: ":attribute duhet të jetë një bashkësi (array).",
                  before: ":attribute duhet të jetë datë para :date.",
                  before_or_equal: "The :attribute must be a date before or equal to :date.",
                  between: {
                      numeric: ":attribute duhet të jetë midis :min - :max.",
                      file: ":attribute duhet të jetë midis :min - :max kilobajtëve.",
                      string: ":attribute duhet të jetë midis :min - :max karaktereve.",
                      array: ":attribute duhet të jetë midis :min - :max elementëve.",
                  },
                  boolean: "Fusha :attribute duhet të jetë e vërtetë ose e gabuar",
                  confirmed: ":attribute konfirmimi nuk përputhet.",
                  date: ":attribute nuk është një datë e saktë.",
                  date_format: ":attribute nuk i përshtatet formatit :format.",
                  different: ":attribute dhe :other duhet të jenë të ndryshme.",
                  digits: ":attribute duhet të jetë :digits shifra.",
                  digits_between: ":attribute duhet të jetë midis :min dhe :max shifra.",
                  dimensions: "The :attribute has invalid image dimensions.",
                  distinct: "The :attribute field has a duplicate value.",
                  email: ":attribute formati është i pasaktë.",
                  exists: ":attribute përzgjedhur është i/e pasaktë.",
                  file: "The :attribute must be a file.",
                  filled: "Fusha :attribute është e kërkuar.",
                  gt: {
                      numeric: "The :attribute must be greater than :value.",
                      file: "The :attribute must be greater than :value kilobytes.",
                      string: "The :attribute must be greater than :value characters.",
                      array: "The :attribute must have more than :value items.",
                  },
                  gte: {
                      numeric: "The :attribute must be greater than or equal :value.",
                      file: "The :attribute must be greater than or equal :value kilobytes.",
                      string: "The :attribute must be greater than or equal :value characters.",
                      array: "The :attribute must have :value items or more.",
                  },
                  hex: "The :attribute field should have hexadecimal format",
                  image: ":attribute duhet të jetë imazh.",
                  in: ":attribute përzgjedhur është i/e pasaktë.",
                  in_array: "The :attribute field does not exist in :other.",
                  integer: ":attribute duhet të jetë numër i plotë.",
                  ip: ":attribute duhet të jetë një IP adresë e saktë.",
                  ipv4: "The :attribute must be a valid IPv4 address.",
                  ipv6: "The :attribute must be a valid IPv6 address.",
                  json: "The :attribute must be a valid JSON string.",
                  lt: {
                      numeric: "The :attribute must be less than :value.",
                      file: "The :attribute must be less than :value kilobytes.",
                      string: "The :attribute must be less than :value characters.",
                      array: "The :attribute must have less than :value items.",
                  },
                  lte: {
                      numeric: "The :attribute must be less than or equal :value.",
                      file: "The :attribute must be less than or equal :value kilobytes.",
                      string: "The :attribute must be less than or equal :value characters.",
                      array: "The :attribute must not have more than :value items.",
                  },
                  max: {
                      numeric: ":attribute nuk mund të jetë më tepër se :max.",
                      file: ":attribute nuk mund të jetë më tepër se :max kilobajtë.",
                      string: ":attribute nuk mund të jetë më tepër se :max karaktere.",
                      array: ":attribute nuk mund të ketë më tepër se :max elemente.",
                  },
                  mimes: ":attribute duhet të jetë një dokument i tipit: :values.",
                  mimetypes: ":attribute duhet të jetë një dokument i tipit: :values.",
                  min: {
                      numeric: ":attribute nuk mund të jetë më pak se :min.",
                      file: ":attribute nuk mund të jetë më pak se :min kilobajtë.",
                      string: ":attribute nuk mund të jetë më pak se :min karaktere.",
                      array: ":attribute nuk mund të ketë më pak se :min elemente.",
                  },
                  not_in: ":attribute përzgjedhur është i/e pasaktë.",
                  not_regex: "The :attribute format is invalid.",
                  numeric: ":attribute duhet të jetë një numër.",
                  present: "The :attribute field must be present.",
                  regex: "Formati i :attribute është i pasaktë.",
                  required: "Fusha :attribute është e kërkuar.",
                  required_if: "Fusha :attribute është e kërkuar kur :other është :value.",
                  required_unless: "The :attribute field is required unless :other is in :values.",
                  required_with: "Fusha :attribute është e kërkuar kur :values ekziston.",
                  required_with_all: "Fusha :attribute është e kërkuar kur :values ekziston.",
                  required_without: "Fusha :attribute është e kërkuar kur :values nuk ekziston.",
                  required_without_all: "Fusha :attribute është e kërkuar kur nuk ekziston asnjë nga :values.",
                  same: ":attribute dhe :other duhet të përputhen.",
                  size: { numeric: ":attribute duhet të jetë :size.", file: ":attribute duhet të jetë :size kilobajtë.", string: ":attribute duhet të jetë :size karaktere.", array: ":attribute duhet të ketë :size elemente." },
                  string: ":attribute duhet të jetë varg.",
                  timezone: ":attribute duhet të jetë zonë e saktë.",
                  unique: ":attribute është marrë tashmë.",
                  uploaded: "The :attribute failed to upload.",
                  url: "Formati i :attribute është i pasaktë.",
              };
          },
          2964: (e) => {
              e.exports = {
                  accepted: "Polje :attribute mora biti prihvaćeno.",
                  active_url: "Polje :attribute nije validan URL.",
                  after: "Polje :attribute mora biti datum posle :date.",
                  after_or_equal: "The :attribute must be a date after or equal to :date.",
                  alpha: "Polje :attribute može sadržati samo slova.",
                  alpha_dash: "Polje :attribute može sadržati samo slova, brojeve i povlake.",
                  alpha_num: "Polje :attribute može sadržati samo slova i brojeve.",
                  attributes: {},
                  array: "Polje :attribute mora sadržati nekih niz stavki.",
                  before: "Polje :attribute mora biti datum pre :date.",
                  before_or_equal: "The :attribute must be a date before or equal to :date.",
                  between: {
                      numeric: "Polje :attribute mora biti između :min - :max.",
                      file: "Fajl :attribute mora biti između :min - :max kilobajta.",
                      string: "Polje :attribute mora biti između :min - :max karaktera.",
                      array: "Polje :attribute mora biti između :min - :max stavki.",
                  },
                  boolean: "Polje :attribute mora biti tačno ili netačno",
                  confirmed: "Potvrda polja :attribute se ne poklapa.",
                  date: "Polje :attribute nije važeći datum.",
                  date_format: "Polje :attribute ne odgovora prema formatu :format.",
                  different: "Polja :attribute i :other moraju biti različita.",
                  digits: "Polje :attribute mora sadržati :digits šifri.",
                  digits_between: "Polje :attribute mora biti izemđu :min i :max šifri.",
                  dimensions: "The :attribute has invalid image dimensions.",
                  distinct: "The :attribute field has a duplicate value.",
                  email: "Format polja :attribute nije validan.",
                  exists: "Odabrano polje :attribute nije validno.",
                  file: "The :attribute must be a file.",
                  filled: "Polje :attribute je obavezno.",
                  gt: {
                      numeric: "The :attribute must be greater than :value.",
                      file: "The :attribute must be greater than :value kilobytes.",
                      string: "The :attribute must be greater than :value characters.",
                      array: "The :attribute must have more than :value items.",
                  },
                  gte: {
                      numeric: "The :attribute must be greater than or equal :value.",
                      file: "The :attribute must be greater than or equal :value kilobytes.",
                      string: "The :attribute must be greater than or equal :value characters.",
                      array: "The :attribute must have :value items or more.",
                  },
                  hex: "The :attribute field should have hexadecimal format",
                  image: "Polje :attribute mora biti slika.",
                  in: "Odabrano polje :attribute nije validno.",
                  in_array: "The :attribute field does not exist in :other.",
                  integer: "Polje :attribute mora biti broj.",
                  ip: "Polje :attribute mora biti validna IP adresa.",
                  ipv4: "The :attribute must be a valid IPv4 address.",
                  ipv6: "The :attribute must be a valid IPv6 address.",
                  json: "The :attribute must be a valid JSON string.",
                  lt: {
                      numeric: "The :attribute must be less than :value.",
                      file: "The :attribute must be less than :value kilobytes.",
                      string: "The :attribute must be less than :value characters.",
                      array: "The :attribute must have less than :value items.",
                  },
                  lte: {
                      numeric: "The :attribute must be less than or equal :value.",
                      file: "The :attribute must be less than or equal :value kilobytes.",
                      string: "The :attribute must be less than or equal :value characters.",
                      array: "The :attribute must not have more than :value items.",
                  },
                  max: {
                      numeric: "Polje :attribute mora biti manje od :max.",
                      file: "Polje :attribute mora biti manje od :max kilobajta.",
                      string: "Polje :attribute mora sadržati manje od :max karaktera.",
                      array: "Polje :attribute ne smije da image više od :max stavki.",
                  },
                  mimes: "Polje :attribute mora biti fajl tipa: :values.",
                  mimetypes: "Polje :attribute mora biti fajl tipa: :values.",
                  min: {
                      numeric: "Polje :attribute mora biti najmanje :min.",
                      file: "Fajl :attribute mora biti najmanje :min kilobajta.",
                      string: "Polje :attribute mora sadržati najmanje :min karaktera.",
                      array: "Polje :attribute mora sadrzati najmanje :min stavku.",
                  },
                  not_in: "Odabrani element polja :attribute nije validan.",
                  not_regex: "The :attribute format is invalid.",
                  numeric: "Polje :attribute mora biti broj.",
                  present: "The :attribute field must be present.",
                  regex: "Format polja :attribute nije validan.",
                  required: "Polje :attribute je obavezno.",
                  required_if: "Polje :attribute je potrebno kada polje :other sadrži :value.",
                  required_unless: "The :attribute field is required unless :other is in :values.",
                  required_with: "Polje :attribute je potrebno kada polje :values je prisutan.",
                  required_with_all: "Polje :attribute je obavezno kada je :values prikazano.",
                  required_without: "Polje :attribute je potrebno kada polje :values nije prisutan.",
                  required_without_all: "Polje :attribute je potrebno kada nijedan od sledeći polja :values nisu prisutni.",
                  same: "Polja :attribute i :other se moraju poklapati.",
                  size: { numeric: "Polje :attribute mora biti :size.", file: "Fajl :attribute mora biti :size kilobajta.", string: "Polje :attribute mora biti :size karaktera.", array: "Polje :attribute mora sadržati :size stavki." },
                  string: "Polje :attribute mora sadržati slova.",
                  timezone: "Polje :attribute mora biti ispravna vremenska zona.",
                  unique: "Polje :attribute već postoji.",
                  uploaded: "The :attribute failed to upload.",
                  url: "Format polja :attribute ne važi.",
              };
          },
          6892: (e) => {
              e.exports = {
                  accepted: ":attribute måste accepteras.",
                  active_url: ":attribute är inte en giltig webbadress.",
                  after: ":attribute måste vara ett datum efter den :date.",
                  after_or_equal: ":attribute måste vara ett datum senare eller samma dag som :date.",
                  alpha: ":attribute får endast innehålla bokstäver.",
                  alpha_dash: ":attribute får endast innehålla bokstäver, siffror och bindestreck.",
                  alpha_num: ":attribute får endast innehålla bokstäver och siffror.",
                  array: ":attribute måste vara en array.",
                  before: ":attribute måste vara ett datum innan den :date.",
                  before_or_equal: ":attribute måste vara ett datum före eller samma dag som :date.",
                  between: {
                      numeric: ":attribute måste vara en siffra mellan :min och :max.",
                      file: ":attribute måste vara mellan :min till :max kilobyte stor.",
                      string: ":attribute måste innehålla :min till :max tecken.",
                      array: ":attribute måste innehålla mellan :min - :max objekt.",
                  },
                  boolean: ":attribute måste vara sant eller falskt.",
                  confirmed: ":attribute bekräftelsen matchar inte.",
                  date: ":attribute är inte ett giltigt datum.",
                  date_format: ":attribute matchar inte formatet :format.",
                  different: ":attribute och :other får inte vara lika.",
                  digits: ":attribute måste vara :digits tecken.",
                  digits_between: ":attribute måste vara mellan :min och :max tecken.",
                  dimensions: ":attribute har felaktiga bilddimensioner.",
                  distinct: ":attribute innehåller fler än en repetition av samma element.",
                  email: ":attribute måste innehålla en korrekt e-postadress.",
                  exists: ":attribute är ogiltigt.",
                  file: ":attribute måste vara en fil.",
                  filled: ":attribute är obligatoriskt.",
                  gt: {
                      numeric: ":attribute måste vara större än :value.",
                      file: ":attribute måste vara större än :value kilobyte stor.",
                      string: ":attribute måste vara längre än :value tecken.",
                      array: ":attribute måste innehålla fler än :value objekt.",
                  },
                  gte: {
                      numeric: ":attribute måste vara lika med eller större än :value.",
                      file: ":attribute måste vara lika med eller större än :value kilobyte stor.",
                      string: ":attribute måste vara lika med eller längre än :value tecken.",
                      array: ":attribute måste innehålla lika många eller fler än :value objekt.",
                  },
                  hex: "The :attribute field should have hexadecimal format",
                  image: ":attribute måste vara en bild.",
                  in: ":attribute är ogiltigt.",
                  in_array: ":attribute finns inte i :other.",
                  integer: ":attribute måste vara en siffra.",
                  ip: ":attribute måste vara en giltig IP-adress.",
                  ipv4: ":attribute måste vara en giltig IPv4-adress.",
                  ipv6: ":attribute måste vara en giltig IPv6-adress.",
                  json: ":attribute måste vara en giltig JSON-sträng.",
                  lt: {
                      numeric: ":attribute måste vara mindre än :value.",
                      file: ":attribute måste vara mindre än :value kilobyte stor.",
                      string: ":attribute måste vara kortare än :value tecken.",
                      array: ":attribute måste innehålla färre än :value objekt.",
                  },
                  lte: {
                      numeric: ":attribute måste vara lika med eller mindre än :value.",
                      file: ":attribute måste vara lika med eller mindre än :value kilobyte stor.",
                      string: ":attribute måste vara lika med eller kortare än :value tecken.",
                      array: ":attribute måste innehålla lika många eller färre än :value objekt.",
                  },
                  max: {
                      numeric: ":attribute får inte vara större än :max.",
                      file: ":attribute får max vara :max kilobyte stor.",
                      string: ":attribute får max innehålla :max tecken.",
                      array: ":attribute får inte innehålla mer än :max objekt.",
                  },
                  mimes: ":attribute måste vara en fil av typen: :values.",
                  mimetypes: ":attribute måste vara en fil av typen: :values.",
                  min: {
                      numeric: ":attribute måste vara större än :min.",
                      file: ":attribute måste vara minst :min kilobyte stor.",
                      string: ":attribute måste innehålla minst :min tecken.",
                      array: ":attribute måste innehålla minst :min objekt.",
                  },
                  not_in: ":attribute är ogiltigt.",
                  not_regex: "Formatet för :attribute är ogiltigt.",
                  numeric: ":attribute måste vara en siffra.",
                  present: ":attribute måste finnas med.",
                  regex: ":attribute har ogiltigt format.",
                  required: ":attribute är obligatoriskt.",
                  required_if: ":attribute är obligatoriskt när :other är :value.",
                  required_unless: ":attribute är obligatoriskt när inte :other finns bland :values.",
                  required_with: ":attribute är obligatoriskt när :values är ifyllt.",
                  required_with_all: ":attribute är obligatoriskt när :values är ifyllt.",
                  required_without: ":attribute är obligatoriskt när :values ej är ifyllt.",
                  required_without_all: ":attribute är obligatoriskt när ingen av :values är ifyllt.",
                  same: ":attribute och :other måste vara lika.",
                  size: { numeric: ":attribute måste vara :size.", file: ":attribute får endast vara :size kilobyte stor.", string: ":attribute måste innehålla :size tecken.", array: ":attribute måste innehålla :size objekt." },
                  string: ":attribute måste vara en sträng.",
                  timezone: ":attribute måste vara en giltig tidszon.",
                  unique: ":attribute används redan.",
                  uploaded: ":attribute kunde inte laddas upp.",
                  url: ":attribute har ett ogiltigt format.",
              };
          },
          5584: (e) => {
              e.exports = {
                  accepted: ":attribute kabul edilmeli.",
                  after: ":attribute alanı :after alanından sonra olmalıdır.",
                  after_or_equal: ":attribute alanı :after_or_equal alanına eşit veya sonra olmalıdır.",
                  alpha: ":attribute alanı sadece harflerden oluşabilir.",
                  alpha_dash: ":attribute alanı sadece alfa-nümerik, tire ve alt çizgi karakterlerden oluşabilir.",
                  alpha_num: ":attribute alanı alfa-nümerik olmalıdır.",
                  before: ":attribute alanı :before alanından önce olmalıdır.",
                  before_or_equal: ":attribute alanı :before_or_equal alanına eşit veya önce olmalıdır.",
                  between: ":attribute alanı :min ile :max arasında olabilir.",
                  confirmed: ":attribute uyuşmuyor.",
                  email: ":attribute formatı geçersiz.",
                  date: ":attribute geöerli bir tarih alanı değil.",
                  def: ":attribute hatalar içeriyor.",
                  digits: ":attribute sadece rakamlardan oluşabilir.",
                  digits_between: ":attribute :min ile :max arasında rakam olmalıdır.",
                  different: ":attribute ve :different farklı olmalı.",
                  in: "Seçilen :attribute geçerli değil.",
                  integer: ":attribute tam sayı olmalı.",
                  hex: ":attribute onaltılık formatta olmalı.",
                  min: { numeric: ":attribute en az :min olmalı.", string: ":attribute en az :min karakter uzunluğunda olmalı." },
                  max: { numeric: ":attribute en çok :max olabilir.", string: ":attribute uzunluğu en çok :max karakter uzunluğunda olabilir." },
                  not_in: "Seçilen :attribute geçerli değil.",
                  numeric: ":attribute sayı olmalı.",
                  present: ":attribute alanı bulunmalıdır (ancak boş olabilir).",
                  required: ":attribute alanı gerekli.",
                  required_if: ":attribute alanı :other alanı :value olduğunda gerekli.",
                  required_unless: ":attribute alanı :other alanı :value değilse gereklidir.",
                  required_with: ":attribute alanı :field boş değilse gereklidir.",
                  required_with_all: ":attribute alanı :fields alanları boş değilse gereklidir.",
                  required_without: ":attribute alanı :field alanı boşsa gereklidir.",
                  required_without_all: ":attribute alanı :fields alanları boşsa gereklidir.",
                  same: ":attribute ve :same aynı olmalı.",
                  size: { numeric: ":attribute :size olmalı.", string: ":attribute :size karakter uzunluğunda olmalı." },
                  string: ":attribute alfa-numerik olmalı.",
                  url: ":attribute formatı geçersiz.",
                  regex: ":attribute formatı geçersiz.",
                  attributes: {},
              };
          },
          6773: (e) => {
              e.exports = {
                  accepted: ":attribute повиннен бути прийнятий.",
                  alpha: "Поле :attribute може складатись тільки з літер.",
                  alpha_dash: "Поле :attribute може складатись тільки з літер, чисел, дефісів та символів підкреслення.",
                  alpha_num: "Поле :attribute може складатись тільки з літер та чисел.",
                  between: "Значення поля :attribute повинно знаходитись між :min і :max.",
                  confirmed: "Поле :attribute не співпадає з підтвердженням.",
                  email: "Значення поля :attribute повинно бути існуючою електронною адресою.",
                  def: "Поле :attribute містить помилки.",
                  digits: "Довжина числового поля :attribute повинна бути :digits.",
                  digits_between: "Довжина цифрового поля :attribute повинна бути від :min до :max.",
                  different: "Поля :attribute і :different повинні відрізнятись.",
                  in: "Обране значення для :attribute помилкове.",
                  integer: "Значення поля :attribute повинно бути цілим числом.",
                  hex: "Значення поля :attribute повинно бути шістнадцяткового формату",
                  min: { numeric: "Значення поля :attribute повинно бути більшим або рівним :min.", string: "Кількість символів в полі :attribute повинна бути не менше :min." },
                  max: { numeric: "Значення поля :attribute повинно бути менше або рівне :max.", string: "Кількість символів в полі :attribute не може превищувати :max." },
                  not_in: "Обране значення для :attribute помилкове.",
                  numeric: "Значення поля :attribute повинно бути числом.",
                  present: "Поле :attribute повинно бути присутнім (але може бути пустим).",
                  required: "Поле :attribute обов'язкове для заповнення.",
                  required_if: "Поле :attribute потрібне у випадку коли значення поля :other рівне :value.",
                  same: "Значеня поля :attribute повинно співпадати з :same.",
                  size: { numeric: "Значення поля :attribute повинно бути рівним :size.", string: "Кількість символів в полі :attribute повинна бути рівною :size." },
                  url: "Поле :attribute повинне містити валідний URL.",
                  regex: "Неправильний формат значення :attribute.",
                  attributes: {},
              };
          },
          9814: (e) => {
              e.exports = {
                  accepted: "Ви повинні прийняти :attribute.",
                  active_url: "Поле :attribute не є правильним URL.",
                  after: "Поле :attribute має містити дату не раніше :date.",
                  after_or_equal: "Поле :attribute має містити дату не раніше або дорівнюватися :date.",
                  alpha: "Поле :attribute має містити лише літери.",
                  alpha_dash: "Поле :attribute має містити лише літери, цифри та підкреслення.",
                  alpha_num: "Поле :attribute має містити лише літери та цифри.",
                  attributes: {},
                  array: "Поле :attribute має бути масивом.",
                  before: "Поле :attribute має містити дату не пізніше :date.",
                  before_or_equal: "Поле :attribute має містити дату не пізніше або дорівнюватися :date.",
                  between: {
                      numeric: "Поле :attribute має бути між :min та :max.",
                      file: "Розмір файлу в полі :attribute має бути не менше :min та не більше :max кілобайт.",
                      string: "Текст в полі :attribute має бути не менше :min та не більше :max символів.",
                      array: "Поле :attribute має містити від :min до :max елементів.",
                  },
                  boolean: "Поле :attribute повинне містити логічний тип.",
                  confirmed: "Поле :attribute не збігається з підтвердженням.",
                  date: "Поле :attribute не є датою.",
                  date_format: "Поле :attribute не відповідає формату :format.",
                  different: "Поля :attribute та :other повинні бути різними.",
                  digits: "Довжина цифрового поля :attribute повинна дорівнювати :digits.",
                  digits_between: "Довжина цифрового поля :attribute повинна бути від :min до :max.",
                  dimensions: "Поле :attribute містіть неприпустимі розміри зображення.",
                  distinct: "Поле :attribute містить значення, яке дублюється.",
                  email: "Поле :attribute повинне містити коректну електронну адресу.",
                  file: "Поле :attribute має містити файл.",
                  filled: "Поле :attribute є обов'язковим для заповнення.",
                  exists: "Вибране для :attribute значення не коректне.",
                  gt: {
                      numeric: "The :attribute must be greater than :value.",
                      file: "The :attribute must be greater than :value kilobytes.",
                      string: "The :attribute must be greater than :value characters.",
                      array: "The :attribute must have more than :value items.",
                  },
                  gte: {
                      numeric: "The :attribute must be greater than or equal :value.",
                      file: "The :attribute must be greater than or equal :value kilobytes.",
                      string: "The :attribute must be greater than or equal :value characters.",
                      array: "The :attribute must have :value items or more.",
                  },
                  hex: "The :attribute field should have hexadecimal format",
                  image: "Поле :attribute має містити зображення.",
                  in: "Вибране для :attribute значення не коректне.",
                  in_array: "Значення поля :attribute не міститься в :other.",
                  integer: "Поле :attribute має містити ціле число.",
                  ip: "Поле :attribute має містити IP адресу.",
                  ipv4: "Поле :attribute має містити IPv4 адресу.",
                  ipv6: "Поле :attribute має містити IPv6 адресу.",
                  json: "Дані поля :attribute мають бути в форматі JSON.",
                  lt: {
                      numeric: "The :attribute must be less than :value.",
                      file: "The :attribute must be less than :value kilobytes.",
                      string: "The :attribute must be less than :value characters.",
                      array: "The :attribute must have less than :value items.",
                  },
                  lte: {
                      numeric: "The :attribute must be less than or equal :value.",
                      file: "The :attribute must be less than or equal :value kilobytes.",
                      string: "The :attribute must be less than or equal :value characters.",
                      array: "The :attribute must not have more than :value items.",
                  },
                  max: {
                      numeric: "Поле :attribute має бути не більше :max.",
                      file: "Файл в полі :attribute має бути не більше :max кілобайт.",
                      string: "Текст в полі :attribute повинен мати довжину не більшу за :max.",
                      array: "Поле :attribute повинне містити не більше :max елементів.",
                  },
                  mimes: "Поле :attribute повинне містити файл одного з типів: :values.",
                  mimetypes: "Поле :attribute повинне містити файл одного з типів: :values.",
                  min: {
                      numeric: "Поле :attribute повинне бути не менше :min.",
                      file: "Розмір файлу в полі :attribute має бути не меншим :min кілобайт.",
                      string: "Текст в полі :attribute повинен містити не менше :min символів.",
                      array: "Поле :attribute повинне містити не менше :min елементів.",
                  },
                  not_in: "Вибране для :attribute значення не коректне.",
                  not_regex: "The :attribute format is invalid.",
                  numeric: "Поле :attribute повинно містити число.",
                  present: "Поле :attribute повинне бути присутнє.",
                  regex: "Поле :attribute має хибний формат.",
                  required: "Поле :attribute є обов'язковим для заповнення.",
                  required_if: "Поле :attribute є обов'язковим для заповнення, коли :other є рівним :value.",
                  required_unless: "Поле :attribute є обов'язковим для заповнення, коли :other відрізняється від :values",
                  required_with: "Поле :attribute є обов'язковим для заповнення, коли :values вказано.",
                  required_with_all: "Поле :attribute є обов'язковим для заповнення, коли :values вказано.",
                  required_without: "Поле :attribute є обов'язковим для заповнення, коли :values не вказано.",
                  required_without_all: "Поле :attribute є обов'язковим для заповнення, коли :values не вказано.",
                  same: "Поля :attribute та :other мають співпадати.",
                  size: {
                      numeric: "Поле :attribute має бути довжини :size.",
                      file: "Файл в полі :attribute має бути розміром :size кілобайт.",
                      string: "Текст в полі :attribute повинен містити :size символів.",
                      array: "Поле :attribute повинне містити :size елементів.",
                  },
                  string: "Поле :attribute повинне містити текст.",
                  timezone: "Поле :attribute повинне містити коректну часову зону.",
                  unique: "Таке значення поля :attribute вже існує.",
                  uploaded: "Завантаження поля :attribute не вдалося.",
                  url: "Формат поля :attribute неправильний.",
              };
          },
          7879: (e) => {
              e.exports = {
                  accepted: ":attribute phải được chấp nhận.",
                  alpha: "Trường :attribute phải là ký tự",
                  alpha_dash: ":attribute chỉ chấp nhận ký tự chữ cái, số, dấu gạch chéo và gạch dưới.",
                  alpha_num: ":attribute phải là ký tự chữ cái hoặc chữ số.",
                  between: ":attribute phải nằm trong khoảng :min và :max.",
                  confirmed: ":attribute xác nhận không trùng khớp.",
                  email: ":attribute không phải là email.",
                  date: ":attribute không phải là ngày hợp lệ",
                  def: "Thuộc tính :attribute có lỗi.",
                  digits: ":attribute phải là số và có chiều dài bằng :digits.",
                  digits_between: "Độ dài của trường :attribute phải nằm trong khoảng :min and :max chữ số.",
                  different: "Giá trị của hai trường :attribute và :different phải khác nhau.",
                  in: "Giá trị được chọn của :attribute không hợp lệ.",
                  integer: ":attribute phải là số nguyên.",
                  hex: "The :attribute should have hexadecimal format",
                  min: { numeric: ":attribute phải lớn hơn hoặc bằng :min.", string: ":attribute phải có ít nhất :min ký tự." },
                  max: { numeric: ":attribute phải nhỏ hơn hoặc bằng :max.", string: ":attribute phải có ít hơn :max ký tự." },
                  not_in: "Giá trị được chọn của trường :attribute không hợp lệ.",
                  numeric: ":attribute phải là số.",
                  present: "Trường :attribute phải có mặt (nhưng có thể để trống).",
                  required: ":attribute bắt buộc nhập.",
                  required_if: ":attribute là bắt buộc khi :other có giá trị :value.",
                  same: "Giá trị của :attribute và :same phải như nhau.",
                  size: { numeric: ":attribute phải có chiều dài của bằng :size.", string: "Số ký tự của :attribute phải là :size ký tự." },
                  string: ":attribute không phải là một chuỗi",
                  url: ":attribute không phải là một Url hợp lệ.",
                  regex: ":attribute không đúng định dạng",
                  attributes: {},
              };
          },
          755: (e) => {
              e.exports = {
                  accepted: ":attribute必须是可接受的.",
                  alpha: ":attribute只能包含字母.",
                  alpha_dash: ":attribute只能包含字母,连字符和下划线.",
                  alpha_num: ":attribute只能包含字母和数字.",
                  between: ":attribute的(大小,长度等)只能在:min和:max之间.",
                  confirmed: ":attribute确认不一致.",
                  email: ":attribute格式不正确.",
                  date: ":attribute日期格式错误.",
                  def: ":attribute属性错误.",
                  digits: ":attribute必须是:digits位小数.",
                  digits_between: ":attribute 必须是介于 :min 和 :max 位的数字。",
                  different: ":attribute和:different必须不同.",
                  in: "选择的:attribute无效",
                  integer: ":attribute必须是一个整数.",
                  hex: "The :attribute should have hexadecimal format",
                  min: { numeric: ":attribute不能小于:min.", string: ":attribute长度不能小于:min." },
                  max: { numeric: ":attribute不能大于:max.", string: ":attribute长度不能大于:max." },
                  not_in: "所选的:attribute无效.",
                  numeric: ":attribute必须是一个数字.",
                  present: "The :attribute field must be present (but can be empty).",
                  required: ":attribute不能为空.",
                  required_if: "当:other是:value时,:attribute不能为空.",
                  same: ":attribute和:same必须一致.",
                  size: { numeric: ":attribute必须等于:size.", string: ":attribute的长度必须等于:size." },
                  string: ":attribute必须是一个字符串.",
                  url: ":attribute格式不正确.",
                  regex: ":attribute格式不正确.",
                  attributes: {},
              };
          },
          9261: (e) => {
              e.exports = {
                  accepted: ":attribute必須接受。",
                  alpha: ":attribute只能包含字母。",
                  alpha_dash: ":attribute只能包含字母，連字符和下划線。",
                  alpha_num: ":attribute只能包含字母和數字。",
                  between: ":attribute的值只能在:min和:max之間。",
                  confirmed: ":attribute與確認輸入不一致。",
                  email: ":attribute的格式錯誤。",
                  date: ":attribute的日期格式錯誤。",
                  def: ":attribute屬性錯誤。",
                  digits: ":attribute必須是:digits位小數。",
                  digits_between: ":attribute 必須介於 :min 至 :max 位數字。",
                  different: ":attribute和:different必須不同。",
                  in: "選擇的:attribute無效",
                  integer: ":attribute必須是一個整數。",
                  hex: ":attribute 必須是十六進位格式",
                  min: { numeric: ":attribute不能小於:min。", string: ":attribute的長度不能小於:min." },
                  max: { numeric: ":attribute不能大於:max。", string: ":attribute的長度不能大於:max." },
                  not_in: "所選的:attribute無效。",
                  numeric: ":attribute必須是一個數字。",
                  present: ":attribute 一定要有值 (可以是空值)。",
                  required: ":attribute不能空白。",
                  required_if: "當:other是:value時,:attribute不能空白。",
                  same: ":attribute和:same必須一致。",
                  size: { numeric: ":attribute必須等於:size。", string: ":attribute的長度必須等於:size." },
                  string: ":attribute必須是一個字串。",
                  url: ":attribute格式不正確。",
                  regex: ":attribute格式不正確。",
                  attributes: {},
              };
          },
          2060: (e, t, a) => {
              var i = {
                  "./ar": 8528,
                  "./ar.js": 8528,
                  "./az": 8173,
                  "./az.js": 8173,
                  "./be": 7931,
                  "./be.js": 7931,
                  "./bg": 3188,
                  "./bg.js": 3188,
                  "./bs": 842,
                  "./bs.js": 842,
                  "./ca": 6918,
                  "./ca.js": 6918,
                  "./cs": 4590,
                  "./cs.js": 4590,
                  "./cy": 4475,
                  "./cy.js": 4475,
                  "./da": 9210,
                  "./da.js": 9210,
                  "./de": 1245,
                  "./de.js": 1245,
                  "./el": 4630,
                  "./el.js": 4630,
                  "./en": 437,
                  "./en.js": 437,
                  "./es": 5322,
                  "./es.js": 5322,
                  "./et": 279,
                  "./et.js": 279,
                  "./eu": 5e3,
                  "./eu.js": 5e3,
                  "./fa": 2927,
                  "./fa.js": 2927,
                  "./fi": 6496,
                  "./fi.js": 6496,
                  "./fr": 8899,
                  "./fr.js": 8899,
                  "./hr": 7494,
                  "./hr.js": 7494,
                  "./hu": 8789,
                  "./hu.js": 8789,
                  "./id": 2846,
                  "./id.js": 2846,
                  "./it": 830,
                  "./it.js": 830,
                  "./ja": 8938,
                  "./ja.js": 8938,
                  "./ka": 3330,
                  "./ka.js": 3330,
                  "./ko": 646,
                  "./ko.js": 646,
                  "./lt": 3772,
                  "./lt.js": 3772,
                  "./lv": 3421,
                  "./lv.js": 3421,
                  "./mk": 403,
                  "./mk.js": 403,
                  "./mn": 6079,
                  "./mn.js": 6079,
                  "./ms": 6311,
                  "./ms.js": 6311,
                  "./nb_NO": 2265,
                  "./nb_NO.js": 2265,
                  "./nl": 7741,
                  "./nl.js": 7741,
                  "./pl": 2756,
                  "./pl.js": 2756,
                  "./pt": 4865,
                  "./pt.js": 4865,
                  "./pt_BR": 9157,
                  "./pt_BR.js": 9157,
                  "./ro": 9296,
                  "./ro.js": 9296,
                  "./ru": 8576,
                  "./ru.js": 8576,
                  "./se": 1944,
                  "./se.js": 1944,
                  "./sl": 202,
                  "./sl.js": 202,
                  "./sq": 6782,
                  "./sq.js": 6782,
                  "./sr": 2964,
                  "./sr.js": 2964,
                  "./sv": 6892,
                  "./sv.js": 6892,
                  "./tr": 5584,
                  "./tr.js": 5584,
                  "./ua": 6773,
                  "./ua.js": 6773,
                  "./uk": 9814,
                  "./uk.js": 9814,
                  "./vi": 7879,
                  "./vi.js": 7879,
                  "./zh": 755,
                  "./zh.js": 755,
                  "./zh_TW": 9261,
                  "./zh_TW.js": 9261,
              };
              function r(e) {
                  var t = u(e);
                  return a(t);
              }
              function u(e) {
                  if (!a.o(i, e)) {
                      var t = new Error("Cannot find module '" + e + "'");
                      throw ((t.code = "MODULE_NOT_FOUND"), t);
                  }
                  return i[e];
              }
              (r.keys = function () {
                  return Object.keys(i);
              }),
                  (r.resolve = u),
                  (e.exports = r),
                  (r.id = 2060);
          },
          3367: (e, t, a) => {
              var i = a(6319),
                  r = function (e, t) {
                      (this.lang = e), (this.messages = t), (this.customMessages = {}), (this.attributeNames = {});
                  };
              (r.prototype = {
                  constructor: r,
                  _setCustom: function (e) {
                      this.customMessages = e || {};
                  },
                  _setAttributeNames: function (e) {
                      this.attributeNames = e;
                  },
                  _setAttributeFormatter: function (e) {
                      this.attributeFormatter = e;
                  },
                  _getAttributeName: function (e) {
                      var t = e;
                      return this.attributeNames.hasOwnProperty(e)
                          ? this.attributeNames[e]
                          : (this.messages.attributes.hasOwnProperty(e) && (t = this.messages.attributes[e]), this.attributeFormatter && (t = this.attributeFormatter(t)), t);
                  },
                  all: function () {
                      return this.messages;
                  },
                  render: function (e) {
                      if (e.customMessage) return e.customMessage;
                      var t = this._getTemplate(e);
                      return i.replacements[e.name] ? i.replacements[e.name].apply(this, [t, e]) : this._replacePlaceholders(e, t, {});
                  },
                  _getTemplate: function (e) {
                      for (var t, a = this.messages, i = a.def, r = this.customMessages, u = [e.name + "." + e.attribute, e.name], n = 0; n < u.length; n++) {
                          if (((t = u[n]), r.hasOwnProperty(t))) {
                              i = r[t];
                              break;
                          }
                          if (a.hasOwnProperty(t)) {
                              i = a[t];
                              break;
                          }
                      }
                      return "object" == typeof i && (i = i[e._getValueType()]), i;
                  },
                  _replacePlaceholders: function (e, t, a) {
                      var i, r;
                      if (((a.attribute = this._getAttributeName(e.attribute)), (a[e.name] = a[e.name] || e.getParameters().join(",")), "string" == typeof t && "object" == typeof a))
                          for (r in ((i = t), a)) i = i.replace(new RegExp(":" + r, "g"), a[r]);
                      return i;
                  },
              }),
                  (e.exports = r);
          },
          1846: (e) => {
              function t(e) {
                  let t;
                  if ("number" == typeof e && ((t = new Date(e)), "object" == typeof t)) return !0;
                  if (((t = new Date(e)), "object" == typeof t))
                      return (
                          "Invalid Date" !== t.toString() &&
                          !!(function (e = "") {
                              if (10 === e.length) {
                                  let a = e.replace(".", "-").replace("/", "-").split("-");
                                  if (3 === a.length && 4 === a[0].length) {
                                      let e = parseInt(a[0]),
                                          i = parseInt(a[1]),
                                          r = parseInt(a[2]);
                                      if (2 === i)
                                          if (((t = e) % 4 == 0 && t % 100 != 0) || t % 400 == 0) {
                                              if (r > 29) return !1;
                                          } else if (r > 28) return !1;
                                      if ((4 === i || 6 === i || 9 === i || 11 === i) && r > 30) return !1;
                                  }
                                  return !0;
                              }
                              var t;
                              return !0;
                          })(e)
                      );
                  if (!/^\d{4}\-\d{1,2}\-\d{1,2}$/.test(e)) return !1;
                  var a = e.split("-"),
                      i = parseInt(a[2], 10),
                      r = parseInt(a[1], 10),
                      u = parseInt(a[0], 10);
                  if (u < 1e3 || u > 3e3 || 0 == r || r > 12) return !1;
                  var n = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
                  return (u % 400 == 0 || (u % 100 != 0 && u % 4 == 0)) && (n[1] = 29), i > 0 && i <= n[r - 1];
              }
              var a,
                  i = {
                      required: function (e) {
                          return null != e && String(e).replace(/\s/g, "").length > 0;
                      },
                      required_if: function (e, t, a) {
                          return (t = this.getParameters()), this.validator._objectPath(this.validator.input, t[0]) !== t[1] || this.validator.getRule("required").validate(e);
                      },
                      required_unless: function (e, t, a) {
                          return (t = this.getParameters()), this.validator._objectPath(this.validator.input, t[0]) === t[1] || this.validator.getRule("required").validate(e);
                      },
                      required_with: function (e, t, a) {
                          return !this.validator._objectPath(this.validator.input, t) || this.validator.getRule("required").validate(e);
                      },
                      required_with_all: function (e, t, a) {
                          t = this.getParameters();
                          for (var i = 0; i < t.length; i++) if (!this.validator._objectPath(this.validator.input, t[i])) return !0;
                          return this.validator.getRule("required").validate(e);
                      },
                      required_without: function (e, t, a) {
                          return !!this.validator._objectPath(this.validator.input, t) || this.validator.getRule("required").validate(e);
                      },
                      required_without_all: function (e, t, a) {
                          t = this.getParameters();
                          for (var i = 0; i < t.length; i++) if (this.validator._objectPath(this.validator.input, t[i])) return !0;
                          return this.validator.getRule("required").validate(e);
                      },
                      boolean: function (e) {
                          return !0 === e || !1 === e || 0 === e || 1 === e || "0" === e || "1" === e || "true" === e || "false" === e;
                      },
                      size: function (e, t, a) {
                          return !e || ((t = parseFloat(t)), this.getSize() === t);
                      },
                      string: function (e, t, a) {
                          return "string" == typeof e;
                      },
                      sometimes: function (e) {
                          return !0;
                      },
                      min: function (e, t, a) {
                          return this.getSize() >= t;
                      },
                      max: function (e, t, a) {
                          return this.getSize() <= t;
                      },
                      between: function (e, t, a) {
                          t = this.getParameters();
                          var i = this.getSize(),
                              r = parseFloat(t[0], 10),
                              u = parseFloat(t[1], 10);
                          return i >= r && i <= u;
                      },
                      email: function (e) {
                          var t = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                          return (
                              t.test(e) ||
                                  (t = /^((?:[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]|[^\u0000-\u007F])+@(?:[a-zA-Z0-9]|[^\u0000-\u007F])(?:(?:[a-zA-Z0-9-]|[^\u0000-\u007F]){0,61}(?:[a-zA-Z0-9]|[^\u0000-\u007F]))?(?:\.(?:[a-zA-Z0-9]|[^\u0000-\u007F])(?:(?:[a-zA-Z0-9-]|[^\u0000-\u007F]){0,61}(?:[a-zA-Z0-9]|[^\u0000-\u007F]))?)+)*$/),
                              t.test(e)
                          );
                      },
                      numeric: function (e) {
                          var t;
                          return "number" == typeof (t = Number(e)) && !isNaN(t) && "boolean" != typeof e;
                      },
                      array: function (e) {
                          return e instanceof Array;
                      },
                      url: function (e) {
                          return /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_\+.~#?&/=]*)/i.test(e);
                      },
                      alpha: function (e) {
                          return /^[a-zA-Z]+$/.test(e);
                      },
                      alpha_dash: function (e) {
                          return /^[a-zA-Z0-9_\-]+$/.test(e);
                      },
                      alpha_num: function (e) {
                          return /^[a-zA-Z0-9]+$/.test(e);
                      },
                      same: function (e, t) {
                          return this.validator._flattenObject(this.validator.input)[t] === e;
                      },
                      different: function (e, t) {
                          return this.validator._flattenObject(this.validator.input)[t] !== e;
                      },
                      in: function (e, t) {
                          var a, i;
                          if ((e && (a = this.getParameters()), e && !(e instanceof Array))) {
                              var r = e;
                              for (i = 0; i < a.length; i++) if (("string" == typeof a[i] && (r = String(e)), r === a[i])) return !0;
                              return !1;
                          }
                          if (e && e instanceof Array) for (i = 0; i < e.length; i++) if (a.indexOf(e[i]) < 0) return !1;
                          return !0;
                      },
                      not_in: function (e, t) {
                          for (var a = this.getParameters(), i = a.length, r = !0, u = 0; u < i; u++) {
                              var n = e;
                              if (("string" == typeof a[u] && (n = String(e)), n === a[u])) {
                                  r = !1;
                                  break;
                              }
                          }
                          return r;
                      },
                      accepted: function (e) {
                          return "on" === e || "yes" === e || 1 === e || "1" === e || !0 === e;
                      },
                      confirmed: function (e, t, a) {
                          var i = a + "_confirmation";
                          return this.validator.input[i] === e;
                      },
                      integer: function (e) {
                          return String(parseInt(e, 10)) === String(e);
                      },
                      digits: function (e, t) {
                          return !(!this.validator.getRule("numeric").validate(e) || String(e.trim()).length !== parseInt(t));
                      },
                      digits_between: function (e) {
                          var t = this.validator.getRule("numeric"),
                              a = this.getParameters(),
                              i = String(e).length,
                              r = parseFloat(a[0], 10),
                              u = parseFloat(a[1], 10);
                          return !!(t.validate(e) && i >= r && i <= u);
                      },
                      regex: function (e, t) {
                          var a = /[g|i|m]{1,3}$/,
                              i = t.match(a);
                          return (i = i ? i[0] : ""), (t = t.replace(a, "").slice(1, -1)), !!(t = new RegExp(t, i)).test(e);
                      },
                      date: function (e, a) {
                          return t(e);
                      },
                      present: function (e) {
                          return void 0 !== e;
                      },
                      after: function (e, a) {
                          var i = this.validator.input[a],
                              r = e;
                          return !!t(i) && !!t(r) && new Date(i).getTime() < new Date(r).getTime();
                      },
                      after_or_equal: function (e, a) {
                          var i = this.validator.input[a],
                              r = e;
                          return !!t(i) && !!t(r) && new Date(i).getTime() <= new Date(r).getTime();
                      },
                      before: function (e, a) {
                          var i = this.validator.input[a],
                              r = e;
                          return !!t(i) && !!t(r) && new Date(i).getTime() > new Date(r).getTime();
                      },
                      before_or_equal: function (e, a) {
                          var i = this.validator.input[a],
                              r = e;
                          return !!t(i) && !!t(r) && new Date(i).getTime() >= new Date(r).getTime();
                      },
                      hex: function (e) {
                          return /^[0-9a-f]+$/i.test(e);
                      },
                      ipv4: function (e, t, a) {
                          if ("string" != typeof e) return !1;
                          var i = /^[0-9]+$/;
                          if (((octets = e.split(".")), 4 != octets.length)) return !1;
                          for (let e = 0; e < octets.length; e++) {
                              const t = octets[e];
                              if (!i.test(t)) return !1;
                              if (parseInt(t) >= 256) return !1;
                          }
                          return !0;
                      },
                      ipv6: function (e, t, a) {
                          if ("string" != typeof e) return !1;
                          var i = /^[0-9a-f]+$/;
                          if (((hextets = e.split(":")), (colons = e.match(/::/)), null != colons && e.match(/::/g).length > 1)) return !1;
                          if (":" == e[0] && (null == colons || (null != colons && 0 != colons.index))) return !1;
                          if (":" == e[e.length - 1] && (null == colons || (null != colons && colons.index != e.length - 2))) return !1;
                          if (3 > hextets.length) return !1;
                          var r = 9 == hextets.length && null != colons && (0 == colons.index || colons.index == e.length - 2);
                          if (hextets.length > 8 && !r) return !1;
                          if (8 != hextets.length && null == colons) return !1;
                          for (let e = 0; e < hextets.length; e++) {
                              const t = hextets[e];
                              if (0 != t.length) {
                                  if (!i.test(t)) return !1;
                                  if (t.length > 4) return !1;
                              }
                          }
                          return !0;
                      },
                      ip: function (e, t, a) {
                          return i.ipv4(e, t, a) || i.ipv6(e, t, a);
                      },
                  },
                  r = function () {
                      throw new Error("Validator `" + this.name + "` is not defined!");
                  };
              function u(e, t, a) {
                  (this.name = e), (this.fn = t), (this.passes = null), (this._customMessage = void 0), (this.async = a);
              }
              u.prototype = {
                  validate: function (e, t, a, i) {
                      var r = this;
                      if ((this._setValidatingData(a, e, t), "function" == typeof i)) {
                          this.callback = i;
                          var u = function (e, t) {
                              r.response(e, t);
                          };
                          return this.async ? this._apply(e, t, a, u) : u(this._apply(e, t, a));
                      }
                      return this._apply(e, t, a);
                  },
                  _apply: function (e, t, a, i) {
                      return (this.isMissed() ? r : this.fn).apply(this, [e, t, a, i]);
                  },
                  _setValidatingData: function (e, t, a) {
                      (this.attribute = e), (this.inputValue = t), (this.ruleValue = a);
                  },
                  getParameters: function () {
                      var e = [];
                      return "string" == typeof this.ruleValue && (e = this.ruleValue.split(",")), "number" == typeof this.ruleValue && e.push(this.ruleValue), this.ruleValue instanceof Array && (e = this.ruleValue), e;
                  },
                  getSize: function () {
                      var e = this.inputValue;
                      return e instanceof Array ? e.length : "number" == typeof e ? e : this.validator._hasNumericRule(this.attribute) ? parseFloat(e, 10) : e.length;
                  },
                  _getValueType: function () {
                      return "number" == typeof this.inputValue || this.validator._hasNumericRule(this.attribute) ? "numeric" : "string";
                  },
                  response: function (e, t) {
                      (this.passes = void 0 === e || !0 === e), (this._customMessage = t), this.callback(this.passes, t);
                  },
                  setValidator: function (e) {
                      this.validator = e;
                  },
                  isMissed: function () {
                      return "function" != typeof this.fn;
                  },
                  get customMessage() {
                      return this.isMissed() ? a : this._customMessage;
                  },
              };
              var n = {
                  asyncRules: [],
                  implicitRules: ["required", "required_if", "required_unless", "required_with", "required_with_all", "required_without", "required_without_all", "accepted", "present"],
                  make: function (e, t) {
                      var a = this.isAsync(e),
                          r = new u(e, i[e], a);
                      return r.setValidator(t), r;
                  },
                  isAsync: function (e) {
                      for (var t = 0, a = this.asyncRules.length; t < a; t++) if (this.asyncRules[t] === e) return !0;
                      return !1;
                  },
                  isImplicit: function (e) {
                      return this.implicitRules.indexOf(e) > -1;
                  },
                  register: function (e, t) {
                      i[e] = t;
                  },
                  registerImplicit: function (e, t) {
                      this.register(e, t), this.implicitRules.push(e);
                  },
                  registerAsync: function (e, t) {
                      this.register(e, t), this.asyncRules.push(e);
                  },
                  registerAsyncImplicit: function (e, t) {
                      this.registerImplicit(e, t), this.asyncRules.push(e);
                  },
                  registerMissedRuleValidator: function (e, t) {
                      (r = e), (a = t);
                  },
              };
              e.exports = n;
          },
          9449: (e, t, a) => {
              var i = a(1846),
                  r = a(8972),
                  u = a(3995),
                  n = a(6319),
                  o = a(6601),
                  l = function (e, t, a) {
                      var i = l.getDefaultLang();
                      (this.input = e || {}),
                          (this.messages = r._make(i)),
                          this.messages._setCustom(a),
                          this.setAttributeFormatter(l.prototype.attributeFormatter),
                          (this.errors = new u()),
                          (this.errorCount = 0),
                          (this.hasAsync = !1),
                          (this.rules = this._parseRules(t));
                  };
              (l.prototype = {
                  constructor: l,
                  lang: "en",
                  numericRules: ["integer", "numeric"],
                  attributeFormatter: n.formatter,
                  check: function () {
                      for (var e in this.rules) {
                          var t = this.rules[e],
                              a = this._objectPath(this.input, e);
                          if (!this._hasRule(e, ["sometimes"]) || this._suppliedWithData(e))
                              for (
                                  var i, r, u, n = 0, o = t.length;
                                  n < o && ((r = t[n]), (i = this.getRule(r.name)), !this._isValidatable(i, a) || ((u = i.validate(a, r.value, e)) || this._addFailure(i), !this._shouldStopValidating(e, u)));
                                  n++
                              );
                      }
                      return 0 === this.errorCount;
                  },
                  checkAsync: function (e, t) {
                      var a = this;
                      (e = e || function () {}), (t = t || function () {});
                      var i = new o(
                              function (e, t) {
                                  a._addFailure(e, t);
                              },
                              function (a) {
                                  a ? e() : t();
                              }
                          ),
                          r = function (e, t, a, r) {
                              return function () {
                                  var u = i.add(r);
                                  r.validate(e, t.value, a, function () {
                                      i.resolve(u);
                                  });
                              };
                          };
                      for (var u in this.rules) {
                          var n = this.rules[u],
                              l = this._objectPath(this.input, u);
                          if (!this._hasRule(u, ["sometimes"]) || this._suppliedWithData(u)) for (var s, b, m = 0, h = n.length; m < h; m++) (b = n[m]), (s = this.getRule(b.name)), this._isValidatable(s, l) && r(l, b, u, s)();
                      }
                      i.enableFiring(), i.fire();
                  },
                  _addFailure: function (e) {
                      var t = this.messages.render(e);
                      this.errors.add(e.attribute, t), this.errorCount++;
                  },
                  _flattenObject: function (e) {
                      var t = {};
                      return (
                          e &&
                              (function e(a, i) {
                                  if (i || 0 !== Object.getOwnPropertyNames(a).length)
                                      if (Object(a) !== a || Array.isArray(a)) t[i] = a;
                                      else {
                                          var r = !0;
                                          for (var u in a) (r = !1), e(a[u], i ? i + "." + u : u);
                                          r && (t[i] = {});
                                      }
                              })(e),
                          t
                      );
                  },
                  _objectPath: function (e, t) {
                      if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                      var a = t
                              .replace(/\[(\w+)\]/g, ".$1")
                              .replace(/^\./, "")
                              .split("."),
                          i = {};
                      for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (i[r] = e[r]);
                      for (var u = 0, n = a.length; u < n; u++) {
                          if ("object" != typeof i || null === i || !Object.hasOwnProperty.call(i, a[u])) return;
                          i = i[a[u]];
                      }
                      return i;
                  },
                  _parseRules: function (e) {
                      var t = {};
                      for (var a in (e = this._flattenObject(e))) {
                          var i = e[a];
                          this._parseRulesCheck(a, i, t);
                      }
                      return t;
                  },
                  _parseRulesCheck: function (e, t, a, i) {
                      e.indexOf("*") > -1 ? this._parsedRulesRecurse(e, t, a, i) : this._parseRulesDefault(e, t, a, i);
                  },
                  _parsedRulesRecurse: function (e, t, a, i) {
                      var r = e.substr(0, e.indexOf("*") - 1),
                          u = this._objectPath(this.input, r);
                      if (u)
                          for (var n = 0; n < u.length; n++) {
                              var o = i ? i.slice() : [];
                              o.push(n), this._parseRulesCheck(e.replace("*", n), t, a, o);
                          }
                  },
                  _parseRulesDefault: function (e, t, a, r) {
                      var u = [];
                      t instanceof Array && (t = this._prepareRulesArray(t)), "string" == typeof t && (t = t.split("|"));
                      for (var n, o = 0, l = t.length; o < l; o++)
                          (n = "string" == typeof t[o] ? this._extractRuleAndRuleValue(t[o]) : t[o]).value && ((n.value = this._replaceWildCards(n.value, r)), this._replaceWildCardsMessages(r)),
                              i.isAsync(n.name) && (this.hasAsync = !0),
                              u.push(n);
                      a[e] = u;
                  },
                  _replaceWildCards: function (e, t) {
                      if (!t) return e;
                      var a = e;
                      return (
                          t.forEach(function (e) {
                              Array.isArray(a) && (a = a[0]);
                              const t = a.indexOf("*");
                              if (-1 === t) return a;
                              a = a.substr(0, t) + e + a.substr(t + 1);
                          }),
                          Array.isArray(e) && ((e[0] = a), (a = e)),
                          a
                      );
                  },
                  _replaceWildCardsMessages: function (e) {
                      var t = this.messages.customMessages,
                          a = this;
                      Object.keys(t).forEach(function (i) {
                          if (e) {
                              var r = a._replaceWildCards(i, e);
                              t[r] = t[i];
                          }
                      }),
                          this.messages._setCustom(t);
                  },
                  _prepareRulesArray: function (e) {
                      for (var t = [], a = 0, i = e.length; a < i; a++)
                          if ("object" == typeof e[a]) for (var r in e[a]) t.push({ name: r, value: e[a][r] });
                          else t.push(e[a]);
                      return t;
                  },
                  _suppliedWithData: function (e) {
                      return this.input.hasOwnProperty(e);
                  },
                  _extractRuleAndRuleValue: function (e) {
                      var t,
                          a = {};
                      return (a.name = e), e.indexOf(":") >= 0 && ((t = e.split(":")), (a.name = t[0]), (a.value = t.slice(1).join(":"))), a;
                  },
                  _hasRule: function (e, t) {
                      for (var a = this.rules[e] || [], i = 0, r = a.length; i < r; i++) if (t.indexOf(a[i].name) > -1) return !0;
                      return !1;
                  },
                  _hasNumericRule: function (e) {
                      return this._hasRule(e, this.numericRules);
                  },
                  _isValidatable: function (e, t) {
                      return !!Array.isArray(t) || !!i.isImplicit(e.name) || this.getRule("required").validate(t);
                  },
                  _shouldStopValidating: function (e, t) {
                      var a = this.stopOnAttributes;
                      return void 0 !== a && !1 !== a && !0 !== t && (!(a instanceof Array) || a.indexOf(e) > -1);
                  },
                  setAttributeNames: function (e) {
                      this.messages._setAttributeNames(e);
                  },
                  setAttributeFormatter: function (e) {
                      this.messages._setAttributeFormatter(e);
                  },
                  getRule: function (e) {
                      return i.make(e, this);
                  },
                  stopOnError: function (e) {
                      this.stopOnAttributes = e;
                  },
                  passes: function (e) {
                      return this._checkAsync("passes", e) ? this.checkAsync(e) : this.check();
                  },
                  fails: function (e) {
                      return this._checkAsync("fails", e) ? this.checkAsync(function () {}, e) : !this.check();
                  },
                  _checkAsync: function (e, t) {
                      var a = "function" == typeof t;
                      if (this.hasAsync && !a) throw e + " expects a callback when async rules are being tested.";
                      return this.hasAsync || a;
                  },
              }),
                  (l.setMessages = function (e, t) {
                      return r._set(e, t), this;
                  }),
                  (l.getMessages = function (e) {
                      return r._get(e);
                  }),
                  (l.useLang = function (e) {
                      this.prototype.lang = e;
                  }),
                  (l.getDefaultLang = function () {
                      return this.prototype.lang;
                  }),
                  (l.setAttributeFormatter = function (e) {
                      this.prototype.attributeFormatter = e;
                  }),
                  (l.stopOnError = function (e) {
                      this.prototype.stopOnAttributes = e;
                  }),
                  (l.register = function (e, t, a, u) {
                      var n = l.getDefaultLang();
                      i.register(e, t), r._setRuleMessage(n, e, a);
                  }),
                  (l.registerImplicit = function (e, t, a, u) {
                      var n = l.getDefaultLang();
                      i.registerImplicit(e, t), r._setRuleMessage(n, e, a);
                  }),
                  (l.registerAsync = function (e, t, a, u) {
                      var n = l.getDefaultLang();
                      i.registerAsync(e, t), r._setRuleMessage(n, e, a);
                  }),
                  (l.registerAsyncImplicit = function (e, t, a) {
                      var u = l.getDefaultLang();
                      i.registerAsyncImplicit(e, t), r._setRuleMessage(u, e, a);
                  }),
                  (l.registerMissedRuleValidator = function (e, t) {
                      i.registerMissedRuleValidator(e, t);
                  }),
                  (e.exports = l);
          },
      },
      t = {};
  function a(i) {
      var r = t[i];
      if (void 0 !== r) return r.exports;
      var u = (t[i] = { exports: {} });
      return e[i].call(u.exports, u, u.exports, a), u.exports;
  }
  (a.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
      (() => {
          "use strict";
          var e = a(9449),
              t = a(7382);
          const i = document.querySelector("[data-environment]"),
              r = JSON.parse(i.textContent).environment,
              u = { endpoints: { dev: "/apps/api/v1/registrations", prod: "/apps/api/v1/registrations" } },
              n = "is-visible",
              o = {};
          var l, s;
          (l = "section-header"),
              (s = {
                  async onLoad() {
                      this.createElementsObject(),
                          this.initMenu(),
                          this.initUserForms(),
                          this.addBreakpointEventListeners(),
                          (function (a) {
                              const i = new (class {
                                  constructor(a, i) {
                                      (this.options = i),
                                          (this.eventObject = {}),
                                          (this.form = a),
                                          (this.controls = i.multistepControls),
                                          (this.validationRules = i.rules),
                                          (this.fieldsets = a.querySelectorAll("fieldset")),
                                          (this.currentStep = 0),
                                          e.useLang('de'),
                                          e.register(
                                              "telephone_e164",
                                              function (e, i, r) {
                                                  const u = a.querySelector(`[name='${r}']`),
                                                      n = a.querySelector(`[name='${i}']`);
                                                  let o = "";
                                                  n && (o = n.value);
                                                  const l = (0, t.phone)(e, { country: o, validateMobilePrefix: !1 });
                                                  return l.isValid && (u.value = l.phoneNumber), l.isValid;
                                              },
                                              "Die Telefonnummer ist für das ausgewählte Land ungültig"
                                          ),
                                          this.init();
                                  }
                                  init() {
                                      this.options.multistep && this.initSteps(), this.listenForFormSubmission();
                                  }
                                  initSteps() {
                                      (this.controls.submit.style.display = "none"), (this.controls.previous.style.visibility = "hidden");
                                      for (let e = 1; e < this.fieldsets.length; e++) this.fieldsets[e].style.display = "none";
                                      this.controls.next.addEventListener("click", this.onNextStepClick.bind(this)), this.controls.previous.addEventListener("click", this.onPreviousStepClick.bind(this));
                                  }
                                  onNextStepClick() {
                                      this.checkValidationForFieldset(this.fieldsets[this.currentStep]) && this.setStep(this.currentStep + 1);
                                  }
                                  checkValidationForFieldset(e) {
                                      const t = this.validateElementChildren(e);
                                      return !!t.passes() || (this.handleValidationErrors(t.errors.all()), !1);
                                  }
                                  handleValidationErrors(e) {
                                      for (const t in e) {
                                          const a = this.form.querySelector(`[name='${t}']`);
                                          a.setAttribute("aria-invalid", !0);
                                          const i = a.closest("fieldset"),
                                              r = Array.from(this.fieldsets).indexOf(i);
                                          r < this.currentStep && this.setStep(r);
                                          const u = a.nextSibling;
                                          if (1 != u.nodeType || (u && !u.classList.contains("error-message"))) {
                                              const i = document.createElement("span");
                                              i.classList.add("error-message"),
                                                  (i.innerHTML = e[t][0]),
                                                  a.after(i),
                                                  "SELECT" == a.nodeName
                                                      ? a.addEventListener(
                                                            "change",
                                                            () => {
                                                                i.remove(), a.removeAttribute("aria-invalid");
                                                            },
                                                            { once: !0 }
                                                        )
                                                      : a.addEventListener(
                                                            "input",
                                                            () => {
                                                                i.remove(), a.removeAttribute("aria-invalid");
                                                            },
                                                            { once: !0 }
                                                        );
                                          }
                                      }
                                  }
                                  onPreviousStepClick() {
                                      this.setStep(this.currentStep - 1);
                                  }
                                  setStep(e) {
                                      (this.currentStep = e), 0 === this.currentStep ? (this.controls.previous.style.visibility = "hidden") : (this.controls.previous.style.visibility = "visible");
                                      for (let e = 0; e < this.fieldsets.length; e++) e == this.currentStep ? this.fieldsets[e].style.removeProperty("display") : (this.fieldsets[e].style.display = "none");
                                      this.currentStep == this.fieldsets.length - 1
                                          ? ((this.controls.next.style.display = "none"), this.controls.submit.style.removeProperty("display"))
                                          : ((this.controls.submit.style.display = "none"), this.controls.next.style.removeProperty("display"));
                                  }
                                  listenForFormSubmission() {
                                      this.form.addEventListener("submit", (e) => {
                                          this.validateElementChildren(this.form) && this.eventObject.submit && (e.preventDefault(), this.emit("submit"));
                                      });
                                  }
                                  validateElementChildren(t) {
                                      const validator = new e(this.getKeyValues(this.form), this.filterRules(this.getKeyValues(t)));
                                      validator.setAttributeNames({
                                          first_name: 'Vorname',
                                          last_name: 'Nachname',
                                          email: 'E-Mail',
                                          email_confirmation: 'E-Mail-Bestätigung',
                                          company_name: 'Firmenname',
                                          job_role: 'Position',
                                          number_of_employees: 'Anzahl der Mitarbeitenden',
                                          company_site: 'Unternehmenswebsite',
                                          company_registration_no: 'Handelsregisternummer',
                                          tax_registration_id: 'Steueridentifikationsnummer',
                                          shipping_address1: 'Lieferadresse',
                                          shipping_city: 'Lieferort',
                                          shipping_postal_code: 'Liefer-Postleitzahl',
                                          shipping_country: 'Lieferland',
                                          phone: 'Telefon',
                                          billing_address1: 'Rechnungsadresse',
                                          billing_city: 'Rechnungsort',
                                          billing_postal_code: 'Rechnungs-Postleitzahl',
                                          billing_country: 'Rechnungsland',
                                          billing_phone: 'Telefon (Rechnung)'
                                      });
                                      return validator;
                                  }
                                  filterRules(e) {
                                      const t = this.validationRules;
                                      return Object.keys(t).reduce(function (a, i) {
                                          return i in e ? ((a[i] = t[i]), a) : a;
                                      }, {});
                                  }
                                  getKeyValues(e) {
                                      let t = e;
                                      "FORM" != t.tagName && ((t = document.createElement("form")), t.appendChild(e.cloneNode(!0)));
                                      const a = new FormData(t),
                                          i = {};
                                      for (const e of a.entries()) i[e[0]] = e[1];
                                      return i;
                                  }
                                  emit(e) {
                                      const t = this.eventObject[e];
                                      if (t) for (let e of t) e();
                                  }
                                  on(e, t) {
                                      this.eventObject[e] || (this.eventObject[e] = []), this.eventObject[e].push(t);
                                  }
                              })(a, {
                                  multistep: !0,
                                  multistepControls: { next: a.querySelector("[data-next-step]"), previous: a.querySelector("[data-previous-step]"), submit: a.querySelector("[data-submit]") },
                                  rules: {
                                      first_name: "required",
                                      last_name: "required",
                                      email: ["required", "email", "confirmed"],
                                      company_name: "required",
                                      job_role: "required",
                                      number_of_employees: ["required", "numeric"],
                                      company_site: "required",
                                      tax_registration_id: "regex:/^DE\\d{9}$/",
                                      shipping_address1: "required",
                                      shipping_city: "required",
                                      shipping_postal_code: "required",
                                      shipping_country: "required",
                                      phone: ["required", "telephone_e164:shipping_country"],
                                      billing_address1: "required_unless:billing_same_as_shipping,true",
                                      billing_city: "required_unless:billing_same_as_shipping,true",
                                      billing_postal_code: "required_unless:billing_same_as_shipping,true",
                                      billing_country: "required_unless:billing_same_as_shipping,true",
                                      billing_phone: ["required_unless:billing_same_as_shipping,true", "telephone_e164:billing_country"]
                                  },
                              });
                              i.on("submit", async () => {
                                  let e = {};
                                  new FormData(a).forEach(function (t, a) {
                                      e[a] = "accepts_terms_and_conditions" == a || "accepts_email_marketing" == a || "accepts_sms_marketing" == a ? "on" == t : t;
                                  });
                                  if (window.BOOMR && window.BOOMR.shopId) {
                                    (e.shop_id = window.BOOMR.shopId);
                                  } else if (window.ShopifyShopId) {
                                    (e.shop_id = window.ShopifyShopId);
                                  };
                                  let t = JSON.stringify(e);
                                      await fetch(u.endpoints[r], {
                                          method: "POST",
                                          mode: "cors",
                                          cache: "no-cache",
                                          credentials: "same-origin",
                                          headers: { "Content-Type": "application/json" },
                                          redirect: "follow",
                                          referrerPolicy: "no-referrer",
                                          body: t,
                                      })
                                          .then((e) => {
                                              const error_container = document.querySelector('[data-submit-error]');
                                              if (error_container !== null) {
                                                error_container.hidden = true;
                                                let error_msg = error_container.querySelector('#registration_errors');
                                                if (error_msg !== null) {
                                                  error_container.removeChild(error_msg);
                                                }
                                              }
                                              if (e.status !== 201) {
                                                if (e.status === 422) {
                                                  return e.json();
                                                } else {
                                                  if (error_container !== null) {
                                                    error_container.hidden = false;
                                                  }
                                                }
                                              } else {
                                                new window.Toast("Antrag eingereicht").show(),
                                                document.querySelector(".snippet-user-forms").classList.remove("is-visible"),
                                                document.querySelector(".snippet-user-form-overlay").classList.remove("is-visible"),
                                                document.body.classList.remove("overflow-hidden");
                                              }
                                          })
                                          .then((e) => {
                                            const error_container = document.querySelector('[data-submit-error]');
                                            if (error_container !== null) {
                                              const ulEl = document.createElement("ul");
                                              ulEl.setAttribute("id", "registration_errors");
                                              for (const [key, value] of Object.entries(e)) {
                                                var liEl = document.createElement("li");
                                                liEl.textContent = `${key.charAt(0).toUpperCase() + key.slice(1).replace(/[_\[]/g, " ").replace(/]/g, "")} ${value}`;
                                                ulEl.appendChild(liEl);
                                              }
                                              error_container.appendChild(ulEl);
                                              error_container.hidden = false;
                                            }
                                          });
                              });
                              const n = document.getElementById("billing_same_as_shipping"),
                                  o = document.getElementById("billing-fields");
                              n.addEventListener("change", () => {
                                  n.checked ? (o.style.display = "none") : (o.style.display = "flex");
                              });
                          })(document.querySelector("form#registration"));
                  },
                  createElementsObject() {
                      (o.menuContainerElement = this.container.querySelector("[data-menu-container]")),
                          (o.menuOpenElement = this.container.querySelector("[data-menu-open]")),
                          (o.userFormOpenElements = document.querySelectorAll("[data-user-form-open]")),
                          (o.userFormElement = document.querySelector("[data-user-form]")),
                          (o.loginFormWrapperElement = document.querySelector("#login")),
                          (o.registerFormWrapperElement = document.querySelector("#register")),
                          (o.userFormCloseElement = document.querySelector("[data-user-form-close]")),
                          (o.userFormOverlayElement = document.querySelector("[data-user-form-overlay]")),
                          (o.registerFormViewElement = document.querySelector("[data-register-form-view]")),
                          (o.loginFormElement = document.querySelector("[data-login-form]")),
                          (o.recoveryPasswordFormElement = document.querySelector("[data-recovery-password-form]")),
                          (o.loginFormToggleElements = document.querySelectorAll("[data-login-form-toggle]"));
                  },
                  addBreakpointEventListeners() {
                      window.addEventListener("breakpoint-down:lg", this.initMenu.bind(this)), window.addEventListener("breakpoint-up:lg", this.uninitMenu.bind(this));
                  },
                  uninitMenu() {
                      o.menuOpenElement.removeEventListener("click", this.onClickMenuOpen);
                  },
                  initMenu() {
                      !window.matchMedia(`(min-width: ${window.theme.breakpoints.lg}px)`).matches &&
                          o.menuContainerElement &&
                          (o.menuOpenElement && o.menuOpenElement.addEventListener("click", this.onClickMenuOpen), this.initMobileMenu());
                  },
                  initMobileMenu() {
                      o.menuContainerElement
                          .querySelector(".tier-1")
                          .querySelectorAll(".has-dropdown")
                          .forEach((e) => {
                              e.firstElementChild.addEventListener("click", (t) => {
                                  t.preventDefault(), e.querySelector(".dropdown").classList.add(n);
                              }),
                                  e.querySelector(".go-back").addEventListener("click", () => {
                                      e.querySelector(".dropdown").classList.remove(n);
                                  });
                          });
                  },
                  onClickMenuOpen() {
                      o.menuContainerElement.classList.toggle(n),
                          o.menuOpenElement.classList.toggle("is-active"),
                          document.body.classList.toggle("overflow-hidden"),
                          o.menuContainerElement.classList.contains(n) &&
                              o.menuContainerElement
                                  .querySelector(".tier-1")
                                  .querySelectorAll(".has-dropdown")
                                  .forEach((e) => {
                                      e.querySelector(".dropdown").classList.remove(n);
                                  });
                  },
                  initUserForms() {
                      o.userFormOpenElements.forEach((e) => {
                          e.addEventListener("click", () => {
                              const t = e.getAttribute("aria-controls");
                              this.openAuthForm(t);
                          });
                      }),
                          o.loginFormToggleElements.forEach((e) => {
                              e.addEventListener("click", (e) => {
                                  e.preventDefault(),
                                      o.recoveryPasswordFormElement.hasAttribute("hidden")
                                          ? ((o.loginFormElement.hidden = !0), (o.recoveryPasswordFormElement.hidden = !1))
                                          : ((o.loginFormElement.hidden = !1), (o.recoveryPasswordFormElement.hidden = !0));
                              });
                          }),
                          window.location.href.includes("#login") ? this.openAuthForm("login") : window.location.href.includes("#register") && this.openAuthForm("register"),
                          o.userFormCloseElement.addEventListener("click", this.onClickFormClose),
                          o.userFormOverlayElement.addEventListener("click", this.onClickFormClose),
                          o.registerFormViewElement.addEventListener("click", () => {
                              this.openAuthForm("register");
                          });
                  },
                  openAuthForm(e = null) {
                      o.userFormOverlayElement.classList.add(n),
                          document.body.classList.add("overflow-hidden"),
                          o.userFormElement.classList.add(n),
                          "login" == e
                              ? o.loginFormWrapperElement && ((o.registerFormWrapperElement.hidden = !0), (o.loginFormWrapperElement.hidden = !1))
                              : "register" == e && (o.loginFormWrapperElement && (o.loginFormWrapperElement.hidden = !0), (o.registerFormWrapperElement.hidden = !1));
                  },
                  onClickFormClose() {
                      o.userFormOverlayElement.classList.remove(n), o.userFormElement.classList.remove(n), document.body.classList.remove("overflow-hidden");
                  },
              }),
              Shopify.theme.sections && Shopify.theme.sections.register
                  ? (0 === Shopify.theme.sections.getInstances(l).length && Shopify.theme.sections.register(l, s), Shopify.theme.sections.load(l))
                  : (function (e, t) {
                        var a = { name: "section-header", events: t };
                        theme.sections.push(a);
                    })(0, s);
      })();
})();
